{
  "providers": {
    "helicone": {
      "url": "https://ai-gateway.helicone.ai/v1",
      "apiKeyEnvVar": "HELICONE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Helicone",
      "models": [
        "chatgpt-4o-latest",
        "claude-3-haiku-20240307",
        "claude-3.5-haiku",
        "claude-3.5-sonnet-v2",
        "claude-3.7-sonnet",
        "claude-4.5-haiku",
        "claude-4.5-opus",
        "claude-4.5-sonnet",
        "claude-haiku-4-5-20251001",
        "claude-opus-4",
        "claude-opus-4-1",
        "claude-opus-4-1-20250805",
        "claude-sonnet-4",
        "claude-sonnet-4-5-20250929",
        "deepseek-r1-distill-llama-70b",
        "deepseek-reasoner",
        "deepseek-tng-r1t2-chimera",
        "deepseek-v3",
        "deepseek-v3.1-terminus",
        "deepseek-v3.2",
        "ernie-4.5-21b-a3b-thinking",
        "gemini-2.5-flash",
        "gemini-2.5-flash-lite",
        "gemini-2.5-pro",
        "gemini-3-pro-preview",
        "gemma-3-12b-it",
        "gemma2-9b-it",
        "glm-4.6",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-4.1-mini-2025-04-14",
        "gpt-4.1-nano",
        "gpt-4o",
        "gpt-4o-mini",
        "gpt-5",
        "gpt-5-chat-latest",
        "gpt-5-codex",
        "gpt-5-mini",
        "gpt-5-nano",
        "gpt-5-pro",
        "gpt-5.1",
        "gpt-5.1-chat-latest",
        "gpt-5.1-codex",
        "gpt-5.1-codex-mini",
        "gpt-oss-120b",
        "gpt-oss-20b",
        "grok-3",
        "grok-3-mini",
        "grok-4",
        "grok-4-1-fast-non-reasoning",
        "grok-4-1-fast-reasoning",
        "grok-4-fast-non-reasoning",
        "grok-4-fast-reasoning",
        "grok-code-fast-1",
        "hermes-2-pro-llama-3-8b",
        "kimi-k2-0711",
        "kimi-k2-0905",
        "kimi-k2-thinking",
        "llama-3.1-8b-instant",
        "llama-3.1-8b-instruct",
        "llama-3.1-8b-instruct-turbo",
        "llama-3.3-70b-instruct",
        "llama-3.3-70b-versatile",
        "llama-4-maverick",
        "llama-4-scout",
        "llama-guard-4",
        "llama-prompt-guard-2-22m",
        "llama-prompt-guard-2-86m",
        "mistral-large-2411",
        "mistral-nemo",
        "mistral-small",
        "o1",
        "o1-mini",
        "o3",
        "o3-mini",
        "o3-pro",
        "o4-mini",
        "qwen2.5-coder-7b-fast",
        "qwen3-235b-a22b-thinking",
        "qwen3-30b-a3b",
        "qwen3-32b",
        "qwen3-coder",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-next-80b-a3b-instruct",
        "qwen3-vl-235b-a22b-instruct",
        "sonar",
        "sonar-deep-research",
        "sonar-pro",
        "sonar-reasoning",
        "sonar-reasoning-pro"
      ],
      "docUrl": "https://helicone.ai/models",
      "gateway": "models.dev"
    },
    "auriko": {
      "url": "https://api.auriko.ai/v1",
      "apiKeyEnvVar": "AURIKO_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Auriko",
      "models": [
        "claude-opus-4-6",
        "claude-opus-4-7",
        "claude-sonnet-4-6",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "gemini-2.5-flash",
        "gemini-2.5-pro",
        "gemini-3.1-pro-preview",
        "glm-5.1",
        "grok-4.3",
        "kimi-k2.5",
        "kimi-k2.6",
        "minimax-m2-7",
        "minimax-m2-7-highspeed",
        "qwen-3.6-plus"
      ],
      "docUrl": "https://docs.auriko.ai",
      "gateway": "models.dev"
    },
    "firepass": {
      "url": "https://api.fireworks.ai/inference/v1/",
      "apiKeyEnvVar": "FIREPASS_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Fireworks (Firepass)",
      "models": ["accounts/fireworks/routers/kimi-k2p6-turbo"],
      "docUrl": "https://docs.fireworks.ai/firepass",
      "gateway": "models.dev"
    },
    "nano-gpt": {
      "url": "https://nano-gpt.com/api/v1",
      "apiKeyEnvVar": "NANO_GPT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "NanoGPT",
      "models": [
        "Alibaba-NLP/Tongyi-DeepResearch-30B-A3B",
        "Baichuan-M2",
        "Baichuan4-Air",
        "Baichuan4-Turbo",
        "CrucibleLab/L3.3-70B-Loki-V2.0",
        "Doctor-Shotgun/MS3.2-24B-Magnum-Diamond",
        "EVA-UNIT-01/EVA-LLaMA-3.33-70B-v0.0",
        "EVA-UNIT-01/EVA-LLaMA-3.33-70B-v0.1",
        "EVA-UNIT-01/EVA-Qwen2.5-32B-v0.2",
        "EVA-UNIT-01/EVA-Qwen2.5-72B-v0.2",
        "Envoid/Llama-3.05-NT-Storybreaker-Ministral-70B",
        "Envoid/Llama-3.05-Nemotron-Tenyxchat-Storybreaker-70B",
        "GLM-4.5-Air-Derestricted",
        "GLM-4.5-Air-Derestricted-Iceblink",
        "GLM-4.5-Air-Derestricted-Iceblink-ReExtract",
        "GLM-4.5-Air-Derestricted-Iceblink-v2",
        "GLM-4.5-Air-Derestricted-Iceblink-v2-ReExtract",
        "GLM-4.5-Air-Derestricted-Steam",
        "GLM-4.5-Air-Derestricted-Steam-ReExtract",
        "GLM-4.6-Derestricted-v5",
        "GalrionSoftworks/MN-LooseCannon-12B-v1",
        "Gemma-3-27B-ArliAI-RPMax-v3",
        "Gemma-3-27B-Big-Tiger-v3",
        "Gemma-3-27B-CardProjector-v4",
        "Gemma-3-27B-Glitter",
        "Gemma-3-27B-Nidum-Uncensored",
        "Gemma-3-27B-it",
        "Gemma-3-27B-it-Abliterated",
        "Gryphe/MythoMax-L2-13b",
        "Infermatic/MN-12B-Inferor-v0.0",
        "KAT-Coder-Air-V1",
        "KAT-Coder-Exp-72B-1010",
        "KAT-Coder-Pro-V1",
        "LLM360/K2-Think",
        "LatitudeGames/Wayfarer-Large-70B-Llama-3.3",
        "Llama-3.3+(3.1v3.3)-70B-Hanami-x1",
        "Llama-3.3+(3.1v3.3)-70B-New-Dawn-v1.1",
        "Llama-3.3+(3v3.3)-70B-TenyxChat-DaybreakStorywriter",
        "Llama-3.3-70B-Anthrobomination",
        "Llama-3.3-70B-Argunaut-1-SFT",
        "Llama-3.3-70B-ArliAI-RPMax-v1.4",
        "Llama-3.3-70B-ArliAI-RPMax-v2",
        "Llama-3.3-70B-ArliAI-RPMax-v3",
        "Llama-3.3-70B-Aurora-Borealis",
        "Llama-3.3-70B-Bigger-Body",
        "Llama-3.3-70B-Cirrus-x1",
        "Llama-3.3-70B-Cu-Mai-R1",
        "Llama-3.3-70B-Damascus-R1",
        "Llama-3.3-70B-Dark-Ages-v0.1",
        "Llama-3.3-70B-Electra-R1",
        "Llama-3.3-70B-Electranova-v1.0",
        "Llama-3.3-70B-Fallen-R1-v1",
        "Llama-3.3-70B-Fallen-v1",
        "Llama-3.3-70B-Forgotten-Abomination-v5.0",
        "Llama-3.3-70B-Forgotten-Safeword-3.6",
        "Llama-3.3-70B-GeneticLemonade-Opus",
        "Llama-3.3-70B-GeneticLemonade-Unleashed-v3",
        "Llama-3.3-70B-Ignition-v0.1",
        "Llama-3.3-70B-Incandescent-Malevolence",
        "Llama-3.3-70B-Legion-V2.1",
        "Llama-3.3-70B-MS-Nevoria",
        "Llama-3.3-70B-Magnum-v4-SE",
        "Llama-3.3-70B-Magnum-v4-SE-Cirrus-x1-SLERP",
        "Llama-3.3-70B-Mhnnn-x1",
        "Llama-3.3-70B-MiraiFanfare",
        "Llama-3.3-70B-Mokume-Gane-R1",
        "Llama-3.3-70B-Nova",
        "Llama-3.3-70B-Predatorial-Extasy",
        "Llama-3.3-70B-Progenitor-V3.3",
        "Llama-3.3-70B-RAWMAW",
        "Llama-3.3-70B-Sapphira-0.1",
        "Llama-3.3-70B-Sapphira-0.2",
        "Llama-3.3-70B-Shakudo",
        "Llama-3.3-70B-StrawberryLemonade-v1.0",
        "Llama-3.3-70B-Strawberrylemonade-v1.2",
        "Llama-3.3-70B-The-Omega-Directive-Unslop-v2.0",
        "Llama-3.3-70B-The-Omega-Directive-Unslop-v2.1",
        "Llama-3.3-70B-Vulpecula-R1",
        "Magistral-Small-2506",
        "MarinaraSpaghetti/NemoMix-Unleashed-12B",
        "Meta-Llama-3-1-8B-Instruct-FP8",
        "MiniMax-M1",
        "MiniMax-M2",
        "MiniMaxAI/MiniMax-M1-80k",
        "Mistral-Nemo-12B-Instruct-2407",
        "NeverSleep/Llama-3-Lumimaid-70B-v0.1",
        "NeverSleep/Lumimaid-v0.2-70B",
        "NousResearch 2/DeepHermes-3-Mistral-24B-Preview",
        "NousResearch 2/Hermes-4-70B:thinking",
        "NousResearch 2/hermes-3-llama-3.1-70b",
        "NousResearch 2/hermes-4-405b",
        "NousResearch 2/hermes-4-405b:thinking",
        "NousResearch 2/hermes-4-70b",
        "QwQ-32B-ArliAI-RpR-v1",
        "Qwen2.5-32B-EVA-v0.2",
        "ReadyArt/MS3.2-The-Omega-Directive-24B-Unslop-v2.0",
        "ReadyArt/The-Omega-Abomination-L-70B-v1.0",
        "Salesforce/Llama-xLAM-2-70b-fc-r",
        "Sao10K/L3-8B-Stheno-v3.2",
        "Sao10K/L3.1-70B-Euryale-v2.2",
        "Sao10K/L3.1-70B-Hanami-x1",
        "Sao10K/L3.3-70B-Euryale-v2.3",
        "Steelskull/L3.3-Cu-Mai-R1-70b",
        "Steelskull/L3.3-Electra-R1-70b",
        "Steelskull/L3.3-MS-Evalebis-70b",
        "Steelskull/L3.3-MS-Evayale-70B",
        "Steelskull/L3.3-MS-Nevoria-70b",
        "Steelskull/L3.3-Nevoria-R1-70b",
        "TEE/deepseek-r1-0528",
        "TEE/deepseek-v3.1",
        "TEE/deepseek-v3.2",
        "TEE/gemma-3-27b-it",
        "TEE/glm-4.6",
        "TEE/glm-4.7",
        "TEE/glm-4.7-flash",
        "TEE/glm-5",
        "TEE/gpt-oss-120b",
        "TEE/gpt-oss-20b",
        "TEE/kimi-k2-thinking",
        "TEE/kimi-k2.5",
        "TEE/kimi-k2.5-thinking",
        "TEE/llama3-3-70b",
        "TEE/minimax-m2.1",
        "TEE/qwen2.5-vl-72b-instruct",
        "TEE/qwen3-30b-a3b-instruct-2507",
        "TEE/qwen3-coder",
        "TEE/qwen3.5-397b-a17b",
        "THUDM/GLM-4-32B-0414",
        "THUDM/GLM-4-9B-0414",
        "THUDM/GLM-Z1-32B-0414",
        "THUDM/GLM-Z1-9B-0414",
        "THUDM/GLM-Z1-Rumination-32B-0414",
        "TheDrummer 2/Anubis-70B-v1",
        "TheDrummer 2/Anubis-70B-v1.1",
        "TheDrummer 2/Cydonia-24B-v2",
        "TheDrummer 2/Cydonia-24B-v4",
        "TheDrummer 2/Cydonia-24B-v4.1",
        "TheDrummer 2/Cydonia-24B-v4.3",
        "TheDrummer 2/Magidonia-24B-v4.3",
        "TheDrummer 2/Rocinante-12B-v1.1",
        "TheDrummer 2/UnslopNemo-12B-v4.1",
        "TheDrummer 2/skyfall-36b-v2",
        "Tongyi-Zhiwen/QwenLong-L1-32B",
        "VongolaChouko/Starcannon-Unleashed-12B-v1.0",
        "abacusai/Dracarys-72B-Instruct",
        "aion-labs/aion-1.0",
        "aion-labs/aion-1.0-mini",
        "aion-labs/aion-rp-llama-3.1-8b",
        "alibaba/qwen3.6-flash",
        "allenai/molmo-2-8b",
        "allenai/olmo-3-32b-think",
        "allenai/olmo-3.1-32b-instruct",
        "allenai/olmo-3.1-32b-think",
        "amazon/nova-2-lite-v1",
        "amazon/nova-lite-v1",
        "amazon/nova-micro-v1",
        "amazon/nova-pro-v1",
        "anthracite-org/magnum-v2-72b",
        "anthracite-org/magnum-v4-72b",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.6:thinking",
        "anthropic/claude-opus-4.6:thinking:low",
        "anthropic/claude-opus-4.6:thinking:max",
        "anthropic/claude-opus-4.6:thinking:medium",
        "anthropic/claude-sonnet-4.6",
        "anthropic/claude-sonnet-4.6:thinking",
        "arcee-ai/trinity-large",
        "arcee-ai/trinity-mini",
        "asi1-mini",
        "auto-model",
        "auto-model-basic",
        "auto-model-premium",
        "auto-model-standard",
        "azure-gpt-4-turbo",
        "azure-gpt-4o",
        "azure-gpt-4o-mini",
        "azure-o1",
        "azure-o3-mini",
        "baidu/ernie-4.5-300b-a47b",
        "baidu/ernie-4.5-vl-28b-a3b",
        "baseten/Kimi-K2-Instruct-FP4",
        "brave",
        "brave-pro",
        "brave-research",
        "chroma",
        "chutesai/Mistral-Small-3.2-24B-Instruct-2506",
        "claude-3-5-haiku-20241022",
        "claude-3-5-sonnet-20240620",
        "claude-3-5-sonnet-20241022",
        "claude-3-7-sonnet-20250219",
        "claude-3-7-sonnet-reasoner",
        "claude-3-7-sonnet-thinking",
        "claude-3-7-sonnet-thinking:1024",
        "claude-3-7-sonnet-thinking:128000",
        "claude-3-7-sonnet-thinking:32768",
        "claude-3-7-sonnet-thinking:8192",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-1-20250805",
        "claude-opus-4-1-thinking",
        "claude-opus-4-1-thinking:1024",
        "claude-opus-4-1-thinking:32000",
        "claude-opus-4-1-thinking:32768",
        "claude-opus-4-1-thinking:8192",
        "claude-opus-4-20250514",
        "claude-opus-4-5-20251101",
        "claude-opus-4-5-20251101:thinking",
        "claude-opus-4-thinking",
        "claude-opus-4-thinking:1024",
        "claude-opus-4-thinking:32000",
        "claude-opus-4-thinking:32768",
        "claude-opus-4-thinking:8192",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5-20250929",
        "claude-sonnet-4-5-20250929-thinking",
        "claude-sonnet-4-thinking",
        "claude-sonnet-4-thinking:1024",
        "claude-sonnet-4-thinking:32768",
        "claude-sonnet-4-thinking:64000",
        "claude-sonnet-4-thinking:8192",
        "cognitivecomputations/dolphin-2.9.2-qwen2-72b",
        "cohere/command-r",
        "cohere/command-r-plus-08-2024",
        "command-a-reasoning-08-2025",
        "deepclaude",
        "deepcogito/cogito-v1-preview-qwen-32B",
        "deepcogito/cogito-v2.1-671b",
        "deepseek-ai/DeepSeek-R1-0528",
        "deepseek-ai/DeepSeek-V3.1",
        "deepseek-ai/DeepSeek-V3.1-Terminus",
        "deepseek-ai/DeepSeek-V3.1-Terminus:thinking",
        "deepseek-ai/DeepSeek-V3.1:thinking",
        "deepseek-ai/deepseek-v3.2-exp",
        "deepseek-ai/deepseek-v3.2-exp-thinking",
        "deepseek-chat",
        "deepseek-chat-cheaper",
        "deepseek-math-v2",
        "deepseek-r1",
        "deepseek-r1-sambanova",
        "deepseek-reasoner",
        "deepseek-reasoner-cheaper",
        "deepseek-v3-0324",
        "deepseek/deepseek-prover-v2-671b",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-speciale",
        "deepseek/deepseek-v3.2:thinking",
        "dmind/dmind-1",
        "dmind/dmind-1-mini",
        "doubao-1-5-thinking-pro-250415",
        "doubao-1-5-thinking-pro-vision-250415",
        "doubao-1-5-thinking-vision-pro-250428",
        "doubao-1.5-pro-256k",
        "doubao-1.5-pro-32k",
        "doubao-1.5-vision-pro-32k",
        "doubao-seed-1-6-250615",
        "doubao-seed-1-6-flash-250615",
        "doubao-seed-1-6-thinking-250615",
        "doubao-seed-1-8-251215",
        "doubao-seed-2-0-code-preview-260215",
        "doubao-seed-2-0-lite-260215",
        "doubao-seed-2-0-mini-260215",
        "doubao-seed-2-0-pro-260215",
        "doubao-seed-code-preview-latest",
        "ernie-4.5-8k-preview",
        "ernie-4.5-turbo-128k",
        "ernie-4.5-turbo-vl-32k",
        "ernie-5.0-thinking-latest",
        "ernie-5.0-thinking-preview",
        "ernie-x1-32k",
        "ernie-x1-32k-preview",
        "ernie-x1-turbo-32k",
        "ernie-x1.1-preview",
        "essentialai/rnj-1-instruct",
        "exa-answer",
        "exa-research",
        "exa-research-pro",
        "failspy/Meta-Llama-3-70B-Instruct-abliterated-v3.5",
        "fastgpt",
        "featherless-ai/Qwerky-72B",
        "gemini-2.0-flash-001",
        "gemini-2.0-flash-exp-image-generation",
        "gemini-2.0-flash-lite",
        "gemini-2.0-flash-thinking-exp-01-21",
        "gemini-2.0-flash-thinking-exp-1219",
        "gemini-2.0-pro-exp-02-05",
        "gemini-2.0-pro-reasoner",
        "gemini-2.5-flash",
        "gemini-2.5-flash-lite",
        "gemini-2.5-flash-lite-preview-06-17",
        "gemini-2.5-flash-lite-preview-09-2025",
        "gemini-2.5-flash-lite-preview-09-2025-thinking",
        "gemini-2.5-flash-nothinking",
        "gemini-2.5-flash-preview-04-17",
        "gemini-2.5-flash-preview-04-17:thinking",
        "gemini-2.5-flash-preview-05-20",
        "gemini-2.5-flash-preview-05-20:thinking",
        "gemini-2.5-flash-preview-09-2025",
        "gemini-2.5-flash-preview-09-2025-thinking",
        "gemini-2.5-pro",
        "gemini-2.5-pro-exp-03-25",
        "gemini-2.5-pro-preview-03-25",
        "gemini-2.5-pro-preview-05-06",
        "gemini-2.5-pro-preview-06-05",
        "gemini-3-pro-image-preview",
        "gemini-3-pro-preview",
        "gemini-3-pro-preview-thinking",
        "gemini-exp-1206",
        "glm-4",
        "glm-4-air",
        "glm-4-air-0111",
        "glm-4-airx",
        "glm-4-flash",
        "glm-4-long",
        "glm-4-plus",
        "glm-4-plus-0111",
        "glm-4.1v-thinking-flash",
        "glm-4.1v-thinking-flashx",
        "glm-z1-air",
        "glm-z1-airx",
        "glm-zero-preview",
        "google/gemini-3-flash-preview",
        "google/gemini-3-flash-preview-thinking",
        "google/gemini-flash-1.5",
        "grok-3-beta",
        "grok-3-fast-beta",
        "grok-3-mini-beta",
        "grok-3-mini-fast-beta",
        "hidream",
        "huihui-ai/DeepSeek-R1-Distill-Llama-70B-abliterated",
        "huihui-ai/DeepSeek-R1-Distill-Qwen-32B-abliterated",
        "huihui-ai/Llama-3.1-Nemotron-70B-Instruct-HF-abliterated",
        "huihui-ai/Llama-3.3-70B-Instruct-abliterated",
        "huihui-ai/Qwen2.5-32B-Instruct-abliterated",
        "hunyuan-t1-latest",
        "hunyuan-turbos-20250226",
        "inflatebot/MN-12B-Mag-Mell-R1",
        "inflection/inflection-3-pi",
        "inflection/inflection-3-productivity",
        "jamba-large",
        "jamba-large-1.6",
        "jamba-large-1.7",
        "jamba-mini",
        "jamba-mini-1.6",
        "jamba-mini-1.7",
        "kimi-k2-instruct-fast",
        "kimi-thinking-preview",
        "learnlm-1.5-pro-experimental",
        "meganova-ai/manta-flash-1.0",
        "meganova-ai/manta-mini-1.0",
        "meganova-ai/manta-pro-1.0",
        "meituan-longcat/LongCat-Flash-Chat-FP8",
        "meta-llama/llama-3.1-8b-instruct",
        "meta-llama/llama-3.2-3b-instruct",
        "meta-llama/llama-3.2-90b-vision-instruct",
        "meta-llama/llama-3.3-70b-instruct",
        "meta-llama/llama-4-maverick",
        "meta-llama/llama-4-scout",
        "microsoft/MAI-DS-R1-FP8",
        "microsoft/wizardlm-2-8x22b",
        "minimax/minimax-01",
        "minimax/minimax-m2-her",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.7",
        "miromind-ai/mirothinker-v1.5-235b",
        "mistral-small-31-24b-instruct",
        "mistralai/Devstral-Small-2505",
        "mistralai/Mistral-Nemo-Instruct-2407",
        "mistralai/codestral-2508",
        "mistralai/devstral-2-123b-instruct-2512",
        "mistralai/ministral-14b-2512",
        "mistralai/ministral-14b-instruct-2512",
        "mistralai/ministral-3b-2512",
        "mistralai/ministral-8b-2512",
        "mistralai/mistral-7b-instruct",
        "mistralai/mistral-large",
        "mistralai/mistral-large-3-675b-instruct-2512",
        "mistralai/mistral-medium-3",
        "mistralai/mistral-medium-3.1",
        "mistralai/mistral-saba",
        "mistralai/mistral-small-creative",
        "mistralai/mistral-tiny",
        "mistralai/mixtral-8x22b-instruct-v0.1",
        "mistralai/mixtral-8x7b-instruct-v0.1",
        "mlabonne/NeuralDaredevil-8B-abliterated",
        "moonshotai/Kimi-Dev-72B",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/kimi-k2-instruct",
        "moonshotai/kimi-k2-instruct-0711",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2-thinking-original",
        "moonshotai/kimi-k2-thinking-turbo-original",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.5:thinking",
        "moonshotai/kimi-k2.6",
        "moonshotai/kimi-k2.6:thinking",
        "nex-agi/deepseek-v3.1-nex-n1",
        "nothingiisreal/L3.1-70B-Celeste-V0.1-BF16",
        "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
        "nvidia/Llama-3.1-Nemotron-Ultra-253B-v1",
        "nvidia/Llama-3.3-Nemotron-Super-49B-v1",
        "nvidia/Llama-3_3-Nemotron-Super-49B-v1_5",
        "nvidia/nemotron-3-nano-30b-a3b",
        "nvidia/nvidia-nemotron-nano-9b-v2",
        "openai/chatgpt-4o-latest",
        "openai/gpt-3.5-turbo",
        "openai/gpt-4-turbo",
        "openai/gpt-4-turbo-preview",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-2024-08-06",
        "openai/gpt-4o-2024-11-20",
        "openai/gpt-4o-mini",
        "openai/gpt-4o-mini-search-preview",
        "openai/gpt-4o-search-preview",
        "openai/gpt-5",
        "openai/gpt-5-chat-latest",
        "openai/gpt-5-codex",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-2025-11-13",
        "openai/gpt-5.1-chat",
        "openai/gpt-5.1-chat-latest",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "openai/gpt-oss-safeguard-20b",
        "openai/o1",
        "openai/o1-preview",
        "openai/o1-pro",
        "openai/o3",
        "openai/o3-deep-research",
        "openai/o3-mini",
        "openai/o3-mini-high",
        "openai/o3-mini-low",
        "openai/o3-pro-2025-06-10",
        "openai/o4-mini",
        "openai/o4-mini-deep-research",
        "openai/o4-mini-high",
        "pamanseau/OpenReasoning-Nemotron-32B",
        "phi-4-mini-instruct",
        "phi-4-multimodal-instruct",
        "qvq-max",
        "qwen-3.6-plus",
        "qwen-image",
        "qwen-long",
        "qwen-max",
        "qwen-plus",
        "qwen-turbo",
        "qwen/Qwen3.6-35B-A3B",
        "qwen/Qwen3.6-35B-A3B:thinking",
        "qwen/qwen3.5-397b-a17b",
        "qwen25-vl-72b-instruct",
        "qwen3-30b-a3b-instruct-2507",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-max-2026-01-23",
        "qwen3-vl-235b-a22b-instruct-original",
        "qwen3-vl-235b-a22b-thinking",
        "qwen3.6-max-preview",
        "qwq-32b",
        "raifle/sorcererlm-8x22b",
        "sarvan-medium",
        "shisa-ai/shisa-v2-llama3.3-70b",
        "shisa-ai/shisa-v2.1-llama3.3-70b",
        "sonar",
        "sonar-deep-research",
        "sonar-pro",
        "sonar-reasoning-pro",
        "soob3123/GrayLine-Qwen3-8B",
        "soob3123/Veiled-Calla-12B",
        "soob3123/amoral-gemma3-27B-v2",
        "step-2-16k-exp",
        "step-2-mini",
        "step-3",
        "step-r1-v-mini",
        "stepfun-ai/step-3.5-flash",
        "stepfun-ai/step-3.5-flash:thinking",
        "study_gpt-chatgpt-4o-latest",
        "tencent/Hunyuan-MT-7B",
        "tngtech/DeepSeek-TNG-R1T2-Chimera",
        "tngtech/tng-r1t-chimera",
        "undi95/remm-slerp-l2-13b",
        "universal-summarizer",
        "unsloth/gemma-3-12b-it",
        "unsloth/gemma-3-1b-it",
        "unsloth/gemma-3-27b-it",
        "unsloth/gemma-3-4b-it",
        "v0-1.0-md",
        "v0-1.5-lg",
        "v0-1.5-md",
        "venice-uncensored",
        "venice-uncensored:web",
        "x-ai/grok-4-07-09",
        "x-ai/grok-4-fast",
        "x-ai/grok-4-fast:thinking",
        "x-ai/grok-4.1-fast",
        "x-ai/grok-4.1-fast-reasoning",
        "x-ai/grok-code-fast-1",
        "xiaomi/mimo-v2-flash",
        "xiaomi/mimo-v2-flash-original",
        "xiaomi/mimo-v2-flash-thinking",
        "xiaomi/mimo-v2-flash-thinking-original",
        "yi-large",
        "yi-lightning",
        "yi-medium-200k",
        "z-ai/glm-4.5v",
        "z-ai/glm-4.5v:thinking",
        "z-ai/glm-4.6",
        "z-ai/glm-4.6:thinking",
        "z-image-turbo",
        "zai-org/glm-4.7",
        "zai-org/glm-4.7-flash",
        "zai-org/glm-5",
        "zai-org/glm-5.1",
        "zai-org/glm-5.1:thinking",
        "zai-org/glm-5:thinking"
      ],
      "docUrl": "https://docs.nano-gpt.com",
      "gateway": "models.dev"
    },
    "io-net": {
      "url": "https://api.intelligence.io.solutions/api/v1",
      "apiKeyEnvVar": "IOINTELLIGENCE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "IO.NET",
      "models": [
        "Intel/Qwen3-Coder-480B-A35B-Instruct-int4-mixed-ar",
        "Qwen/Qwen2.5-VL-32B-Instruct",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-Next-80B-A3B-Instruct",
        "deepseek-ai/DeepSeek-R1-0528",
        "meta-llama/Llama-3.2-90B-Vision-Instruct",
        "meta-llama/Llama-3.3-70B-Instruct",
        "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
        "mistralai/Devstral-Small-2505",
        "mistralai/Magistral-Small-2506",
        "mistralai/Mistral-Large-Instruct-2411",
        "mistralai/Mistral-Nemo-Instruct-2407",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/Kimi-K2-Thinking",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "zai-org/GLM-4.6"
      ],
      "docUrl": "https://io.net/docs/guides/intelligence/io-intelligence",
      "gateway": "models.dev"
    },
    "inception": {
      "url": "https://api.inceptionlabs.ai/v1/",
      "apiKeyEnvVar": "INCEPTION_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Inception",
      "models": ["mercury-2", "mercury-edit-2"],
      "docUrl": "https://platform.inceptionlabs.ai/docs",
      "gateway": "models.dev"
    },
    "submodel": {
      "url": "https://llm.submodel.ai/v1",
      "apiKeyEnvVar": "SUBMODEL_INSTAGEN_ACCESS_KEY",
      "apiKeyHeader": "Authorization",
      "name": "submodel",
      "models": [
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
        "deepseek-ai/DeepSeek-R1-0528",
        "deepseek-ai/DeepSeek-V3-0324",
        "deepseek-ai/DeepSeek-V3.1",
        "openai/gpt-oss-120b",
        "zai-org/GLM-4.5-Air",
        "zai-org/GLM-4.5-FP8"
      ],
      "docUrl": "https://submodel.gitbook.io",
      "gateway": "models.dev"
    },
    "requesty": {
      "url": "https://router.requesty.ai/v1",
      "apiKeyEnvVar": "REQUESTY_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Requesty",
      "models": [
        "anthropic/claude-3-7-sonnet",
        "anthropic/claude-haiku-4-5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4-1",
        "anthropic/claude-opus-4-5",
        "anthropic/claude-opus-4-6",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4-5",
        "anthropic/claude-sonnet-4-6",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash-preview",
        "google/gemini-3-pro-preview",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4o-mini",
        "openai/gpt-5",
        "openai/gpt-5-chat",
        "openai/gpt-5-codex",
        "openai/gpt-5-image",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-chat",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-pro",
        "openai/o4-mini",
        "xai/grok-4",
        "xai/grok-4-fast"
      ],
      "docUrl": "https://requesty.ai/solution/llm-routing/models",
      "gateway": "models.dev"
    },
    "zai": {
      "url": "https://api.z.ai/api/paas/v4",
      "apiKeyEnvVar": "ZHIPU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Z.AI",
      "models": [
        "glm-4.5",
        "glm-4.5-air",
        "glm-4.5-flash",
        "glm-4.5v",
        "glm-4.6",
        "glm-4.6v",
        "glm-4.7",
        "glm-4.7-flash",
        "glm-4.7-flashx",
        "glm-5",
        "glm-5-turbo",
        "glm-5.1",
        "glm-5v-turbo"
      ],
      "docUrl": "https://docs.z.ai/guides/overview/pricing",
      "gateway": "models.dev"
    },
    "zai-coding-plan": {
      "url": "https://api.z.ai/api/coding/paas/v4",
      "apiKeyEnvVar": "ZHIPU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Z.AI Coding Plan",
      "models": ["glm-4.5-air", "glm-4.7", "glm-5-turbo", "glm-5.1", "glm-5v-turbo"],
      "docUrl": "https://docs.z.ai/devpack/overview",
      "gateway": "models.dev"
    },
    "deepinfra": {
      "apiKeyEnvVar": "DEEPINFRA_API_KEY",
      "name": "Deep Infra",
      "models": [
        "MiniMaxAI/MiniMax-M2",
        "MiniMaxAI/MiniMax-M2.1",
        "MiniMaxAI/MiniMax-M2.5",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-Turbo",
        "Qwen/Qwen3.5-35B-A3B",
        "Qwen/Qwen3.5-397B-A17B",
        "Qwen/Qwen3.6-35B-A3B",
        "anthropic/claude-3-7-sonnet-latest",
        "anthropic/claude-4-opus",
        "deepseek-ai/DeepSeek-R1-0528",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/DeepSeek-V4-Flash",
        "deepseek-ai/DeepSeek-V4-Pro",
        "google/gemma-4-26B-A4B-it",
        "google/gemma-4-31B-it",
        "meta-llama/Llama-3.1-70B-Instruct",
        "meta-llama/Llama-3.1-70B-Instruct-Turbo",
        "meta-llama/Llama-3.1-8B-Instruct",
        "meta-llama/Llama-3.1-8B-Instruct-Turbo",
        "meta-llama/Llama-3.3-70B-Instruct-Turbo",
        "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
        "meta-llama/Llama-4-Scout-17B-16E-Instruct",
        "moonshotai/Kimi-K2-Instruct",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/Kimi-K2-Thinking",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "xiaomi/mimo-v2.5",
        "xiaomi/mimo-v2.5-pro",
        "zai-org/GLM-4.6",
        "zai-org/GLM-4.6V",
        "zai-org/GLM-4.7",
        "zai-org/GLM-4.7-Flash",
        "zai-org/GLM-5",
        "zai-org/GLM-5.1"
      ],
      "docUrl": "https://deepinfra.com/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/deepinfra"
    },
    "clarifai": {
      "url": "https://api.clarifai.com/v2/ext/openai/v1",
      "apiKeyEnvVar": "CLARIFAI_PAT",
      "apiKeyHeader": "Authorization",
      "name": "Clarifai",
      "models": [
        "arcee_ai/AFM/models/trinity-mini",
        "clarifai/main/models/mm-poly-8b",
        "deepseek-ai/deepseek-ocr/models/DeepSeek-OCR",
        "minimaxai/chat-completion/models/MiniMax-M2_5-high-throughput",
        "mistralai/completion/models/Ministral-3-14B-Reasoning-2512",
        "mistralai/completion/models/Ministral-3-3B-Reasoning-2512",
        "moonshotai/chat-completion/models/Kimi-K2_6",
        "openai/chat-completion/models/gpt-oss-120b-high-throughput",
        "openai/chat-completion/models/gpt-oss-20b",
        "qwen/qwenCoder/models/Qwen3-Coder-30B-A3B-Instruct",
        "qwen/qwenLM/models/Qwen3-30B-A3B-Instruct-2507",
        "qwen/qwenLM/models/Qwen3-30B-A3B-Thinking-2507"
      ],
      "docUrl": "https://docs.clarifai.com/compute/inference/",
      "gateway": "models.dev"
    },
    "moark": {
      "url": "https://moark.com/v1",
      "apiKeyEnvVar": "MOARK_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Moark",
      "models": ["GLM-4.7", "MiniMax-M2.1"],
      "docUrl": "https://moark.com/docs/openapi/v1#tag/%E6%96%87%E6%9C%AC%E7%94%9F%E6%88%90",
      "gateway": "models.dev"
    },
    "frogbot": {
      "url": "https://app.frogbot.ai/api/v1",
      "apiKeyEnvVar": "FROGBOT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "FrogBot",
      "models": [
        "claude-haiku-4-5",
        "claude-opus-4-6",
        "claude-opus-4-7",
        "claude-sonnet-4-6",
        "deepseek-v4-pro",
        "gemini-2.5-flash",
        "gemini-2.5-pro",
        "gemini-3-1-pro-preview",
        "gemini-3-flash-preview",
        "gpt-4o",
        "gpt-5-3-codex",
        "gpt-5-4-mini",
        "gpt-5-4-nano",
        "gpt-5-5",
        "gpt-oss-120b",
        "gpt-oss-20b",
        "grok-4-1-fast-non-reasoning",
        "grok-4-1-fast-reasoning",
        "grok-4-3",
        "grok-code-fast-1",
        "kimi-k2-6",
        "kimi-k2.5",
        "minimax-m2-5",
        "minimax-m2-7",
        "qwen-3-6-plus",
        "zai-glm-5-1"
      ],
      "docUrl": "https://docs.frogbot.ai",
      "gateway": "models.dev"
    },
    "wandb": {
      "url": "https://api.inference.wandb.ai/v1",
      "apiKeyEnvVar": "WANDB_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Weights & Biases",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "OpenPipe/Qwen3-14B-Instruct",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "deepseek-ai/DeepSeek-V3.1",
        "meta-llama/Llama-3.1-70B-Instruct",
        "meta-llama/Llama-3.1-8B-Instruct",
        "meta-llama/Llama-3.3-70B-Instruct",
        "meta-llama/Llama-4-Scout-17B-16E-Instruct",
        "microsoft/Phi-4-mini-instruct",
        "moonshotai/Kimi-K2.5",
        "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-FP8",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "zai-org/GLM-5-FP8",
        "zai-org/GLM-5.1"
      ],
      "docUrl": "https://docs.wandb.ai/guides/integrations/inference/",
      "gateway": "models.dev"
    },
    "gmicloud": {
      "url": "https://api.gmi-serving.com/v1",
      "apiKeyEnvVar": "GMICLOUD_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "GMI Cloud",
      "models": [
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-sonnet-4.6",
        "deepseek-ai/DeepSeek-V4-Flash",
        "deepseek-ai/DeepSeek-V4-Pro",
        "moonshotai/Kimi-K2.6",
        "zai-org/GLM-5-FP8",
        "zai-org/GLM-5.1-FP8"
      ],
      "docUrl": "https://docs.gmicloud.ai/inference-engine/api-reference/llm-api-reference",
      "gateway": "models.dev"
    },
    "crof": {
      "url": "https://crof.ai/v1",
      "apiKeyEnvVar": "CROF_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "CrofAI",
      "models": [
        "deepseek-v3.2",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "deepseek-v4-pro-precision",
        "gemma-4-31b-it",
        "glm-4.7",
        "glm-4.7-flash",
        "glm-5",
        "glm-5.1",
        "glm-5.1-precision",
        "greg",
        "kimi-k2.5",
        "kimi-k2.5-lightning",
        "kimi-k2.6",
        "kimi-k2.6-precision",
        "mimo-v2.5-pro",
        "mimo-v2.5-pro-precision",
        "minimax-m2.5",
        "qwen3.5-397b-a17b",
        "qwen3.5-9b",
        "qwen3.6-27b"
      ],
      "docUrl": "https://crof.ai/docs",
      "gateway": "models.dev"
    },
    "ambient": {
      "url": "https://api.ambient.xyz/v1",
      "apiKeyEnvVar": "AMBIENT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Ambient",
      "models": ["moonshotai/kimi-k2.6", "zai-org/GLM-5.1-FP8"],
      "docUrl": "https://ambient.xyz",
      "gateway": "models.dev"
    },
    "routing-run": {
      "url": "https://api.routing.run/v1",
      "apiKeyEnvVar": "ROUTING_RUN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "routing.run",
      "models": [
        "route/deepseek-v3.2",
        "route/deepseek-v4-flash",
        "route/deepseek-v4-flash-6bit",
        "route/deepseek-v4-pro",
        "route/deepseek-v4-pro-6bit",
        "route/gemma-4-31b-it",
        "route/glm-5.1",
        "route/glm-5.1-6bit",
        "route/kimi-k2.5",
        "route/kimi-k2.6",
        "route/kimi-k2.6-6bit",
        "route/mimo-v2.5-pro",
        "route/mimo-v2.5-pro-6bit",
        "route/minimax-m2.5",
        "route/minimax-m2.5-highspeed",
        "route/minimax-m2.7",
        "route/minimax-m2.7-highspeed",
        "route/mistral-large-3",
        "route/mistral-medium-2505",
        "route/mistral-small-2503",
        "route/qwen3.6-27b",
        "route/step-3.5-flash",
        "route/step-3.5-flash-2603",
        "route/stepfun-3.5-flash"
      ],
      "docUrl": "https://docs.routing.run/api-reference/models",
      "gateway": "models.dev"
    },
    "the-grid-ai": {
      "url": "https://api.thegrid.ai/v1",
      "apiKeyEnvVar": "THEGRIDAI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "The Grid AI",
      "models": [
        "agent-max",
        "agent-prime",
        "agent-standard",
        "code-max",
        "code-prime",
        "code-standard",
        "text-max",
        "text-prime",
        "text-standard"
      ],
      "docUrl": "https://thegrid.ai/docs",
      "gateway": "models.dev"
    },
    "fastrouter": {
      "url": "https://go.fastrouter.ai/api/v1",
      "apiKeyEnvVar": "FASTROUTER_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "FastRouter",
      "models": [
        "anthropic/claude-opus-4.1",
        "anthropic/claude-sonnet-4",
        "deepseek-ai/deepseek-r1-distill-llama-70b",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-pro",
        "moonshotai/kimi-k2",
        "openai/gpt-4.1",
        "openai/gpt-5",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "qwen/qwen3-coder",
        "x-ai/grok-4",
        "z-ai/glm-5"
      ],
      "docUrl": "https://fastrouter.ai/models",
      "gateway": "models.dev"
    },
    "tencent-coding-plan": {
      "url": "https://api.lkeap.cloud.tencent.com/coding/v3",
      "apiKeyEnvVar": "TENCENT_CODING_PLAN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Tencent Coding Plan (China)",
      "models": [
        "glm-5",
        "hunyuan-2.0-instruct",
        "hunyuan-2.0-thinking",
        "hunyuan-t1",
        "hunyuan-turbos",
        "kimi-k2.5",
        "minimax-m2.5",
        "tc-code-latest"
      ],
      "docUrl": "https://cloud.tencent.com/document/product/1772/128947",
      "gateway": "models.dev"
    },
    "cortecs": {
      "url": "https://api.cortecs.ai/v1",
      "apiKeyEnvVar": "CORTECS_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Cortecs",
      "models": [
        "claude-4-5-sonnet",
        "claude-4-6-sonnet",
        "claude-haiku-4-5",
        "claude-opus4-5",
        "claude-opus4-6",
        "claude-opus4-7",
        "claude-sonnet-4",
        "codestral-2508",
        "deepseek-r1-0528",
        "deepseek-v3-0324",
        "deepseek-v3.2",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "devstral-2512",
        "devstral-small-2512",
        "gemini-2.5-pro",
        "glm-4.5",
        "glm-4.5-air",
        "glm-4.7",
        "glm-4.7-flash",
        "glm-5",
        "glm-5.1",
        "gpt-4.1",
        "gpt-oss-120b",
        "hermes-4-70b",
        "intellect-3",
        "kimi-k2-instruct",
        "kimi-k2-thinking",
        "kimi-k2.5",
        "kimi-k2.6",
        "llama-3.1-405b-instruct",
        "llama-3.3-70b-instruct",
        "minimax-m2",
        "minimax-m2.1",
        "minimax-m2.5",
        "minimax-m2.7",
        "mistral-large-2512",
        "mixtral-8x7B-instruct-v0.1",
        "nemotron-3-super-120b-a12b",
        "nova-pro-v1",
        "qwen-2.5-72b-instruct",
        "qwen3-235b-a22b-instruct-2507",
        "qwen3-32b",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-coder-next",
        "qwen3-next-80b-a3b-thinking",
        "qwen3.5-122b-a10b",
        "qwen3.5-397b-a17b"
      ],
      "docUrl": "https://api.cortecs.ai/v1/models",
      "gateway": "models.dev"
    },
    "baseten": {
      "url": "https://inference.baseten.co/v1",
      "apiKeyEnvVar": "BASETEN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Baseten",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "deepseek-ai/DeepSeek-V3-0324",
        "deepseek-ai/DeepSeek-V3.1",
        "deepseek-ai/DeepSeek-V4-Pro",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "nvidia/Nemotron-120B-A12B",
        "openai/gpt-oss-120b",
        "zai-org/GLM-4.6",
        "zai-org/GLM-4.7",
        "zai-org/GLM-5"
      ],
      "docUrl": "https://docs.baseten.co/development/model-apis/overview",
      "gateway": "models.dev"
    },
    "llama": {
      "url": "https://api.llama.com/compat/v1/",
      "apiKeyEnvVar": "LLAMA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Llama",
      "models": [
        "cerebras-llama-4-maverick-17b-128e-instruct",
        "cerebras-llama-4-scout-17b-16e-instruct",
        "groq-llama-4-maverick-17b-128e-instruct",
        "llama-3.3-70b-instruct",
        "llama-3.3-8b-instruct",
        "llama-4-maverick-17b-128e-instruct-fp8",
        "llama-4-scout-17b-16e-instruct-fp8"
      ],
      "docUrl": "https://llama.developer.meta.com/docs/models",
      "gateway": "models.dev"
    },
    "novita-ai": {
      "url": "https://api.novita.ai/openai",
      "apiKeyEnvVar": "NOVITA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "NovitaAI",
      "models": [
        "baichuan/baichuan-m2-32b",
        "baidu/ernie-4.5-21B-a3b",
        "baidu/ernie-4.5-21B-a3b-thinking",
        "baidu/ernie-4.5-300b-a47b-paddle",
        "baidu/ernie-4.5-vl-28b-a3b",
        "baidu/ernie-4.5-vl-28b-a3b-thinking",
        "baidu/ernie-4.5-vl-424b-a47b",
        "deepseek/deepseek-ocr",
        "deepseek/deepseek-ocr-2",
        "deepseek/deepseek-prover-v2-671b",
        "deepseek/deepseek-r1-0528",
        "deepseek/deepseek-r1-0528-qwen3-8b",
        "deepseek/deepseek-r1-distill-llama-70b",
        "deepseek/deepseek-r1-distill-qwen-14b",
        "deepseek/deepseek-r1-distill-qwen-32b",
        "deepseek/deepseek-r1-turbo",
        "deepseek/deepseek-v3-0324",
        "deepseek/deepseek-v3-turbo",
        "deepseek/deepseek-v3.1",
        "deepseek/deepseek-v3.1-terminus",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-pro",
        "google/gemma-3-12b-it",
        "google/gemma-3-27b-it",
        "google/gemma-4-26b-a4b-it",
        "google/gemma-4-31b-it",
        "gryphe/mythomax-l2-13b",
        "inclusionai/ling-2.6-1t",
        "inclusionai/ling-2.6-flash",
        "kwaipilot/kat-coder-pro",
        "meta-llama/llama-3-70b-instruct",
        "meta-llama/llama-3-8b-instruct",
        "meta-llama/llama-3.1-8b-instruct",
        "meta-llama/llama-3.2-3b-instruct",
        "meta-llama/llama-3.3-70b-instruct",
        "meta-llama/llama-4-maverick-17b-128e-instruct-fp8",
        "meta-llama/llama-4-scout-17b-16e-instruct",
        "microsoft/wizardlm-2-8x22b",
        "minimax/minimax-m2",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5-highspeed",
        "minimax/minimax-m2.7",
        "minimaxai/minimax-m1-80k",
        "mistralai/mistral-nemo",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-instruct",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.6",
        "nousresearch/hermes-2-pro-llama-3-8b",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "paddlepaddle/paddleocr-vl",
        "qwen/qwen-2.5-72b-instruct",
        "qwen/qwen-mt-plus",
        "qwen/qwen2.5-7b-instruct",
        "qwen/qwen2.5-vl-72b-instruct",
        "qwen/qwen3-235b-a22b-fp8",
        "qwen/qwen3-235b-a22b-instruct-2507",
        "qwen/qwen3-235b-a22b-thinking-2507",
        "qwen/qwen3-30b-a3b-fp8",
        "qwen/qwen3-32b-fp8",
        "qwen/qwen3-4b-fp8",
        "qwen/qwen3-8b-fp8",
        "qwen/qwen3-coder-30b-a3b-instruct",
        "qwen/qwen3-coder-480b-a35b-instruct",
        "qwen/qwen3-coder-next",
        "qwen/qwen3-max",
        "qwen/qwen3-next-80b-a3b-instruct",
        "qwen/qwen3-next-80b-a3b-thinking",
        "qwen/qwen3-omni-30b-a3b-instruct",
        "qwen/qwen3-omni-30b-a3b-thinking",
        "qwen/qwen3-vl-235b-a22b-instruct",
        "qwen/qwen3-vl-235b-a22b-thinking",
        "qwen/qwen3-vl-30b-a3b-instruct",
        "qwen/qwen3-vl-30b-a3b-thinking",
        "qwen/qwen3-vl-8b-instruct",
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-27b",
        "qwen/qwen3.5-35b-a3b",
        "qwen/qwen3.5-397b-a17b",
        "sao10K/L3-8B-stheno-v3.2",
        "sao10K/l3-70b-euryale-v2.1",
        "sao10K/l3-8b-lunaris",
        "sao10K/l31-70b-euryale-v2.2",
        "xiaomimimo/mimo-v2-flash",
        "zai-org/autoglm-phone-9b-multilingual",
        "zai-org/glm-4.5",
        "zai-org/glm-4.5-air",
        "zai-org/glm-4.5v",
        "zai-org/glm-4.6",
        "zai-org/glm-4.6v",
        "zai-org/glm-4.7",
        "zai-org/glm-4.7-flash",
        "zai-org/glm-5",
        "zai-org/glm-5.1"
      ],
      "docUrl": "https://novita.ai/docs/guides/introduction",
      "gateway": "models.dev"
    },
    "digitalocean": {
      "url": "https://inference.do-ai.run/v1",
      "apiKeyEnvVar": "DIGITALOCEAN_ACCESS_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "DigitalOcean",
      "models": [
        "alibaba-qwen3-32b",
        "all-mini-lm-l6-v2",
        "anthropic-claude-4.1-opus",
        "anthropic-claude-4.5-haiku",
        "anthropic-claude-4.5-sonnet",
        "anthropic-claude-4.6-sonnet",
        "anthropic-claude-haiku-4.5",
        "anthropic-claude-opus-4",
        "anthropic-claude-opus-4.5",
        "anthropic-claude-opus-4.6",
        "anthropic-claude-opus-4.7",
        "anthropic-claude-sonnet-4",
        "arcee-trinity-large-thinking",
        "bge-m3",
        "bge-reranker-v2-m3",
        "deepseek-3.2",
        "deepseek-r1-distill-llama-70b",
        "deepseek-v3",
        "deepseek-v4-pro",
        "e5-large-v2",
        "fal-ai/elevenlabs/tts/multilingual-v2",
        "fal-ai/fast-sdxl",
        "fal-ai/flux/schnell",
        "fal-ai/stable-audio-25/text-to-audio",
        "gemma-4-31B-it",
        "glm-5",
        "gte-large-en-v1.5",
        "kimi-k2.5",
        "kimi-k2.6",
        "llama-4-maverick",
        "llama3-8b-instruct",
        "llama3.3-70b-instruct",
        "minimax-m2.5",
        "ministral-3-8b-instruct-2512",
        "mistral-3-14B",
        "mistral-7b-instruct-v0.3",
        "multi-qa-mpnet-base-dot-v1",
        "nemotron-3-nano-30b",
        "nemotron-3-nano-omni",
        "nemotron-nano-12b-v2-vl",
        "nvidia-nemotron-3-super-120b",
        "openai-gpt-4.1",
        "openai-gpt-4o",
        "openai-gpt-4o-mini",
        "openai-gpt-5",
        "openai-gpt-5-mini",
        "openai-gpt-5-nano",
        "openai-gpt-5.1-codex-max",
        "openai-gpt-5.2",
        "openai-gpt-5.2-pro",
        "openai-gpt-5.3-codex",
        "openai-gpt-5.4",
        "openai-gpt-5.4-mini",
        "openai-gpt-5.4-nano",
        "openai-gpt-5.4-pro",
        "openai-gpt-5.5",
        "openai-gpt-image-1",
        "openai-gpt-image-1.5",
        "openai-gpt-image-2",
        "openai-gpt-oss-120b",
        "openai-gpt-oss-20b",
        "openai-o1",
        "openai-o3",
        "openai-o3-mini",
        "qwen-2.5-14b-instruct",
        "qwen3-coder-flash",
        "qwen3-embedding-0.6b",
        "qwen3-tts-voicedesign",
        "qwen3.5-397b-a17b",
        "stable-diffusion-3.5-large",
        "wan2-2-t2v-a14b"
      ],
      "docUrl": "https://docs.digitalocean.com/products/gradient-ai-platform/details/models/",
      "gateway": "models.dev"
    },
    "moonshotai": {
      "url": "https://api.moonshot.ai/anthropic/v1",
      "apiKeyEnvVar": "MOONSHOT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Moonshot AI",
      "models": [
        "kimi-k2-0711-preview",
        "kimi-k2-0905-preview",
        "kimi-k2-thinking",
        "kimi-k2-thinking-turbo",
        "kimi-k2-turbo-preview",
        "kimi-k2.5",
        "kimi-k2.6"
      ],
      "docUrl": "https://platform.moonshot.ai/docs/api/chat",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "mistral": {
      "url": "https://api.mistral.ai/v1",
      "apiKeyEnvVar": "MISTRAL_API_KEY",
      "name": "Mistral",
      "models": [
        "codestral-latest",
        "devstral-2512",
        "devstral-medium-2507",
        "devstral-medium-latest",
        "devstral-small-2505",
        "devstral-small-2507",
        "labs-devstral-small-2512",
        "magistral-medium-latest",
        "magistral-small",
        "ministral-3b-latest",
        "ministral-8b-latest",
        "mistral-embed",
        "mistral-large-2411",
        "mistral-large-2512",
        "mistral-large-latest",
        "mistral-medium-2505",
        "mistral-medium-2508",
        "mistral-medium-2604",
        "mistral-medium-latest",
        "mistral-nemo",
        "mistral-small-2506",
        "mistral-small-2603",
        "mistral-small-latest",
        "open-mistral-7b",
        "open-mixtral-8x22b",
        "open-mixtral-8x7b",
        "pixtral-12b",
        "pixtral-large-latest"
      ],
      "docUrl": "https://docs.mistral.ai/getting-started/models/",
      "gateway": "models.dev",
      "npm": "@ai-sdk/mistral"
    },
    "kilo": {
      "url": "https://api.kilo.ai/api/gateway",
      "apiKeyEnvVar": "KILO_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Kilo Gateway",
      "models": [
        "ai21/jamba-large-1.7",
        "aion-labs/aion-1.0",
        "aion-labs/aion-1.0-mini",
        "aion-labs/aion-2.0",
        "aion-labs/aion-rp-llama-3.1-8b",
        "alfredpros/codellama-7b-instruct-solidity",
        "alibaba/tongyi-deepresearch-30b-a3b",
        "allenai/olmo-3-32b-think",
        "amazon/nova-2-lite-v1",
        "amazon/nova-lite-v1",
        "amazon/nova-micro-v1",
        "amazon/nova-premier-v1",
        "amazon/nova-pro-v1",
        "anthracite-org/magnum-v4-72b",
        "anthropic/claude-3-haiku",
        "anthropic/claude-3.5-haiku",
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.6-fast",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-opus-4.7-fast",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "arcee-ai/coder-large",
        "arcee-ai/maestro-reasoning",
        "arcee-ai/spotlight",
        "arcee-ai/trinity-large-preview",
        "arcee-ai/trinity-large-thinking",
        "arcee-ai/trinity-mini",
        "arcee-ai/virtuoso-large",
        "baidu/cobuddy:free",
        "baidu/ernie-4.5-21b-a3b",
        "baidu/ernie-4.5-21b-a3b-thinking",
        "baidu/ernie-4.5-300b-a47b",
        "baidu/ernie-4.5-vl-28b-a3b",
        "baidu/ernie-4.5-vl-424b-a47b",
        "baidu/qianfan-ocr-fast",
        "bytedance-seed/seed-1.6",
        "bytedance-seed/seed-1.6-flash",
        "bytedance-seed/seed-2.0-lite",
        "bytedance-seed/seed-2.0-mini",
        "bytedance/ui-tars-1.5-7b",
        "cohere/command-a",
        "cohere/command-r-08-2024",
        "cohere/command-r-plus-08-2024",
        "cohere/command-r7b-12-2024",
        "deepcogito/cogito-v2.1-671b",
        "deepseek/deepseek-chat",
        "deepseek/deepseek-chat-v3-0324",
        "deepseek/deepseek-chat-v3.1",
        "deepseek/deepseek-r1",
        "deepseek/deepseek-r1-0528",
        "deepseek/deepseek-r1-distill-llama-70b",
        "deepseek/deepseek-r1-distill-qwen-32b",
        "deepseek/deepseek-v3.1-terminus",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v3.2-speciale",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-flash:free",
        "deepseek/deepseek-v4-pro",
        "essentialai/rnj-1-instruct",
        "google/gemini-2.0-flash-001",
        "google/gemini-2.0-flash-lite-001",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-image",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-flash-lite-preview-09-2025",
        "google/gemini-2.5-pro",
        "google/gemini-2.5-pro-preview",
        "google/gemini-2.5-pro-preview-05-06",
        "google/gemini-3-flash-preview",
        "google/gemini-3-pro-image-preview",
        "google/gemini-3.1-flash-image-preview",
        "google/gemini-3.1-flash-lite",
        "google/gemini-3.1-flash-lite-preview",
        "google/gemini-3.1-pro-preview",
        "google/gemini-3.1-pro-preview-customtools",
        "google/gemma-2-27b-it",
        "google/gemma-3-12b-it",
        "google/gemma-3-27b-it",
        "google/gemma-3-4b-it",
        "google/gemma-3n-e4b-it",
        "google/gemma-4-26b-a4b-it",
        "google/gemma-4-31b-it",
        "google/lyria-3-clip-preview",
        "google/lyria-3-pro-preview",
        "gryphe/mythomax-l2-13b",
        "ibm-granite/granite-4.0-h-micro",
        "ibm-granite/granite-4.1-8b",
        "inception/mercury-2",
        "inclusionai/ling-2.6-1t",
        "inclusionai/ling-2.6-flash",
        "inclusionai/ring-2.6-1t",
        "inflection/inflection-3-pi",
        "inflection/inflection-3-productivity",
        "kilo-auto/balanced",
        "kilo-auto/free",
        "kilo-auto/frontier",
        "kilo-auto/small",
        "kwaipilot/kat-coder-pro-v2",
        "liquid/lfm-2-24b-a2b",
        "mancer/weaver",
        "meta-llama/llama-3-70b-instruct",
        "meta-llama/llama-3-8b-instruct",
        "meta-llama/llama-3.1-70b-instruct",
        "meta-llama/llama-3.1-8b-instruct",
        "meta-llama/llama-3.2-11b-vision-instruct",
        "meta-llama/llama-3.2-1b-instruct",
        "meta-llama/llama-3.2-3b-instruct",
        "meta-llama/llama-3.3-70b-instruct",
        "meta-llama/llama-4-maverick",
        "meta-llama/llama-4-scout",
        "meta-llama/llama-guard-3-8b",
        "meta-llama/llama-guard-4-12b",
        "microsoft/phi-4",
        "microsoft/phi-4-mini-instruct",
        "microsoft/wizardlm-2-8x22b",
        "minimax/minimax-01",
        "minimax/minimax-m1",
        "minimax/minimax-m2",
        "minimax/minimax-m2-her",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.7",
        "mistralai/codestral-2508",
        "mistralai/devstral-2512",
        "mistralai/devstral-medium",
        "mistralai/devstral-small",
        "mistralai/ministral-14b-2512",
        "mistralai/ministral-3b-2512",
        "mistralai/ministral-8b-2512",
        "mistralai/mistral-7b-instruct-v0.1",
        "mistralai/mistral-large",
        "mistralai/mistral-large-2407",
        "mistralai/mistral-large-2411",
        "mistralai/mistral-large-2512",
        "mistralai/mistral-medium-3",
        "mistralai/mistral-medium-3-5",
        "mistralai/mistral-medium-3.1",
        "mistralai/mistral-nemo",
        "mistralai/mistral-saba",
        "mistralai/mistral-small-24b-instruct-2501",
        "mistralai/mistral-small-2603",
        "mistralai/mistral-small-3.1-24b-instruct",
        "mistralai/mistral-small-3.2-24b-instruct",
        "mistralai/mixtral-8x22b-instruct",
        "mistralai/pixtral-large-2411",
        "mistralai/voxtral-small-24b-2507",
        "moonshotai/kimi-k2",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.6",
        "morph/morph-v3-fast",
        "morph/morph-v3-large",
        "nex-agi/deepseek-v3.1-nex-n1",
        "nousresearch/hermes-2-pro-llama-3-8b",
        "nousresearch/hermes-3-llama-3.1-405b",
        "nousresearch/hermes-3-llama-3.1-70b",
        "nousresearch/hermes-4-405b",
        "nousresearch/hermes-4-70b",
        "nvidia/llama-3.3-nemotron-super-49b-v1.5",
        "nvidia/nemotron-3-nano-30b-a3b",
        "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
        "nvidia/nemotron-3-super-120b-a12b",
        "nvidia/nemotron-3-super-120b-a12b:free",
        "nvidia/nemotron-nano-9b-v2",
        "openai/gpt-3.5-turbo",
        "openai/gpt-3.5-turbo-0613",
        "openai/gpt-3.5-turbo-16k",
        "openai/gpt-3.5-turbo-instruct",
        "openai/gpt-4",
        "openai/gpt-4-0314",
        "openai/gpt-4-1106-preview",
        "openai/gpt-4-turbo",
        "openai/gpt-4-turbo-preview",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-2024-05-13",
        "openai/gpt-4o-2024-08-06",
        "openai/gpt-4o-2024-11-20",
        "openai/gpt-4o-audio-preview",
        "openai/gpt-4o-mini",
        "openai/gpt-4o-mini-2024-07-18",
        "openai/gpt-4o-mini-search-preview",
        "openai/gpt-4o-search-preview",
        "openai/gpt-5",
        "openai/gpt-5-chat",
        "openai/gpt-5-codex",
        "openai/gpt-5-image",
        "openai/gpt-5-image-mini",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-chat",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-chat",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-image-2",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "openai/gpt-audio",
        "openai/gpt-audio-mini",
        "openai/gpt-chat-latest",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "openai/gpt-oss-safeguard-20b",
        "openai/o1",
        "openai/o1-pro",
        "openai/o3",
        "openai/o3-deep-research",
        "openai/o3-mini",
        "openai/o3-mini-high",
        "openai/o3-pro",
        "openai/o4-mini",
        "openai/o4-mini-deep-research",
        "openai/o4-mini-high",
        "openrouter/auto",
        "openrouter/bodybuilder",
        "openrouter/free",
        "openrouter/owl-alpha",
        "openrouter/pareto-code",
        "perceptron/perceptron-mk1",
        "perplexity/sonar",
        "perplexity/sonar-deep-research",
        "perplexity/sonar-pro",
        "perplexity/sonar-pro-search",
        "perplexity/sonar-reasoning-pro",
        "poolside/laguna-m.1:free",
        "poolside/laguna-xs.2:free",
        "prime-intellect/intellect-3",
        "qwen/qwen-2.5-72b-instruct",
        "qwen/qwen-2.5-7b-instruct",
        "qwen/qwen-2.5-coder-32b-instruct",
        "qwen/qwen-plus",
        "qwen/qwen-plus-2025-07-28",
        "qwen/qwen-plus-2025-07-28:thinking",
        "qwen/qwen2.5-vl-72b-instruct",
        "qwen/qwen3-14b",
        "qwen/qwen3-235b-a22b",
        "qwen/qwen3-235b-a22b-2507",
        "qwen/qwen3-235b-a22b-thinking-2507",
        "qwen/qwen3-30b-a3b",
        "qwen/qwen3-30b-a3b-instruct-2507",
        "qwen/qwen3-30b-a3b-thinking-2507",
        "qwen/qwen3-32b",
        "qwen/qwen3-8b",
        "qwen/qwen3-coder",
        "qwen/qwen3-coder-30b-a3b-instruct",
        "qwen/qwen3-coder-flash",
        "qwen/qwen3-coder-next",
        "qwen/qwen3-coder-plus",
        "qwen/qwen3-max",
        "qwen/qwen3-max-thinking",
        "qwen/qwen3-next-80b-a3b-instruct",
        "qwen/qwen3-next-80b-a3b-thinking",
        "qwen/qwen3-vl-235b-a22b-instruct",
        "qwen/qwen3-vl-235b-a22b-thinking",
        "qwen/qwen3-vl-30b-a3b-instruct",
        "qwen/qwen3-vl-30b-a3b-thinking",
        "qwen/qwen3-vl-32b-instruct",
        "qwen/qwen3-vl-8b-instruct",
        "qwen/qwen3-vl-8b-thinking",
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-27b",
        "qwen/qwen3.5-35b-a3b",
        "qwen/qwen3.5-397b-a17b",
        "qwen/qwen3.5-9b",
        "qwen/qwen3.5-flash-02-23",
        "qwen/qwen3.5-plus-02-15",
        "qwen/qwen3.5-plus-20260420",
        "qwen/qwen3.6-27b",
        "qwen/qwen3.6-35b-a3b",
        "qwen/qwen3.6-flash",
        "qwen/qwen3.6-max-preview",
        "qwen/qwen3.6-plus",
        "rekaai/reka-edge",
        "rekaai/reka-flash-3",
        "relace/relace-apply-3",
        "relace/relace-search",
        "sao10k/l3-euryale-70b",
        "sao10k/l3-lunaris-8b",
        "sao10k/l3.1-70b-hanami-x1",
        "sao10k/l3.1-euryale-70b",
        "sao10k/l3.3-euryale-70b",
        "stepfun/step-3.5-flash",
        "stepfun/step-3.5-flash:free",
        "switchpoint/router",
        "tencent/hunyuan-a13b-instruct",
        "tencent/hy3-preview",
        "thedrummer/cydonia-24b-v4.1",
        "thedrummer/rocinante-12b",
        "thedrummer/skyfall-36b-v2",
        "thedrummer/unslopnemo-12b",
        "undi95/remm-slerp-l2-13b",
        "upstage/solar-pro-3",
        "writer/palmyra-x5",
        "x-ai/grok-4.20",
        "x-ai/grok-4.20-multi-agent",
        "x-ai/grok-4.3",
        "x-ai/grok-code-fast-1:optimized:free",
        "xiaomi/mimo-v2-flash",
        "xiaomi/mimo-v2-omni",
        "xiaomi/mimo-v2-pro",
        "xiaomi/mimo-v2.5",
        "xiaomi/mimo-v2.5-pro",
        "z-ai/glm-4-32b",
        "z-ai/glm-4.5",
        "z-ai/glm-4.5-air",
        "z-ai/glm-4.5v",
        "z-ai/glm-4.6",
        "z-ai/glm-4.6v",
        "z-ai/glm-4.7",
        "z-ai/glm-4.7-flash",
        "z-ai/glm-5",
        "z-ai/glm-5-turbo",
        "z-ai/glm-5.1",
        "z-ai/glm-5v-turbo",
        "~anthropic/claude-haiku-latest",
        "~anthropic/claude-opus-latest",
        "~anthropic/claude-sonnet-latest",
        "~google/gemini-flash-latest",
        "~google/gemini-pro-latest",
        "~moonshotai/kimi-latest",
        "~openai/gpt-latest",
        "~openai/gpt-mini-latest"
      ],
      "docUrl": "https://kilo.ai",
      "gateway": "models.dev"
    },
    "cloudflare-workers-ai": {
      "url": "https://api.cloudflare.com/client/v4/accounts/${CLOUDFLARE_ACCOUNT_ID}/ai/v1",
      "apiKeyEnvVar": "CLOUDFLARE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Cloudflare Workers AI",
      "models": [
        "@cf/aisingapore/gemma-sea-lion-v4-27b-it",
        "@cf/deepseek-ai/deepseek-r1-distill-qwen-32b",
        "@cf/google/gemma-3-12b-it",
        "@cf/google/gemma-4-26b-a4b-it",
        "@cf/ibm-granite/granite-4.0-h-micro",
        "@cf/meta/llama-2-7b-chat-fp16",
        "@cf/meta/llama-3-8b-instruct",
        "@cf/meta/llama-3-8b-instruct-awq",
        "@cf/meta/llama-3.1-8b-instruct-awq",
        "@cf/meta/llama-3.1-8b-instruct-fp8",
        "@cf/meta/llama-3.2-11b-vision-instruct",
        "@cf/meta/llama-3.2-1b-instruct",
        "@cf/meta/llama-3.2-3b-instruct",
        "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
        "@cf/meta/llama-4-scout-17b-16e-instruct",
        "@cf/meta/llama-guard-3-8b",
        "@cf/mistral/mistral-7b-instruct-v0.1",
        "@cf/mistralai/mistral-small-3.1-24b-instruct",
        "@cf/moonshotai/kimi-k2.5",
        "@cf/moonshotai/kimi-k2.6",
        "@cf/nvidia/nemotron-3-120b-a12b",
        "@cf/openai/gpt-oss-120b",
        "@cf/openai/gpt-oss-20b",
        "@cf/qwen/qwen2.5-coder-32b-instruct",
        "@cf/qwen/qwen3-30b-a3b-fp8",
        "@cf/qwen/qwq-32b",
        "@cf/zai-org/glm-4.7-flash"
      ],
      "docUrl": "https://developers.cloudflare.com/workers-ai/models/",
      "gateway": "models.dev"
    },
    "lmstudio": {
      "url": "http://127.0.0.1:1234/v1",
      "apiKeyEnvVar": "LMSTUDIO_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "LMStudio",
      "models": ["openai/gpt-oss-20b", "qwen/qwen3-30b-a3b-2507", "qwen/qwen3-coder-30b"],
      "docUrl": "https://lmstudio.ai/models",
      "gateway": "models.dev"
    },
    "xiaomi-token-plan-cn": {
      "url": "https://token-plan-cn.xiaomimimo.com/v1",
      "apiKeyEnvVar": "XIAOMI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Xiaomi Token Plan (China)",
      "models": ["mimo-v2-flash", "mimo-v2-omni", "mimo-v2-pro", "mimo-v2-tts", "mimo-v2.5", "mimo-v2.5-pro"],
      "docUrl": "https://platform.xiaomimimo.com/#/docs",
      "gateway": "models.dev"
    },
    "morph": {
      "url": "https://api.morphllm.com/v1",
      "apiKeyEnvVar": "MORPH_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Morph",
      "models": ["auto", "morph-v3-fast", "morph-v3-large"],
      "docUrl": "https://docs.morphllm.com/api-reference/introduction",
      "gateway": "models.dev"
    },
    "nearai": {
      "url": "https://cloud-api.near.ai/v1",
      "apiKeyEnvVar": "NEARAI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "NEAR AI Cloud",
      "models": [
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-Embedding-0.6B",
        "Qwen/Qwen3-Reranker-0.6B",
        "Qwen/Qwen3-VL-30B-A3B-Instruct",
        "Qwen/Qwen3.5-122B-A10B",
        "anthropic/claude-haiku-4-5",
        "anthropic/claude-opus-4-6",
        "anthropic/claude-opus-4-7",
        "anthropic/claude-sonnet-4-5",
        "anthropic/claude-sonnet-4-6",
        "black-forest-labs/FLUX.2-klein-4B",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-pro",
        "google/gemini-3.1-flash-lite",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-5",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5.1",
        "openai/gpt-5.2",
        "openai/gpt-5.4",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.5",
        "openai/gpt-oss-120b",
        "openai/o3",
        "openai/o3-mini",
        "openai/o4-mini",
        "openai/whisper-large-v3",
        "zai-org/GLM-5.1-FP8"
      ],
      "docUrl": "https://docs.near.ai/",
      "gateway": "models.dev"
    },
    "abacus": {
      "url": "https://routellm.abacus.ai/v1",
      "apiKeyEnvVar": "ABACUS_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Abacus",
      "models": [
        "Qwen/QwQ-32B",
        "Qwen/Qwen2.5-72B-Instruct",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-32B",
        "Qwen/qwen3-coder-480b-a35b-instruct",
        "claude-3-7-sonnet-20250219",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-1-20250805",
        "claude-opus-4-20250514",
        "claude-opus-4-5-20251101",
        "claude-opus-4-6",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5-20250929",
        "claude-sonnet-4-6",
        "deepseek-ai/DeepSeek-R1",
        "deepseek-ai/DeepSeek-V3.1-Terminus",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek/deepseek-v3.1",
        "gemini-2.5-flash",
        "gemini-2.5-pro",
        "gemini-3-flash-preview",
        "gemini-3.1-flash-lite-preview",
        "gemini-3.1-pro-preview",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-4.1-nano",
        "gpt-4o-2024-11-20",
        "gpt-4o-mini",
        "gpt-5",
        "gpt-5-codex",
        "gpt-5-mini",
        "gpt-5-nano",
        "gpt-5.1",
        "gpt-5.1-chat-latest",
        "gpt-5.1-codex",
        "gpt-5.1-codex-max",
        "gpt-5.2",
        "gpt-5.2-chat-latest",
        "gpt-5.2-codex",
        "gpt-5.3-chat-latest",
        "gpt-5.3-codex",
        "gpt-5.3-codex-xhigh",
        "gpt-5.4",
        "grok-4-0709",
        "grok-4-1-fast-non-reasoning",
        "grok-4-fast-non-reasoning",
        "grok-code-fast-1",
        "kimi-k2-turbo-preview",
        "kimi-k2.5",
        "llama-3.3-70b-versatile",
        "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
        "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
        "meta-llama/Meta-Llama-3.1-8B-Instruct",
        "o3",
        "o3-mini",
        "o3-pro",
        "o4-mini",
        "openai/gpt-oss-120b",
        "qwen-2.5-coder-32b",
        "qwen3-max",
        "route-llm",
        "zai-org/glm-4.5",
        "zai-org/glm-4.6",
        "zai-org/glm-4.7",
        "zai-org/glm-5"
      ],
      "docUrl": "https://abacus.ai/help/api",
      "gateway": "models.dev"
    },
    "privatemode-ai": {
      "url": "http://localhost:8080/v1",
      "apiKeyEnvVar": "PRIVATEMODE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Privatemode AI",
      "models": ["gemma-3-27b", "gpt-oss-120b", "qwen3-coder-30b-a3b", "qwen3-embedding-4b", "whisper-large-v3"],
      "docUrl": "https://docs.privatemode.ai/api/overview",
      "gateway": "models.dev"
    },
    "minimax-cn-coding-plan": {
      "url": "https://api.minimaxi.com/anthropic/v1",
      "apiKeyEnvVar": "MINIMAX_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "MiniMax Token Plan (minimaxi.com)",
      "models": [
        "MiniMax-M2",
        "MiniMax-M2.1",
        "MiniMax-M2.5",
        "MiniMax-M2.5-highspeed",
        "MiniMax-M2.7",
        "MiniMax-M2.7-highspeed"
      ],
      "docUrl": "https://platform.minimaxi.com/docs/token-plan/intro",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "xiaomi-token-plan-ams": {
      "url": "https://token-plan-ams.xiaomimimo.com/v1",
      "apiKeyEnvVar": "XIAOMI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Xiaomi Token Plan (Europe)",
      "models": ["mimo-v2-flash", "mimo-v2-omni", "mimo-v2-pro", "mimo-v2-tts", "mimo-v2.5", "mimo-v2.5-pro"],
      "docUrl": "https://platform.xiaomimimo.com/#/docs",
      "gateway": "models.dev"
    },
    "cloudferro-sherlock": {
      "url": "https://api-sherlock.cloudferro.com/openai/v1/",
      "apiKeyEnvVar": "CLOUDFERRO_SHERLOCK_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "CloudFerro Sherlock",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "meta-llama/Llama-3.3-70B-Instruct",
        "openai/gpt-oss-120b",
        "speakleash/Bielik-11B-v2.6-Instruct",
        "speakleash/Bielik-11B-v3.0-Instruct"
      ],
      "docUrl": "https://docs.sherlock.cloudferro.com/",
      "gateway": "models.dev"
    },
    "openai": {
      "apiKeyEnvVar": "OPENAI_API_KEY",
      "name": "OpenAI",
      "models": [
        "chatgpt-image-latest",
        "gpt-3.5-turbo",
        "gpt-4",
        "gpt-4-turbo",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-4.1-nano",
        "gpt-4o",
        "gpt-4o-2024-05-13",
        "gpt-4o-2024-08-06",
        "gpt-4o-2024-11-20",
        "gpt-4o-mini",
        "gpt-5",
        "gpt-5-chat-latest",
        "gpt-5-codex",
        "gpt-5-mini",
        "gpt-5-nano",
        "gpt-5-pro",
        "gpt-5.1",
        "gpt-5.1-chat-latest",
        "gpt-5.1-codex",
        "gpt-5.1-codex-max",
        "gpt-5.1-codex-mini",
        "gpt-5.2",
        "gpt-5.2-chat-latest",
        "gpt-5.2-codex",
        "gpt-5.2-pro",
        "gpt-5.3-chat-latest",
        "gpt-5.3-codex",
        "gpt-5.3-codex-spark",
        "gpt-5.4",
        "gpt-5.4-mini",
        "gpt-5.4-nano",
        "gpt-5.4-pro",
        "gpt-5.5",
        "gpt-5.5-pro",
        "gpt-image-1",
        "gpt-image-1-mini",
        "gpt-image-1.5",
        "o1",
        "o1-mini",
        "o1-preview",
        "o1-pro",
        "o3",
        "o3-deep-research",
        "o3-mini",
        "o3-pro",
        "o4-mini",
        "o4-mini-deep-research",
        "text-embedding-3-large",
        "text-embedding-3-small",
        "text-embedding-ada-002"
      ],
      "docUrl": "https://platform.openai.com/docs/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/openai"
    },
    "dinference": {
      "url": "https://api.dinference.com/v1",
      "apiKeyEnvVar": "DINFERENCE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "DInference",
      "models": ["glm-4.7", "glm-5", "glm-5.1", "gpt-oss-120b", "minimax-m2.5"],
      "docUrl": "https://dinference.com",
      "gateway": "models.dev"
    },
    "vivgrid": {
      "url": "https://api.vivgrid.com/v1",
      "apiKeyEnvVar": "VIVGRID_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Vivgrid",
      "models": [
        "deepseek-v3.2",
        "deepseek-v4-pro",
        "gemini-3.1-flash-lite-preview",
        "gemini-3.1-pro-preview",
        "gpt-5-mini",
        "gpt-5.1-codex",
        "gpt-5.1-codex-max",
        "gpt-5.2-codex",
        "gpt-5.3-codex",
        "gpt-5.4",
        "gpt-5.4-mini",
        "gpt-5.4-nano",
        "gpt-5.5"
      ],
      "docUrl": "https://docs.vivgrid.com/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/openai"
    },
    "cerebras": {
      "apiKeyEnvVar": "CEREBRAS_API_KEY",
      "name": "Cerebras",
      "models": ["gpt-oss-120b", "llama3.1-8b", "qwen-3-235b-a22b-instruct-2507", "zai-glm-4.7"],
      "docUrl": "https://inference-docs.cerebras.ai/models/overview",
      "gateway": "models.dev",
      "npm": "@ai-sdk/cerebras"
    },
    "vultr": {
      "url": "https://api.vultrinference.com/v1",
      "apiKeyEnvVar": "VULTR_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Vultr",
      "models": ["DeepSeek-V3.2", "GLM-5-FP8", "Kimi-K2.5", "MiniMax-M2.5", "gpt-oss-120b"],
      "docUrl": "https://api.vultrinference.com/",
      "gateway": "models.dev"
    },
    "kuae-cloud-coding-plan": {
      "url": "https://coding-plan-endpoint.kuaecloud.net/v1",
      "apiKeyEnvVar": "KUAE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "KUAE Cloud Coding Plan",
      "models": ["GLM-4.7"],
      "docUrl": "https://docs.mthreads.com/kuaecloud/kuaecloud-doc-online/coding_plan/",
      "gateway": "models.dev"
    },
    "modelscope": {
      "url": "https://api-inference.modelscope.cn/v1",
      "apiKeyEnvVar": "MODELSCOPE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "ModelScope",
      "models": [
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-30B-A3B-Thinking-2507",
        "Qwen/Qwen3-Coder-30B-A3B-Instruct",
        "ZhipuAI/GLM-4.5",
        "ZhipuAI/GLM-4.6"
      ],
      "docUrl": "https://modelscope.cn/docs/model-service/API-Inference/intro",
      "gateway": "models.dev"
    },
    "kimi-for-coding": {
      "url": "https://api.kimi.com/coding/v1",
      "apiKeyEnvVar": "KIMI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Kimi For Coding",
      "models": ["k2p5", "k2p6", "kimi-k2-thinking"],
      "docUrl": "https://www.kimi.com/coding/docs/en/third-party-agents.html",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "lucidquery": {
      "url": "https://lucidquery.com/api/v1",
      "apiKeyEnvVar": "LUCIDQUERY_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "LucidQuery AI",
      "models": ["lucidnova-rf1-100b", "lucidquery-nexus-coder"],
      "docUrl": "https://lucidquery.com/api/docs",
      "gateway": "models.dev"
    },
    "neuralwatt": {
      "url": "https://api.neuralwatt.com/v1",
      "apiKeyEnvVar": "NEURALWATT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Neuralwatt",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "Qwen/Qwen3.5-397B-A17B-FP8",
        "Qwen/Qwen3.6-35B-A3B",
        "glm-5-fast",
        "glm-5.1-fast",
        "kimi-k2.5-fast",
        "kimi-k2.6-fast",
        "mistralai/Devstral-Small-2-24B-Instruct-2512",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "openai/gpt-oss-20b",
        "qwen3.5-397b-fast",
        "qwen3.6-35b-fast",
        "zai-org/GLM-5.1-FP8"
      ],
      "docUrl": "https://portal.neuralwatt.com/docs",
      "gateway": "models.dev"
    },
    "jiekou": {
      "url": "https://api.jiekou.ai/openai",
      "apiKeyEnvVar": "JIEKOU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Jiekou.AI",
      "models": [
        "baidu/ernie-4.5-300b-a47b-paddle",
        "baidu/ernie-4.5-vl-424b-a47b",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-1-20250805",
        "claude-opus-4-20250514",
        "claude-opus-4-5-20251101",
        "claude-opus-4-6",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5-20250929",
        "deepseek/deepseek-r1-0528",
        "deepseek/deepseek-v3-0324",
        "deepseek/deepseek-v3.1",
        "gemini-2.5-flash",
        "gemini-2.5-flash-lite",
        "gemini-2.5-flash-lite-preview-06-17",
        "gemini-2.5-flash-lite-preview-09-2025",
        "gemini-2.5-flash-preview-05-20",
        "gemini-2.5-pro",
        "gemini-2.5-pro-preview-06-05",
        "gemini-3-flash-preview",
        "gemini-3-pro-preview",
        "gpt-5-chat-latest",
        "gpt-5-codex",
        "gpt-5-mini",
        "gpt-5-nano",
        "gpt-5-pro",
        "gpt-5.1",
        "gpt-5.1-codex",
        "gpt-5.1-codex-max",
        "gpt-5.1-codex-mini",
        "gpt-5.2",
        "gpt-5.2-codex",
        "gpt-5.2-pro",
        "grok-4-0709",
        "grok-4-1-fast-non-reasoning",
        "grok-4-1-fast-reasoning",
        "grok-4-fast-non-reasoning",
        "grok-4-fast-reasoning",
        "grok-code-fast-1",
        "minimax/minimax-m2.1",
        "minimaxai/minimax-m1-80k",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-instruct",
        "moonshotai/kimi-k2.5",
        "o3",
        "o3-mini",
        "o4-mini",
        "qwen/qwen3-235b-a22b-fp8",
        "qwen/qwen3-235b-a22b-instruct-2507",
        "qwen/qwen3-235b-a22b-thinking-2507",
        "qwen/qwen3-30b-a3b-fp8",
        "qwen/qwen3-32b-fp8",
        "qwen/qwen3-coder-480b-a35b-instruct",
        "qwen/qwen3-coder-next",
        "qwen/qwen3-next-80b-a3b-instruct",
        "qwen/qwen3-next-80b-a3b-thinking",
        "xiaomimimo/mimo-v2-flash",
        "zai-org/glm-4.5",
        "zai-org/glm-4.5v",
        "zai-org/glm-4.7",
        "zai-org/glm-4.7-flash"
      ],
      "docUrl": "https://docs.jiekou.ai/docs/support/quickstart?utm_source=github_models.dev",
      "gateway": "models.dev"
    },
    "ovhcloud": {
      "url": "https://oai.endpoints.kepler.ai.cloud.ovh.net/v1",
      "apiKeyEnvVar": "OVHCLOUD_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "OVHcloud AI Endpoints",
      "models": [
        "gpt-oss-120b",
        "gpt-oss-20b",
        "llama-3.1-8b-instruct",
        "meta-llama-3_3-70b-instruct",
        "mistral-7b-instruct-v0.3",
        "mistral-nemo-instruct-2407",
        "mistral-small-3.2-24b-instruct-2506",
        "qwen2.5-vl-72b-instruct",
        "qwen3-32b",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3.5-9b"
      ],
      "docUrl": "https://www.ovhcloud.com/en/public-cloud/ai-endpoints/catalog//",
      "gateway": "models.dev"
    },
    "friendli": {
      "url": "https://api.friendli.ai/serverless/v1",
      "apiKeyEnvVar": "FRIENDLI_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "Friendli",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "meta-llama/Llama-3.1-8B-Instruct",
        "meta-llama/Llama-3.3-70B-Instruct",
        "zai-org/GLM-5",
        "zai-org/GLM-5.1"
      ],
      "docUrl": "https://friendli.ai/docs/guides/serverless_endpoints/introduction",
      "gateway": "models.dev"
    },
    "openrouter": {
      "url": "https://openrouter.ai/api/v1",
      "apiKeyEnvVar": "OPENROUTER_API_KEY",
      "name": "OpenRouter",
      "models": [
        "ai21/jamba-large-1.7",
        "aion-labs/aion-1.0",
        "aion-labs/aion-1.0-mini",
        "aion-labs/aion-2.0",
        "aion-labs/aion-rp-llama-3.1-8b",
        "alfredpros/codellama-7b-instruct-solidity",
        "alibaba/tongyi-deepresearch-30b-a3b",
        "allenai/olmo-3-32b-think",
        "amazon/nova-2-lite-v1",
        "amazon/nova-lite-v1",
        "amazon/nova-micro-v1",
        "amazon/nova-premier-v1",
        "amazon/nova-pro-v1",
        "anthracite-org/magnum-v4-72b",
        "anthropic/claude-3-haiku",
        "anthropic/claude-3.5-haiku",
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.6-fast",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-opus-4.7-fast",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "arcee-ai/coder-large",
        "arcee-ai/maestro-reasoning",
        "arcee-ai/spotlight",
        "arcee-ai/trinity-large-thinking",
        "arcee-ai/trinity-large-thinking:free",
        "arcee-ai/trinity-mini",
        "arcee-ai/virtuoso-large",
        "baidu/cobuddy:free",
        "baidu/ernie-4.5-21b-a3b",
        "baidu/ernie-4.5-21b-a3b-thinking",
        "baidu/ernie-4.5-300b-a47b",
        "baidu/ernie-4.5-vl-28b-a3b",
        "baidu/ernie-4.5-vl-424b-a47b",
        "baidu/qianfan-ocr-fast",
        "bytedance-seed/seed-1.6",
        "bytedance-seed/seed-1.6-flash",
        "bytedance-seed/seed-2.0-lite",
        "bytedance-seed/seed-2.0-mini",
        "bytedance/ui-tars-1.5-7b",
        "cognitivecomputations/dolphin-mistral-24b-venice-edition:free",
        "cohere/command-a",
        "cohere/command-r-08-2024",
        "cohere/command-r-plus-08-2024",
        "cohere/command-r7b-12-2024",
        "deepcogito/cogito-v2.1-671b",
        "deepseek/deepseek-chat",
        "deepseek/deepseek-chat-v3-0324",
        "deepseek/deepseek-chat-v3.1",
        "deepseek/deepseek-r1",
        "deepseek/deepseek-r1-0528",
        "deepseek/deepseek-r1-distill-llama-70b",
        "deepseek/deepseek-r1-distill-qwen-32b",
        "deepseek/deepseek-v3.1-terminus",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v3.2-speciale",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-flash:free",
        "deepseek/deepseek-v4-pro",
        "essentialai/rnj-1-instruct",
        "google/gemini-2.0-flash-001",
        "google/gemini-2.0-flash-lite-001",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-image",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-flash-lite-preview-09-2025",
        "google/gemini-2.5-pro",
        "google/gemini-2.5-pro-preview",
        "google/gemini-2.5-pro-preview-05-06",
        "google/gemini-3-flash-preview",
        "google/gemini-3-pro-image-preview",
        "google/gemini-3.1-flash-image-preview",
        "google/gemini-3.1-flash-lite",
        "google/gemini-3.1-flash-lite-preview",
        "google/gemini-3.1-pro-preview",
        "google/gemini-3.1-pro-preview-customtools",
        "google/gemini-3.5-flash",
        "google/gemma-2-27b-it",
        "google/gemma-3-12b-it",
        "google/gemma-3-27b-it",
        "google/gemma-3-4b-it",
        "google/gemma-3n-e4b-it",
        "google/gemma-4-26b-a4b-it",
        "google/gemma-4-26b-a4b-it:free",
        "google/gemma-4-31b-it",
        "google/gemma-4-31b-it:free",
        "google/lyria-3-clip-preview",
        "google/lyria-3-pro-preview",
        "gryphe/mythomax-l2-13b",
        "ibm-granite/granite-4.0-h-micro",
        "ibm-granite/granite-4.1-8b",
        "inception/mercury-2",
        "inclusionai/ling-2.6-1t",
        "inclusionai/ling-2.6-flash",
        "inclusionai/ring-2.6-1t",
        "inflection/inflection-3-pi",
        "inflection/inflection-3-productivity",
        "kwaipilot/kat-coder-pro-v2",
        "liquid/lfm-2-24b-a2b",
        "liquid/lfm-2.5-1.2b-instruct:free",
        "liquid/lfm-2.5-1.2b-thinking:free",
        "mancer/weaver",
        "meta-llama/llama-3-70b-instruct",
        "meta-llama/llama-3-8b-instruct",
        "meta-llama/llama-3.1-70b-instruct",
        "meta-llama/llama-3.1-8b-instruct",
        "meta-llama/llama-3.2-11b-vision-instruct",
        "meta-llama/llama-3.2-1b-instruct",
        "meta-llama/llama-3.2-3b-instruct",
        "meta-llama/llama-3.2-3b-instruct:free",
        "meta-llama/llama-3.3-70b-instruct",
        "meta-llama/llama-3.3-70b-instruct:free",
        "meta-llama/llama-4-maverick",
        "meta-llama/llama-4-scout",
        "meta-llama/llama-guard-3-8b",
        "meta-llama/llama-guard-4-12b",
        "microsoft/phi-4",
        "microsoft/phi-4-mini-instruct",
        "microsoft/wizardlm-2-8x22b",
        "minimax/minimax-01",
        "minimax/minimax-m1",
        "minimax/minimax-m2",
        "minimax/minimax-m2-her",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5:free",
        "minimax/minimax-m2.7",
        "mistralai/codestral-2508",
        "mistralai/devstral-2512",
        "mistralai/devstral-medium",
        "mistralai/devstral-small",
        "mistralai/ministral-14b-2512",
        "mistralai/ministral-3b-2512",
        "mistralai/ministral-8b-2512",
        "mistralai/mistral-7b-instruct-v0.1",
        "mistralai/mistral-large",
        "mistralai/mistral-large-2407",
        "mistralai/mistral-large-2411",
        "mistralai/mistral-large-2512",
        "mistralai/mistral-medium-3",
        "mistralai/mistral-medium-3-5",
        "mistralai/mistral-medium-3.1",
        "mistralai/mistral-nemo",
        "mistralai/mistral-saba",
        "mistralai/mistral-small-24b-instruct-2501",
        "mistralai/mistral-small-2603",
        "mistralai/mistral-small-3.1-24b-instruct",
        "mistralai/mistral-small-3.2-24b-instruct",
        "mistralai/mixtral-8x22b-instruct",
        "mistralai/pixtral-large-2411",
        "mistralai/voxtral-small-24b-2507",
        "moonshotai/kimi-k2",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.6",
        "morph/morph-v3-fast",
        "morph/morph-v3-large",
        "nex-agi/deepseek-v3.1-nex-n1",
        "nousresearch/hermes-2-pro-llama-3-8b",
        "nousresearch/hermes-3-llama-3.1-405b",
        "nousresearch/hermes-3-llama-3.1-405b:free",
        "nousresearch/hermes-3-llama-3.1-70b",
        "nousresearch/hermes-4-405b",
        "nousresearch/hermes-4-70b",
        "nvidia/llama-3.3-nemotron-super-49b-v1.5",
        "nvidia/nemotron-3-nano-30b-a3b",
        "nvidia/nemotron-3-nano-30b-a3b:free",
        "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
        "nvidia/nemotron-3-super-120b-a12b",
        "nvidia/nemotron-3-super-120b-a12b:free",
        "nvidia/nemotron-nano-12b-v2-vl:free",
        "nvidia/nemotron-nano-9b-v2",
        "nvidia/nemotron-nano-9b-v2:free",
        "openai/gpt-3.5-turbo",
        "openai/gpt-3.5-turbo-0613",
        "openai/gpt-3.5-turbo-16k",
        "openai/gpt-3.5-turbo-instruct",
        "openai/gpt-4",
        "openai/gpt-4-0314",
        "openai/gpt-4-1106-preview",
        "openai/gpt-4-turbo",
        "openai/gpt-4-turbo-preview",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-2024-05-13",
        "openai/gpt-4o-2024-08-06",
        "openai/gpt-4o-2024-11-20",
        "openai/gpt-4o-audio-preview",
        "openai/gpt-4o-mini",
        "openai/gpt-4o-mini-2024-07-18",
        "openai/gpt-4o-mini-search-preview",
        "openai/gpt-4o-search-preview",
        "openai/gpt-5",
        "openai/gpt-5-chat",
        "openai/gpt-5-codex",
        "openai/gpt-5-image",
        "openai/gpt-5-image-mini",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-chat",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-chat",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-image-2",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "openai/gpt-audio",
        "openai/gpt-audio-mini",
        "openai/gpt-chat-latest",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-120b:free",
        "openai/gpt-oss-20b",
        "openai/gpt-oss-20b:free",
        "openai/gpt-oss-safeguard-20b",
        "openai/o1",
        "openai/o1-pro",
        "openai/o3",
        "openai/o3-deep-research",
        "openai/o3-mini",
        "openai/o3-mini-high",
        "openai/o3-pro",
        "openai/o4-mini",
        "openai/o4-mini-deep-research",
        "openai/o4-mini-high",
        "openrouter/auto",
        "openrouter/bodybuilder",
        "openrouter/free",
        "openrouter/owl-alpha",
        "openrouter/pareto-code",
        "perceptron/perceptron-mk1",
        "perplexity/sonar",
        "perplexity/sonar-deep-research",
        "perplexity/sonar-pro",
        "perplexity/sonar-pro-search",
        "perplexity/sonar-reasoning-pro",
        "poolside/laguna-m.1:free",
        "poolside/laguna-xs.2:free",
        "prime-intellect/intellect-3",
        "qwen/qwen-2.5-72b-instruct",
        "qwen/qwen-2.5-7b-instruct",
        "qwen/qwen-2.5-coder-32b-instruct",
        "qwen/qwen-plus",
        "qwen/qwen-plus-2025-07-28",
        "qwen/qwen-plus-2025-07-28:thinking",
        "qwen/qwen2.5-vl-72b-instruct",
        "qwen/qwen3-14b",
        "qwen/qwen3-235b-a22b",
        "qwen/qwen3-235b-a22b-2507",
        "qwen/qwen3-235b-a22b-thinking-2507",
        "qwen/qwen3-30b-a3b",
        "qwen/qwen3-30b-a3b-instruct-2507",
        "qwen/qwen3-30b-a3b-thinking-2507",
        "qwen/qwen3-32b",
        "qwen/qwen3-8b",
        "qwen/qwen3-coder",
        "qwen/qwen3-coder-30b-a3b-instruct",
        "qwen/qwen3-coder-flash",
        "qwen/qwen3-coder-next",
        "qwen/qwen3-coder-plus",
        "qwen/qwen3-coder:free",
        "qwen/qwen3-max",
        "qwen/qwen3-max-thinking",
        "qwen/qwen3-next-80b-a3b-instruct",
        "qwen/qwen3-next-80b-a3b-instruct:free",
        "qwen/qwen3-next-80b-a3b-thinking",
        "qwen/qwen3-vl-235b-a22b-instruct",
        "qwen/qwen3-vl-235b-a22b-thinking",
        "qwen/qwen3-vl-30b-a3b-instruct",
        "qwen/qwen3-vl-30b-a3b-thinking",
        "qwen/qwen3-vl-32b-instruct",
        "qwen/qwen3-vl-8b-instruct",
        "qwen/qwen3-vl-8b-thinking",
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-27b",
        "qwen/qwen3.5-35b-a3b",
        "qwen/qwen3.5-397b-a17b",
        "qwen/qwen3.5-9b",
        "qwen/qwen3.5-flash-02-23",
        "qwen/qwen3.5-plus-02-15",
        "qwen/qwen3.5-plus-20260420",
        "qwen/qwen3.6-27b",
        "qwen/qwen3.6-35b-a3b",
        "qwen/qwen3.6-flash",
        "qwen/qwen3.6-max-preview",
        "qwen/qwen3.6-plus",
        "qwen/qwen3.7-max",
        "rekaai/reka-edge",
        "rekaai/reka-flash-3",
        "relace/relace-apply-3",
        "relace/relace-search",
        "sao10k/l3-euryale-70b",
        "sao10k/l3-lunaris-8b",
        "sao10k/l3.1-70b-hanami-x1",
        "sao10k/l3.1-euryale-70b",
        "sao10k/l3.3-euryale-70b",
        "stepfun/step-3.5-flash",
        "switchpoint/router",
        "tencent/hunyuan-a13b-instruct",
        "tencent/hy3-preview",
        "thedrummer/cydonia-24b-v4.1",
        "thedrummer/rocinante-12b",
        "thedrummer/skyfall-36b-v2",
        "thedrummer/unslopnemo-12b",
        "undi95/remm-slerp-l2-13b",
        "upstage/solar-pro-3",
        "writer/palmyra-x5",
        "x-ai/grok-4.20",
        "x-ai/grok-4.20-multi-agent",
        "x-ai/grok-4.3",
        "x-ai/grok-build-0.1",
        "xiaomi/mimo-v2-flash",
        "xiaomi/mimo-v2-omni",
        "xiaomi/mimo-v2-pro",
        "xiaomi/mimo-v2.5",
        "xiaomi/mimo-v2.5-pro",
        "z-ai/glm-4-32b",
        "z-ai/glm-4.5",
        "z-ai/glm-4.5-air",
        "z-ai/glm-4.5-air:free",
        "z-ai/glm-4.5v",
        "z-ai/glm-4.6",
        "z-ai/glm-4.6v",
        "z-ai/glm-4.7",
        "z-ai/glm-4.7-flash",
        "z-ai/glm-5",
        "z-ai/glm-5-turbo",
        "z-ai/glm-5.1",
        "z-ai/glm-5v-turbo",
        "~anthropic/claude-haiku-latest",
        "~anthropic/claude-opus-latest",
        "~anthropic/claude-sonnet-latest",
        "~google/gemini-flash-latest",
        "~google/gemini-pro-latest",
        "~moonshotai/kimi-latest",
        "~openai/gpt-latest",
        "~openai/gpt-mini-latest"
      ],
      "docUrl": "https://openrouter.ai/models",
      "gateway": "models.dev",
      "npm": "@openrouter/ai-sdk-provider"
    },
    "regolo-ai": {
      "url": "https://api.regolo.ai/v1",
      "apiKeyEnvVar": "REGOLO_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Regolo AI",
      "models": [
        "gpt-oss-120b",
        "gpt-oss-20b",
        "llama-3.1-8b-instruct",
        "llama-3.3-70b-instruct",
        "minimax-m2.5",
        "mistral-small-4-119b",
        "mistral-small3.2",
        "qwen-image",
        "qwen3-coder-next",
        "qwen3-embedding-8b",
        "qwen3-reranker-4b",
        "qwen3.5-122b",
        "qwen3.5-9b"
      ],
      "docUrl": "https://docs.regolo.ai/",
      "gateway": "models.dev"
    },
    "claudinio": {
      "url": "https://api.claudin.io/v1",
      "apiKeyEnvVar": "CLAUDINIO_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Claudinio",
      "models": ["claudinio"],
      "docUrl": "https://claudin.io",
      "gateway": "models.dev"
    },
    "orcarouter": {
      "url": "https://api.orcarouter.ai/v1",
      "apiKeyEnvVar": "ORCAROUTER_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "OrcaRouter",
      "models": [
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "deepseek/deepseek-chat",
        "deepseek/deepseek-reasoner",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-pro",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash-preview",
        "google/gemini-3-pro-preview",
        "google/gemini-3.1-flash-lite-preview",
        "google/gemini-3.1-pro-preview",
        "google/gemini-3.1-pro-preview-customtools",
        "google/gemini-flash-latest",
        "google/gemini-flash-lite-latest",
        "google/gemma-4-26b-a4b-it",
        "google/gemma-4-31b-it",
        "grok/grok-4.3",
        "kimi/kimi-k2.5",
        "kimi/kimi-k2.6",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5-highspeed",
        "minimax/minimax-m2.7",
        "minimax/minimax-m2.7-highspeed",
        "openai/gpt-3.5-turbo",
        "openai/gpt-4",
        "openai/gpt-4-turbo",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-2024-05-13",
        "openai/gpt-4o-2024-08-06",
        "openai/gpt-4o-2024-11-20",
        "openai/gpt-4o-mini",
        "openai/gpt-5",
        "openai/gpt-5-chat-latest",
        "openai/gpt-5-codex",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-chat-latest",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat-latest",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-chat-latest",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "orcarouter/auto",
        "qwen/qwen3-max",
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-27b",
        "qwen/qwen3.5-35b-a3b",
        "qwen/qwen3.5-397b-a17b",
        "qwen/qwen3.5-plus",
        "qwen/qwen3.6-35b-a3b",
        "qwen/qwen3.6-plus",
        "z-ai/glm-4.5",
        "z-ai/glm-4.5-air",
        "z-ai/glm-4.6",
        "z-ai/glm-4.7",
        "z-ai/glm-5",
        "z-ai/glm-5.1"
      ],
      "docUrl": "https://docs.orcarouter.ai",
      "gateway": "models.dev"
    },
    "opencode-go": {
      "url": "https://opencode.ai/zen/go/v1",
      "apiKeyEnvVar": "OPENCODE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "OpenCode Go",
      "models": [
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "glm-5",
        "glm-5.1",
        "kimi-k2.5",
        "kimi-k2.6",
        "mimo-v2.5",
        "mimo-v2.5-pro",
        "minimax-m2.5",
        "minimax-m2.7",
        "qwen3.5-plus",
        "qwen3.6-plus"
      ],
      "docUrl": "https://opencode.ai/docs/zen",
      "gateway": "models.dev"
    },
    "llmgateway": {
      "url": "https://api.llmgateway.io/v1",
      "apiKeyEnvVar": "LLMGATEWAY_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "LLM Gateway",
      "models": [
        "auto",
        "claude-3-5-sonnet-20241022",
        "claude-3-7-sonnet",
        "claude-3-7-sonnet-20250219",
        "claude-3-opus",
        "claude-haiku-4-5",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-1-20250805",
        "claude-opus-4-20250514",
        "claude-opus-4-5-20251101",
        "claude-opus-4-6",
        "claude-opus-4-7",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5",
        "claude-sonnet-4-5-20250929",
        "claude-sonnet-4-6",
        "codestral-2508",
        "custom",
        "deepseek-r1-0528",
        "deepseek-v3.1",
        "deepseek-v3.2",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "devstral-2512",
        "devstral-small-2507",
        "gemini-2.0-flash",
        "gemini-2.0-flash-lite",
        "gemini-2.5-flash",
        "gemini-2.5-flash-lite",
        "gemini-2.5-pro",
        "gemini-3-flash-preview",
        "gemini-3.1-flash-lite",
        "gemini-3.1-flash-lite-preview",
        "gemini-3.1-pro-preview",
        "gemini-3.5-flash",
        "gemini-pro-latest",
        "gemma-2-27b-it-together",
        "gemma-3-1b-it",
        "gemma-3-27b",
        "glm-4-32b-0414-128k",
        "glm-4.5",
        "glm-4.5-air",
        "glm-4.5-airx",
        "glm-4.5-flash",
        "glm-4.5-x",
        "glm-4.5v",
        "glm-4.6",
        "glm-4.6v",
        "glm-4.6v-flash",
        "glm-4.6v-flashx",
        "glm-4.7",
        "glm-4.7-flash",
        "glm-4.7-flashx",
        "glm-5",
        "glm-5.1",
        "gpt-3.5-turbo",
        "gpt-4",
        "gpt-4-turbo",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-4.1-nano",
        "gpt-4o",
        "gpt-4o-mini",
        "gpt-4o-mini-search-preview",
        "gpt-4o-search-preview",
        "gpt-5",
        "gpt-5-chat-latest",
        "gpt-5-mini",
        "gpt-5-nano",
        "gpt-5-pro",
        "gpt-5.1",
        "gpt-5.1-codex",
        "gpt-5.1-codex-mini",
        "gpt-5.2",
        "gpt-5.2-chat-latest",
        "gpt-5.2-codex",
        "gpt-5.2-pro",
        "gpt-5.3-chat-latest",
        "gpt-5.3-codex",
        "gpt-5.4",
        "gpt-5.4-mini",
        "gpt-5.4-nano",
        "gpt-5.4-pro",
        "gpt-5.5",
        "gpt-5.5-pro",
        "gpt-oss-120b",
        "gpt-oss-20b",
        "grok-4-0709",
        "grok-4-1-fast-reasoning",
        "grok-4-20-beta-0309-non-reasoning",
        "grok-4-20-beta-0309-reasoning",
        "grok-4-20-non-reasoning",
        "grok-4-20-reasoning",
        "grok-4-3",
        "grok-4-fast-reasoning",
        "hermes-2-pro-llama-3-8b",
        "kimi-k2",
        "kimi-k2-thinking",
        "kimi-k2-thinking-turbo",
        "kimi-k2.5",
        "kimi-k2.6",
        "llama-3-70b-instruct",
        "llama-3-8b-instruct",
        "llama-3.1-70b-instruct",
        "llama-3.1-8b-instruct",
        "llama-3.1-nemotron-ultra-253b",
        "llama-3.2-11b-instruct",
        "llama-3.2-3b-instruct",
        "llama-3.3-70b-instruct",
        "llama-4-maverick-17b-instruct",
        "llama-4-scout",
        "llama-4-scout-17b-instruct",
        "mimo-v2-flash",
        "mimo-v2-omni",
        "mimo-v2-pro",
        "mimo-v2.5",
        "mimo-v2.5-pro",
        "minimax-m2",
        "minimax-m2.1",
        "minimax-m2.1-lightning",
        "minimax-m2.5",
        "minimax-m2.5-highspeed",
        "minimax-m2.7",
        "minimax-m2.7-highspeed",
        "minimax-text-01",
        "ministral-14b-2512",
        "ministral-3b-2512",
        "ministral-8b-2512",
        "mistral-large-2512",
        "mistral-large-latest",
        "mistral-small-2506",
        "o1",
        "o3",
        "o3-mini",
        "o4-mini",
        "pixtral-large-latest",
        "qwen-coder-plus",
        "qwen-flash",
        "qwen-max",
        "qwen-max-latest",
        "qwen-omni-turbo",
        "qwen-plus",
        "qwen-plus-latest",
        "qwen-turbo",
        "qwen-vl-max",
        "qwen-vl-plus",
        "qwen2-5-vl-32b-instruct",
        "qwen2-5-vl-72b-instruct",
        "qwen25-coder-7b",
        "qwen3-235b-a22b-fp8",
        "qwen3-235b-a22b-instruct-2507",
        "qwen3-235b-a22b-thinking-2507",
        "qwen3-30b-a3b-fp8",
        "qwen3-30b-a3b-instruct-2507",
        "qwen3-30b-a3b-thinking-2507",
        "qwen3-32b",
        "qwen3-32b-fp8",
        "qwen3-4b-fp8",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-coder-flash",
        "qwen3-coder-next",
        "qwen3-coder-plus",
        "qwen3-max",
        "qwen3-max-2026-01-23",
        "qwen3-next-80b-a3b-instruct",
        "qwen3-next-80b-a3b-thinking",
        "qwen3-vl-235b-a22b-instruct",
        "qwen3-vl-235b-a22b-thinking",
        "qwen3-vl-30b-a3b-instruct",
        "qwen3-vl-30b-a3b-thinking",
        "qwen3-vl-8b-instruct",
        "qwen3-vl-flash",
        "qwen3-vl-plus",
        "qwen3.6-35b-a3b",
        "qwen3.6-max-preview",
        "qwen3.6-plus",
        "qwen35-397b-a17b",
        "qwen37-max",
        "qwq-plus",
        "seed-1-6-250615",
        "seed-1-6-250915",
        "seed-1-6-flash-250715",
        "seed-1-8-251228",
        "sonar",
        "sonar-pro",
        "sonar-reasoning-pro"
      ],
      "docUrl": "https://llmgateway.io/docs",
      "gateway": "models.dev"
    },
    "poe": {
      "url": "https://api.poe.com/v1",
      "apiKeyEnvVar": "POE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Poe",
      "models": [
        "anthropic/claude-haiku-3",
        "anthropic/claude-haiku-3.5",
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-sonnet-3.7",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "cerebras/gpt-oss-120b-cs",
        "cerebras/llama-3.1-8b-cs",
        "elevenlabs/elevenlabs-music",
        "elevenlabs/elevenlabs-v2.5-turbo",
        "elevenlabs/elevenlabs-v3",
        "empiriolabs/deepseek-v4-flash-el",
        "empiriolabs/deepseek-v4-pro-el",
        "fireworks-ai/kimi-k2.5-fw",
        "google/gemini-2.0-flash",
        "google/gemini-2.0-flash-lite",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash",
        "google/gemini-3.1-flash-lite",
        "google/gemini-3.1-pro",
        "google/gemini-3.5-flash",
        "google/gemma-4-31b",
        "google/imagen-3",
        "google/imagen-3-fast",
        "google/imagen-4",
        "google/imagen-4-fast",
        "google/imagen-4-ultra",
        "google/lyria",
        "google/nano-banana",
        "google/nano-banana-pro",
        "google/veo-2",
        "google/veo-3",
        "google/veo-3-fast",
        "google/veo-3.1",
        "google/veo-3.1-fast",
        "ideogramai/ideogram",
        "ideogramai/ideogram-v2",
        "ideogramai/ideogram-v2a",
        "ideogramai/ideogram-v2a-turbo",
        "lumalabs/ray2",
        "novita/deepseek-v3.2",
        "novita/glm-4.6",
        "novita/glm-4.6v",
        "novita/glm-4.7-flash",
        "novita/glm-4.7-n",
        "novita/glm-5",
        "novita/kimi-k2-thinking",
        "novita/kimi-k2.5",
        "novita/kimi-k2.6",
        "novita/minimax-m2.1",
        "openai/dall-e-3",
        "openai/gpt-3.5-turbo",
        "openai/gpt-3.5-turbo-instruct",
        "openai/gpt-3.5-turbo-raw",
        "openai/gpt-4-turbo",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-aug",
        "openai/gpt-4o-mini",
        "openai/gpt-4o-mini-search",
        "openai/gpt-4o-search",
        "openai/gpt-5",
        "openai/gpt-5-chat",
        "openai/gpt-5-codex",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.1-instant",
        "openai/gpt-5.2",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-instant",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.3-codex-spark",
        "openai/gpt-5.3-instant",
        "openai/gpt-5.4",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "openai/gpt-image-1",
        "openai/gpt-image-1-mini",
        "openai/gpt-image-1.5",
        "openai/gpt-image-2",
        "openai/o1",
        "openai/o1-pro",
        "openai/o3",
        "openai/o3-deep-research",
        "openai/o3-mini",
        "openai/o3-mini-high",
        "openai/o3-pro",
        "openai/o4-mini",
        "openai/o4-mini-deep-research",
        "openai/sora-2",
        "openai/sora-2-pro",
        "poetools/claude-code",
        "runwayml/runway",
        "runwayml/runway-gen-4-turbo",
        "stabilityai/stablediffusionxl",
        "topazlabs-co/topazlabs",
        "trytako/tako",
        "xai/grok-3",
        "xai/grok-3-mini",
        "xai/grok-4",
        "xai/grok-4-fast-non-reasoning",
        "xai/grok-4-fast-reasoning",
        "xai/grok-4.1-fast-non-reasoning",
        "xai/grok-4.1-fast-reasoning",
        "xai/grok-4.20-multi-agent",
        "xai/grok-code-fast-1"
      ],
      "docUrl": "https://creator.poe.com/docs/external-applications/openai-compatible-api",
      "gateway": "models.dev"
    },
    "minimax": {
      "url": "https://api.minimax.io/anthropic/v1",
      "apiKeyEnvVar": "MINIMAX_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "MiniMax (minimax.io)",
      "models": [
        "MiniMax-M2",
        "MiniMax-M2.1",
        "MiniMax-M2.5",
        "MiniMax-M2.5-highspeed",
        "MiniMax-M2.7",
        "MiniMax-M2.7-highspeed"
      ],
      "docUrl": "https://platform.minimax.io/docs/guides/quickstart",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "groq": {
      "url": "https://api.groq.com/openai/v1",
      "apiKeyEnvVar": "GROQ_API_KEY",
      "name": "Groq",
      "models": [
        "allam-2-7b",
        "canopylabs/orpheus-arabic-saudi",
        "canopylabs/orpheus-v1-english",
        "groq/compound",
        "groq/compound-mini",
        "llama-3.1-8b-instant",
        "llama-3.3-70b-versatile",
        "meta-llama/llama-4-scout-17b-16e-instruct",
        "meta-llama/llama-prompt-guard-2-22m",
        "meta-llama/llama-prompt-guard-2-86m",
        "moonshotai/kimi-k2-instruct-0905",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "openai/gpt-oss-safeguard-20b",
        "qwen/qwen3-32b",
        "whisper-large-v3",
        "whisper-large-v3-turbo"
      ],
      "docUrl": "https://console.groq.com/docs/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/groq"
    },
    "xiaomi-token-plan-sgp": {
      "url": "https://token-plan-sgp.xiaomimimo.com/v1",
      "apiKeyEnvVar": "XIAOMI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Xiaomi Token Plan (Singapore)",
      "models": ["mimo-v2-flash", "mimo-v2-omni", "mimo-v2-pro", "mimo-v2-tts", "mimo-v2.5", "mimo-v2.5-pro"],
      "docUrl": "https://platform.xiaomimimo.com/#/docs",
      "gateway": "models.dev"
    },
    "siliconflow": {
      "url": "https://api.siliconflow.com/v1",
      "apiKeyEnvVar": "SILICONFLOW_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "SiliconFlow",
      "models": [
        "ByteDance-Seed/Seed-OSS-36B-Instruct",
        "MiniMaxAI/MiniMax-M2.1",
        "MiniMaxAI/MiniMax-M2.5",
        "Qwen/QwQ-32B",
        "Qwen/Qwen2.5-14B-Instruct",
        "Qwen/Qwen2.5-32B-Instruct",
        "Qwen/Qwen2.5-72B-Instruct",
        "Qwen/Qwen2.5-72B-Instruct-128K",
        "Qwen/Qwen2.5-7B-Instruct",
        "Qwen/Qwen2.5-Coder-32B-Instruct",
        "Qwen/Qwen2.5-VL-32B-Instruct",
        "Qwen/Qwen2.5-VL-72B-Instruct",
        "Qwen/Qwen2.5-VL-7B-Instruct",
        "Qwen/Qwen3-14B",
        "Qwen/Qwen3-235B-A22B",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-30B-A3B-Thinking-2507",
        "Qwen/Qwen3-32B",
        "Qwen/Qwen3-8B",
        "Qwen/Qwen3-Coder-30B-A3B-Instruct",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "Qwen/Qwen3-Next-80B-A3B-Instruct",
        "Qwen/Qwen3-Next-80B-A3B-Thinking",
        "Qwen/Qwen3-Omni-30B-A3B-Captioner",
        "Qwen/Qwen3-Omni-30B-A3B-Instruct",
        "Qwen/Qwen3-Omni-30B-A3B-Thinking",
        "Qwen/Qwen3-VL-235B-A22B-Instruct",
        "Qwen/Qwen3-VL-235B-A22B-Thinking",
        "Qwen/Qwen3-VL-30B-A3B-Instruct",
        "Qwen/Qwen3-VL-30B-A3B-Thinking",
        "Qwen/Qwen3-VL-32B-Instruct",
        "Qwen/Qwen3-VL-32B-Thinking",
        "Qwen/Qwen3-VL-8B-Instruct",
        "Qwen/Qwen3-VL-8B-Thinking",
        "THUDM/GLM-4-32B-0414",
        "THUDM/GLM-4-9B-0414",
        "THUDM/GLM-Z1-32B-0414",
        "THUDM/GLM-Z1-9B-0414",
        "baidu/ERNIE-4.5-300B-A47B",
        "deepseek-ai/DeepSeek-R1",
        "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
        "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
        "deepseek-ai/DeepSeek-V3",
        "deepseek-ai/DeepSeek-V3.1",
        "deepseek-ai/DeepSeek-V3.1-Terminus",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/DeepSeek-V3.2-Exp",
        "deepseek-ai/deepseek-v4-flash",
        "deepseek-ai/deepseek-v4-pro",
        "deepseek-ai/deepseek-vl2",
        "inclusionAI/Ling-flash-2.0",
        "inclusionAI/Ling-mini-2.0",
        "inclusionAI/Ring-flash-2.0",
        "meta-llama/Meta-Llama-3.1-8B-Instruct",
        "moonshotai/Kimi-K2-Instruct",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/Kimi-K2-Thinking",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "nex-agi/DeepSeek-V3.1-Nex-N1",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "stepfun-ai/Step-3.5-Flash",
        "tencent/Hunyuan-A13B-Instruct",
        "tencent/Hunyuan-MT-7B",
        "zai-org/GLM-4.5",
        "zai-org/GLM-4.5-Air",
        "zai-org/GLM-4.5V",
        "zai-org/GLM-4.6",
        "zai-org/GLM-4.6V",
        "zai-org/GLM-4.7",
        "zai-org/GLM-5",
        "zai-org/GLM-5.1",
        "zai-org/GLM-5V-Turbo"
      ],
      "docUrl": "https://cloud.siliconflow.com/models",
      "gateway": "models.dev"
    },
    "ollama-cloud": {
      "url": "https://ollama.com/v1",
      "apiKeyEnvVar": "OLLAMA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Ollama Cloud",
      "models": [
        "cogito-2.1:671b",
        "deepseek-v3.1:671b",
        "deepseek-v3.2",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "devstral-2:123b",
        "devstral-small-2:24b",
        "gemini-3-flash-preview",
        "gemma3:12b",
        "gemma3:27b",
        "gemma3:4b",
        "gemma4:31b",
        "glm-4.6",
        "glm-4.7",
        "glm-5",
        "glm-5.1",
        "gpt-oss:120b",
        "gpt-oss:20b",
        "kimi-k2-thinking",
        "kimi-k2.5",
        "kimi-k2.6",
        "kimi-k2:1t",
        "minimax-m2",
        "minimax-m2.1",
        "minimax-m2.5",
        "minimax-m2.7",
        "ministral-3:14b",
        "ministral-3:3b",
        "ministral-3:8b",
        "mistral-large-3:675b",
        "nemotron-3-nano:30b",
        "nemotron-3-super",
        "qwen3-coder-next",
        "qwen3-coder:480b",
        "qwen3-next:80b",
        "qwen3-vl:235b",
        "qwen3-vl:235b-instruct",
        "qwen3.5:397b",
        "rnj-1:8b"
      ],
      "docUrl": "https://docs.ollama.com/cloud",
      "gateway": "models.dev"
    },
    "databricks": {
      "url": "https://${DATABRICKS_HOST}/ai-gateway/mlflow/v1",
      "apiKeyEnvVar": "DATABRICKS_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "Databricks",
      "models": [
        "databricks-claude-haiku-4-5",
        "databricks-claude-opus-4-1",
        "databricks-claude-opus-4-5",
        "databricks-claude-opus-4-6",
        "databricks-claude-opus-4-7",
        "databricks-claude-sonnet-4",
        "databricks-claude-sonnet-4-5",
        "databricks-claude-sonnet-4-6",
        "databricks-gemini-2-5-flash",
        "databricks-gemini-2-5-pro",
        "databricks-gemini-3-1-flash-lite",
        "databricks-gemini-3-1-pro",
        "databricks-gemini-3-flash",
        "databricks-gemini-3-pro",
        "databricks-gpt-5",
        "databricks-gpt-5-1",
        "databricks-gpt-5-2",
        "databricks-gpt-5-4",
        "databricks-gpt-5-4-mini",
        "databricks-gpt-5-4-nano",
        "databricks-gpt-5-5",
        "databricks-gpt-5-mini",
        "databricks-gpt-5-nano",
        "databricks-gpt-oss-120b",
        "databricks-gpt-oss-20b"
      ],
      "docUrl": "https://docs.databricks.com/aws/en/machine-learning/foundation-models/",
      "gateway": "models.dev"
    },
    "berget": {
      "url": "https://api.berget.ai/v1",
      "apiKeyEnvVar": "BERGET_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Berget.AI",
      "models": [
        "google/gemma-4-31B-it",
        "meta-llama/Llama-3.3-70B-Instruct",
        "mistralai/Mistral-Medium-3.5-128B",
        "mistralai/Mistral-Small-3.2-24B-Instruct-2506",
        "moonshotai/Kimi-K2.6",
        "openai/gpt-oss-120b",
        "zai-org/GLM-4.7"
      ],
      "docUrl": "https://api.berget.ai",
      "gateway": "models.dev"
    },
    "moonshotai-cn": {
      "url": "https://api.moonshot.cn/anthropic/v1",
      "apiKeyEnvVar": "MOONSHOT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Moonshot AI (China)",
      "models": [
        "kimi-k2-0711-preview",
        "kimi-k2-0905-preview",
        "kimi-k2-thinking",
        "kimi-k2-thinking-turbo",
        "kimi-k2-turbo-preview",
        "kimi-k2.5",
        "kimi-k2.6"
      ],
      "docUrl": "https://platform.moonshot.cn/docs/api/chat",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "alibaba-coding-plan-cn": {
      "url": "https://coding.dashscope.aliyuncs.com/v1",
      "apiKeyEnvVar": "ALIBABA_CODING_PLAN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Alibaba Coding Plan (China)",
      "models": [
        "MiniMax-M2.5",
        "glm-4.7",
        "glm-5",
        "kimi-k2.5",
        "qwen3-coder-next",
        "qwen3-coder-plus",
        "qwen3-max-2026-01-23",
        "qwen3.5-plus",
        "qwen3.6-plus"
      ],
      "docUrl": "https://help.aliyun.com/zh/model-studio/coding-plan",
      "gateway": "models.dev"
    },
    "minimax-cn": {
      "url": "https://api.minimaxi.com/anthropic/v1",
      "apiKeyEnvVar": "MINIMAX_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "MiniMax (minimaxi.com)",
      "models": [
        "MiniMax-M2",
        "MiniMax-M2.1",
        "MiniMax-M2.5",
        "MiniMax-M2.5-highspeed",
        "MiniMax-M2.7",
        "MiniMax-M2.7-highspeed"
      ],
      "docUrl": "https://platform.minimaxi.com/docs/guides/quickstart",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "chutes": {
      "url": "https://llm.chutes.ai/v1",
      "apiKeyEnvVar": "CHUTES_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Chutes",
      "models": [
        "MiniMaxAI/MiniMax-M2.5-TEE",
        "NousResearch/DeepHermes-3-Mistral-24B-Preview",
        "NousResearch/Hermes-4-14B",
        "Qwen/Qwen2.5-72B-Instruct",
        "Qwen/Qwen2.5-Coder-32B-Instruct",
        "Qwen/Qwen2.5-VL-32B-Instruct",
        "Qwen/Qwen3-235B-A22B-Instruct-2507-TEE",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-30B-A3B",
        "Qwen/Qwen3-32B-TEE",
        "Qwen/Qwen3-Coder-Next-TEE",
        "Qwen/Qwen3-Next-80B-A3B-Instruct",
        "Qwen/Qwen3.5-397B-A17B-TEE",
        "Qwen/Qwen3.6-27B-TEE",
        "Qwen/Qwen3Guard-Gen-0.6B",
        "XiaomiMiMo/MiMo-V2-Flash-TEE",
        "deepseek-ai/DeepSeek-R1-0528-TEE",
        "deepseek-ai/DeepSeek-R1-Distill-Llama-70B",
        "deepseek-ai/DeepSeek-V3-0324-TEE",
        "deepseek-ai/DeepSeek-V3.1-TEE",
        "deepseek-ai/DeepSeek-V3.2-TEE",
        "google/gemma-4-31B-turbo-TEE",
        "moonshotai/Kimi-K2.5-TEE",
        "moonshotai/Kimi-K2.6-TEE",
        "openai/gpt-oss-120b-TEE",
        "rednote-hilab/dots.ocr",
        "tngtech/DeepSeek-TNG-R1T2-Chimera-TEE",
        "unsloth/Llama-3.2-1B-Instruct",
        "unsloth/Llama-3.2-3B-Instruct",
        "unsloth/Mistral-Nemo-Instruct-2407",
        "unsloth/gemma-3-12b-it",
        "unsloth/gemma-3-27b-it",
        "unsloth/gemma-3-4b-it",
        "zai-org/GLM-4.6V",
        "zai-org/GLM-4.7-FP8",
        "zai-org/GLM-4.7-TEE",
        "zai-org/GLM-5-TEE",
        "zai-org/GLM-5-Turbo",
        "zai-org/GLM-5.1-TEE"
      ],
      "docUrl": "https://llm.chutes.ai/v1/models",
      "gateway": "models.dev"
    },
    "siliconflow-cn": {
      "url": "https://api.siliconflow.cn/v1",
      "apiKeyEnvVar": "SILICONFLOW_CN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "SiliconFlow (China)",
      "models": [
        "ByteDance-Seed/Seed-OSS-36B-Instruct",
        "Kwaipilot/KAT-Dev",
        "PaddlePaddle/PaddleOCR-VL",
        "PaddlePaddle/PaddleOCR-VL-1.5",
        "Pro/MiniMaxAI/MiniMax-M2.1",
        "Pro/MiniMaxAI/MiniMax-M2.5",
        "Pro/deepseek-ai/DeepSeek-R1",
        "Pro/deepseek-ai/DeepSeek-V3",
        "Pro/deepseek-ai/DeepSeek-V3.1-Terminus",
        "Pro/deepseek-ai/DeepSeek-V3.2",
        "Pro/moonshotai/Kimi-K2-Instruct-0905",
        "Pro/moonshotai/Kimi-K2-Thinking",
        "Pro/moonshotai/Kimi-K2.5",
        "Pro/moonshotai/Kimi-K2.6",
        "Pro/zai-org/GLM-4.7",
        "Pro/zai-org/GLM-5",
        "Pro/zai-org/GLM-5.1",
        "Qwen/QwQ-32B",
        "Qwen/Qwen2.5-14B-Instruct",
        "Qwen/Qwen2.5-32B-Instruct",
        "Qwen/Qwen2.5-72B-Instruct",
        "Qwen/Qwen2.5-72B-Instruct-128K",
        "Qwen/Qwen2.5-7B-Instruct",
        "Qwen/Qwen2.5-Coder-32B-Instruct",
        "Qwen/Qwen2.5-VL-32B-Instruct",
        "Qwen/Qwen2.5-VL-72B-Instruct",
        "Qwen/Qwen3-14B",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-30B-A3B-Thinking-2507",
        "Qwen/Qwen3-32B",
        "Qwen/Qwen3-8B",
        "Qwen/Qwen3-Coder-30B-A3B-Instruct",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "Qwen/Qwen3-Next-80B-A3B-Instruct",
        "Qwen/Qwen3-Next-80B-A3B-Thinking",
        "Qwen/Qwen3-Omni-30B-A3B-Captioner",
        "Qwen/Qwen3-Omni-30B-A3B-Instruct",
        "Qwen/Qwen3-Omni-30B-A3B-Thinking",
        "Qwen/Qwen3-VL-235B-A22B-Instruct",
        "Qwen/Qwen3-VL-235B-A22B-Thinking",
        "Qwen/Qwen3-VL-30B-A3B-Instruct",
        "Qwen/Qwen3-VL-30B-A3B-Thinking",
        "Qwen/Qwen3-VL-32B-Instruct",
        "Qwen/Qwen3-VL-32B-Thinking",
        "Qwen/Qwen3-VL-8B-Instruct",
        "Qwen/Qwen3-VL-8B-Thinking",
        "Qwen/Qwen3.5-122B-A10B",
        "Qwen/Qwen3.5-27B",
        "Qwen/Qwen3.5-35B-A3B",
        "Qwen/Qwen3.5-397B-A17B",
        "Qwen/Qwen3.5-4B",
        "Qwen/Qwen3.5-9B",
        "Qwen/Qwen3.6-35B-A3B",
        "THUDM/GLM-4-32B-0414",
        "THUDM/GLM-4-9B-0414",
        "THUDM/GLM-Z1-32B-0414",
        "THUDM/GLM-Z1-9B-0414",
        "ascend-tribe/pangu-pro-moe",
        "baidu/ERNIE-4.5-300B-A47B",
        "deepseek-ai/DeepSeek-OCR",
        "deepseek-ai/DeepSeek-R1",
        "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
        "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
        "deepseek-ai/DeepSeek-V3",
        "deepseek-ai/DeepSeek-V3.1-Terminus",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/deepseek-vl2",
        "inclusionAI/Ling-flash-2.0",
        "inclusionAI/Ling-mini-2.0",
        "inclusionAI/Ring-flash-2.0",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/Kimi-K2-Thinking",
        "stepfun-ai/Step-3.5-Flash",
        "tencent/Hunyuan-A13B-Instruct",
        "tencent/Hunyuan-MT-7B",
        "zai-org/GLM-4.5-Air",
        "zai-org/GLM-4.5V",
        "zai-org/GLM-4.6",
        "zai-org/GLM-4.6V"
      ],
      "docUrl": "https://cloud.siliconflow.com/models",
      "gateway": "models.dev"
    },
    "nvidia": {
      "url": "https://integrate.api.nvidia.com/v1",
      "apiKeyEnvVar": "NVIDIA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Nvidia",
      "models": [
        "abacusai/dracarys-llama-3_1-70b-instruct",
        "baai/bge-m3",
        "black-forest-labs/flux.1-dev",
        "black-forest-labs/flux_1-kontext-dev",
        "black-forest-labs/flux_1-schnell",
        "black-forest-labs/flux_2-klein-4b",
        "bytedance/seed-oss-36b-instruct",
        "deepseek-ai/deepseek-v3.1-terminus",
        "deepseek-ai/deepseek-v3.2",
        "deepseek-ai/deepseek-v4-flash",
        "deepseek-ai/deepseek-v4-pro",
        "google/gemma-2-2b-it",
        "google/gemma-3-27b-it",
        "google/gemma-3n-e2b-it",
        "google/gemma-3n-e4b-it",
        "google/gemma-4-31b-it",
        "google/google-paligemma",
        "meta/esm2-650m",
        "meta/esmfold",
        "meta/llama-3.1-70b-instruct",
        "meta/llama-3.1-8b-instruct",
        "meta/llama-3.2-11b-vision-instruct",
        "meta/llama-3.2-1b-instruct",
        "meta/llama-3.2-3b-instruct",
        "meta/llama-3.2-90b-vision-instruct",
        "meta/llama-3.3-70b-instruct",
        "meta/llama-4-maverick-17b-128e-instruct",
        "meta/llama-guard-4-12b",
        "microsoft/phi-4-mini-instruct",
        "microsoft/phi-4-multimodal-instruct",
        "minimaxai/minimax-m2.5",
        "minimaxai/minimax-m2.7",
        "mistralai/devstral-2-123b-instruct-2512",
        "mistralai/magistral-small-2506",
        "mistralai/mistral-7b-instruct-v03",
        "mistralai/mistral-large-3-675b-instruct-2512",
        "mistralai/mistral-medium-3-instruct",
        "mistralai/mistral-nemotron",
        "mistralai/mistral-small-4-119b-2603",
        "mistralai/mixtral-8x22b-instruct",
        "mistralai/mixtral-8x7b-instruct",
        "moonshotai/kimi-k2-instruct",
        "moonshotai/kimi-k2-instruct-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2.6",
        "nvidia/active-speaker-detection",
        "nvidia/bevformer",
        "nvidia/cosmos-predict1-5b",
        "nvidia/cosmos-transfer1-7b",
        "nvidia/cosmos-transfer2_5-2b",
        "nvidia/gliner-pii",
        "nvidia/llama-3_1-nemotron-safety-guard-8b-v3",
        "nvidia/llama-3_2-nemoretriever-300m-embed-v1",
        "nvidia/llama-3_3-nemotron-super-49b-v1",
        "nvidia/llama-3_3-nemotron-super-49b-v1_5",
        "nvidia/llama-nemotron-embed-vl-1b-v2",
        "nvidia/llama-nemotron-rerank-vl-1b-v2",
        "nvidia/magpie-tts-zeroshot",
        "nvidia/nemotron-3-content-safety",
        "nvidia/nemotron-3-nano-30b-a3b",
        "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning",
        "nvidia/nemotron-3-super-120b-a12b",
        "nvidia/nemotron-content-safety-reasoning-4b",
        "nvidia/nemotron-mini-4b-instruct",
        "nvidia/nemotron-voicechat",
        "nvidia/nv-embed-v1",
        "nvidia/nv-embedcode-7b-v1",
        "nvidia/nvidia-nemotron-nano-9b-v2",
        "nvidia/rerank-qa-mistral-4b",
        "nvidia/riva-translate-4b-instruct-v1_1",
        "nvidia/sparsedrive",
        "nvidia/streampetr",
        "nvidia/studiovoice",
        "nvidia/synthetic-video-detector",
        "nvidia/usdcode",
        "nvidia/usdvalidate",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "openai/whisper-large-v3",
        "qwen/qwen-image",
        "qwen/qwen-image-edit",
        "qwen/qwen2.5-coder-32b-instruct",
        "qwen/qwen3-coder-480b-a35b-instruct",
        "qwen/qwen3-next-80b-a3b-instruct",
        "qwen/qwen3-next-80b-a3b-thinking",
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-397b-a17b",
        "sarvamai/sarvam-m",
        "stepfun-ai/step-3.5-flash",
        "upstage/solar-10_7b-instruct",
        "z-ai/glm-5.1",
        "z-ai/glm4.7"
      ],
      "docUrl": "https://docs.api.nvidia.com/nim/",
      "gateway": "models.dev"
    },
    "anthropic": {
      "apiKeyEnvVar": "ANTHROPIC_API_KEY",
      "name": "Anthropic",
      "models": [
        "claude-3-5-haiku-20241022",
        "claude-3-5-haiku-latest",
        "claude-3-5-sonnet-20240620",
        "claude-3-5-sonnet-20241022",
        "claude-3-7-sonnet-20250219",
        "claude-3-haiku-20240307",
        "claude-3-opus-20240229",
        "claude-3-sonnet-20240229",
        "claude-haiku-4-5",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-0",
        "claude-opus-4-1",
        "claude-opus-4-1-20250805",
        "claude-opus-4-20250514",
        "claude-opus-4-5",
        "claude-opus-4-5-20251101",
        "claude-opus-4-6",
        "claude-opus-4-7",
        "claude-sonnet-4-0",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5",
        "claude-sonnet-4-5-20250929",
        "claude-sonnet-4-6"
      ],
      "docUrl": "https://docs.anthropic.com/en/docs/about-claude/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "zhipuai-coding-plan": {
      "url": "https://open.bigmodel.cn/api/coding/paas/v4",
      "apiKeyEnvVar": "ZHIPU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Zhipu AI Coding Plan",
      "models": ["glm-4.5-air", "glm-4.7", "glm-5-turbo", "glm-5.1", "glm-5v-turbo"],
      "docUrl": "https://docs.bigmodel.cn/cn/coding-plan/overview",
      "gateway": "models.dev"
    },
    "atomic-chat": {
      "url": "http://127.0.0.1:1337/v1",
      "apiKeyEnvVar": "ATOMIC_CHAT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Atomic Chat",
      "models": [
        "Meta-Llama-3_1-8B-Instruct-GGUF",
        "Qwen3_5-9B-MLX-4bit",
        "Qwen3_5-9B-Q4_K_M",
        "gemma-4-E4B-it-IQ4_XS",
        "gemma-4-E4B-it-MLX-4bit"
      ],
      "docUrl": "https://atomic.chat",
      "gateway": "models.dev"
    },
    "github-models": {
      "url": "https://models.github.ai/inference",
      "apiKeyEnvVar": "GITHUB_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "GitHub Models",
      "models": [
        "ai21-labs/ai21-jamba-1.5-large",
        "ai21-labs/ai21-jamba-1.5-mini",
        "cohere/cohere-command-a",
        "cohere/cohere-command-r",
        "cohere/cohere-command-r-08-2024",
        "cohere/cohere-command-r-plus",
        "cohere/cohere-command-r-plus-08-2024",
        "core42/jais-30b-chat",
        "deepseek/deepseek-r1",
        "deepseek/deepseek-r1-0528",
        "deepseek/deepseek-v3-0324",
        "meta/llama-3.2-11b-vision-instruct",
        "meta/llama-3.2-90b-vision-instruct",
        "meta/llama-3.3-70b-instruct",
        "meta/llama-4-maverick-17b-128e-instruct-fp8",
        "meta/llama-4-scout-17b-16e-instruct",
        "meta/meta-llama-3-70b-instruct",
        "meta/meta-llama-3-8b-instruct",
        "meta/meta-llama-3.1-405b-instruct",
        "meta/meta-llama-3.1-70b-instruct",
        "meta/meta-llama-3.1-8b-instruct",
        "microsoft/mai-ds-r1",
        "microsoft/phi-3-medium-128k-instruct",
        "microsoft/phi-3-medium-4k-instruct",
        "microsoft/phi-3-mini-128k-instruct",
        "microsoft/phi-3-mini-4k-instruct",
        "microsoft/phi-3-small-128k-instruct",
        "microsoft/phi-3-small-8k-instruct",
        "microsoft/phi-3.5-mini-instruct",
        "microsoft/phi-3.5-moe-instruct",
        "microsoft/phi-3.5-vision-instruct",
        "microsoft/phi-4",
        "microsoft/phi-4-mini-instruct",
        "microsoft/phi-4-mini-reasoning",
        "microsoft/phi-4-multimodal-instruct",
        "microsoft/phi-4-reasoning",
        "mistral-ai/codestral-2501",
        "mistral-ai/ministral-3b",
        "mistral-ai/mistral-large-2411",
        "mistral-ai/mistral-medium-2505",
        "mistral-ai/mistral-nemo",
        "mistral-ai/mistral-small-2503",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-mini",
        "openai/o1",
        "openai/o1-mini",
        "openai/o1-preview",
        "openai/o3",
        "openai/o3-mini",
        "openai/o4-mini",
        "xai/grok-3",
        "xai/grok-3-mini"
      ],
      "docUrl": "https://docs.github.com/en/github-models",
      "gateway": "models.dev"
    },
    "qiniu-ai": {
      "url": "https://api.qnaigc.com/v1",
      "apiKeyEnvVar": "QINIU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Qiniu",
      "models": [
        "MiniMax-M1",
        "claude-3.5-haiku",
        "claude-3.5-sonnet",
        "claude-3.7-sonnet",
        "claude-4.0-opus",
        "claude-4.0-sonnet",
        "claude-4.1-opus",
        "claude-4.5-haiku",
        "claude-4.5-opus",
        "claude-4.5-sonnet",
        "deepseek-r1",
        "deepseek-r1-0528",
        "deepseek-v3",
        "deepseek-v3-0324",
        "deepseek-v3.1",
        "deepseek/deepseek-math-v2",
        "deepseek/deepseek-v3.1-terminus",
        "deepseek/deepseek-v3.1-terminus-thinking",
        "deepseek/deepseek-v3.2-251201",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v3.2-exp-thinking",
        "doubao-1.5-pro-32k",
        "doubao-1.5-thinking-pro",
        "doubao-1.5-vision-pro",
        "doubao-seed-1.6",
        "doubao-seed-1.6-flash",
        "doubao-seed-1.6-thinking",
        "doubao-seed-2.0-code",
        "doubao-seed-2.0-lite",
        "doubao-seed-2.0-mini",
        "doubao-seed-2.0-pro",
        "gemini-2.0-flash",
        "gemini-2.0-flash-lite",
        "gemini-2.5-flash",
        "gemini-2.5-flash-image",
        "gemini-2.5-flash-lite",
        "gemini-2.5-pro",
        "gemini-3.0-flash-preview",
        "gemini-3.0-pro-image-preview",
        "gemini-3.0-pro-preview",
        "glm-4.5",
        "glm-4.5-air",
        "gpt-oss-120b",
        "gpt-oss-20b",
        "kimi-k2",
        "kling-v2-6",
        "meituan/longcat-flash-chat",
        "meituan/longcat-flash-lite",
        "mimo-v2-flash",
        "minimax/minimax-m2",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5-highspeed",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2.5",
        "openai/gpt-5",
        "openai/gpt-5.2",
        "qwen-max-2025-01-25",
        "qwen-turbo",
        "qwen-vl-max-2025-01-25",
        "qwen2.5-vl-72b-instruct",
        "qwen2.5-vl-7b-instruct",
        "qwen3-235b-a22b",
        "qwen3-235b-a22b-instruct-2507",
        "qwen3-235b-a22b-thinking-2507",
        "qwen3-30b-a3b",
        "qwen3-30b-a3b-instruct-2507",
        "qwen3-30b-a3b-thinking-2507",
        "qwen3-32b",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-max",
        "qwen3-max-preview",
        "qwen3-next-80b-a3b-instruct",
        "qwen3-next-80b-a3b-thinking",
        "qwen3-vl-30b-a3b-thinking",
        "qwen3.5-397b-a17b",
        "stepfun-ai/gelab-zero-4b-preview",
        "stepfun/step-3.5-flash",
        "x-ai/grok-4-fast",
        "x-ai/grok-4-fast-non-reasoning",
        "x-ai/grok-4-fast-reasoning",
        "x-ai/grok-4.1-fast",
        "x-ai/grok-4.1-fast-non-reasoning",
        "x-ai/grok-4.1-fast-reasoning",
        "x-ai/grok-code-fast-1",
        "xiaomi/mimo-v2-flash",
        "z-ai/autoglm-phone-9b",
        "z-ai/glm-4.6",
        "z-ai/glm-4.7",
        "z-ai/glm-5"
      ],
      "docUrl": "https://developer.qiniu.com/aitokenapi",
      "gateway": "models.dev"
    },
    "google": {
      "apiKeyEnvVar": ["GOOGLE_API_KEY", "GOOGLE_GENERATIVE_AI_API_KEY"],
      "name": "Google",
      "models": [
        "gemini-2.0-flash",
        "gemini-2.0-flash-lite",
        "gemini-2.5-flash",
        "gemini-2.5-flash-image",
        "gemini-2.5-flash-lite",
        "gemini-2.5-flash-preview-tts",
        "gemini-2.5-pro",
        "gemini-2.5-pro-preview-tts",
        "gemini-3-flash-preview",
        "gemini-3-pro-preview",
        "gemini-3.1-flash-image-preview",
        "gemini-3.1-flash-lite",
        "gemini-3.1-flash-lite-preview",
        "gemini-3.1-pro-preview",
        "gemini-3.1-pro-preview-customtools",
        "gemini-3.5-flash",
        "gemini-embedding-001",
        "gemini-flash-latest",
        "gemini-flash-lite-latest",
        "gemma-4-26b-a4b-it",
        "gemma-4-31b-it"
      ],
      "docUrl": "https://ai.google.dev/gemini-api/docs/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/google"
    },
    "scaleway": {
      "url": "https://api.scaleway.ai/v1",
      "apiKeyEnvVar": "SCALEWAY_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Scaleway",
      "models": [
        "bge-multilingual-gemma2",
        "deepseek-r1-distill-llama-70b",
        "devstral-2-123b-instruct-2512",
        "gemma-3-27b-it",
        "gpt-oss-120b",
        "llama-3.1-8b-instruct",
        "llama-3.3-70b-instruct",
        "mistral-medium-3.5-128b",
        "mistral-nemo-instruct-2407",
        "mistral-small-3.2-24b-instruct-2506",
        "pixtral-12b-2409",
        "qwen3-235b-a22b-instruct-2507",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-embedding-8b",
        "qwen3.5-397b-a17b",
        "voxtral-small-24b-2507",
        "whisper-large-v3"
      ],
      "docUrl": "https://www.scaleway.com/en/docs/generative-apis/",
      "gateway": "models.dev"
    },
    "opencode": {
      "url": "https://opencode.ai/zen/v1",
      "apiKeyEnvVar": "OPENCODE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "OpenCode Zen",
      "models": [
        "big-pickle",
        "claude-haiku-4-5",
        "claude-opus-4-1",
        "claude-opus-4-5",
        "claude-opus-4-6",
        "claude-opus-4-7",
        "claude-sonnet-4",
        "claude-sonnet-4-5",
        "claude-sonnet-4-6",
        "deepseek-v4-flash-free",
        "gemini-3-flash",
        "gemini-3.1-pro",
        "gemini-3.5-flash",
        "glm-5",
        "glm-5.1",
        "gpt-5",
        "gpt-5-codex",
        "gpt-5-nano",
        "gpt-5.1",
        "gpt-5.1-codex",
        "gpt-5.1-codex-max",
        "gpt-5.1-codex-mini",
        "gpt-5.2",
        "gpt-5.2-codex",
        "gpt-5.3-codex",
        "gpt-5.3-codex-spark",
        "gpt-5.4",
        "gpt-5.4-mini",
        "gpt-5.4-nano",
        "gpt-5.4-pro",
        "gpt-5.5",
        "gpt-5.5-pro",
        "grok-build-0.1",
        "kimi-k2.5",
        "kimi-k2.6",
        "minimax-m2.5",
        "minimax-m2.7",
        "nemotron-3-super-free",
        "qwen3.5-plus",
        "qwen3.6-plus"
      ],
      "docUrl": "https://opencode.ai/docs/zen",
      "gateway": "models.dev"
    },
    "mixlayer": {
      "url": "https://models.mixlayer.ai/v1",
      "apiKeyEnvVar": "MIXLAYER_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Mixlayer",
      "models": [
        "qwen/qwen3.5-122b-a10b",
        "qwen/qwen3.5-27b",
        "qwen/qwen3.5-35b-a3b",
        "qwen/qwen3.5-397b-a17b",
        "qwen/qwen3.5-9b"
      ],
      "docUrl": "https://docs.mixlayer.com",
      "gateway": "models.dev"
    },
    "zenmux": {
      "url": "https://zenmux.ai/api/v1",
      "apiKeyEnvVar": "ZENMUX_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "ZenMux",
      "models": [
        "anthropic/claude-3.5-haiku",
        "anthropic/claude-3.7-sonnet",
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "baidu/ernie-5.0-thinking-preview",
        "deepseek/deepseek-chat",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-pro",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash-preview",
        "google/gemini-3.1-flash-lite-preview",
        "google/gemini-3.1-pro-preview",
        "inclusionai/ling-1t",
        "inclusionai/ring-1t",
        "kuaishou/kat-coder-pro-v2",
        "minimax/minimax-m2",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5-lightning",
        "minimax/minimax-m2.7",
        "minimax/minimax-m2.7-highspeed",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2-thinking-turbo",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.6",
        "openai/gpt-5",
        "openai/gpt-5-codex",
        "openai/gpt-5.1",
        "openai/gpt-5.1-chat",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-chat",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "qwen/qwen3-coder-plus",
        "qwen/qwen3-max",
        "qwen/qwen3.5-flash",
        "qwen/qwen3.5-plus",
        "qwen/qwen3.6-plus",
        "sapiens-ai/agnes-1.5-lite",
        "sapiens-ai/agnes-1.5-pro",
        "stepfun/step-3",
        "stepfun/step-3.5-flash",
        "stepfun/step-3.5-flash-free",
        "tencent/hy3-preview",
        "volcengine/doubao-seed-1.8",
        "volcengine/doubao-seed-2.0-code",
        "volcengine/doubao-seed-2.0-lite",
        "volcengine/doubao-seed-2.0-mini",
        "volcengine/doubao-seed-2.0-pro",
        "volcengine/doubao-seed-code",
        "x-ai/grok-4",
        "x-ai/grok-4-fast",
        "x-ai/grok-4.1-fast",
        "x-ai/grok-4.1-fast-non-reasoning",
        "x-ai/grok-4.2-fast",
        "x-ai/grok-4.2-fast-non-reasoning",
        "x-ai/grok-code-fast-1",
        "xiaomi/mimo-v2-flash",
        "xiaomi/mimo-v2-omni",
        "xiaomi/mimo-v2-pro",
        "xiaomi/mimo-v2.5",
        "xiaomi/mimo-v2.5-pro",
        "z-ai/glm-4.5",
        "z-ai/glm-4.5-air",
        "z-ai/glm-4.6",
        "z-ai/glm-4.6v",
        "z-ai/glm-4.6v-flash",
        "z-ai/glm-4.6v-flash-free",
        "z-ai/glm-4.7",
        "z-ai/glm-4.7-flash-free",
        "z-ai/glm-4.7-flashx",
        "z-ai/glm-5",
        "z-ai/glm-5-turbo",
        "z-ai/glm-5.1",
        "z-ai/glm-5v-turbo"
      ],
      "docUrl": "https://docs.zenmux.ai",
      "gateway": "models.dev"
    },
    "perplexity-agent": {
      "url": "https://api.perplexity.ai/v1",
      "apiKeyEnvVar": "PERPLEXITY_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Perplexity Agent",
      "models": [
        "anthropic/claude-haiku-4-5",
        "anthropic/claude-opus-4-5",
        "anthropic/claude-opus-4-6",
        "anthropic/claude-opus-4-7",
        "anthropic/claude-sonnet-4-5",
        "anthropic/claude-sonnet-4-6",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash-preview",
        "google/gemini-3.1-pro-preview",
        "nvidia/nemotron-3-super-120b-a12b",
        "openai/gpt-5-mini",
        "openai/gpt-5.1",
        "openai/gpt-5.2",
        "openai/gpt-5.4",
        "openai/gpt-5.5",
        "perplexity/sonar",
        "xai/grok-4-1-fast-non-reasoning"
      ],
      "docUrl": "https://docs.perplexity.ai/docs/agent-api/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/openai"
    },
    "alibaba-coding-plan": {
      "url": "https://coding-intl.dashscope.aliyuncs.com/v1",
      "apiKeyEnvVar": "ALIBABA_CODING_PLAN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Alibaba Coding Plan",
      "models": [
        "MiniMax-M2.5",
        "glm-4.7",
        "glm-5",
        "kimi-k2.5",
        "qwen3-coder-next",
        "qwen3-coder-plus",
        "qwen3-max-2026-01-23",
        "qwen3.5-plus",
        "qwen3.6-plus"
      ],
      "docUrl": "https://www.alibabacloud.com/help/en/model-studio/coding-plan",
      "gateway": "models.dev"
    },
    "meganova": {
      "url": "https://api.meganova.ai/v1",
      "apiKeyEnvVar": "MEGANOVA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Meganova",
      "models": [
        "MiniMaxAI/MiniMax-M2.1",
        "MiniMaxAI/MiniMax-M2.5",
        "Qwen/Qwen2.5-VL-32B-Instruct",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3.5-Plus",
        "XiaomiMiMo/MiMo-V2-Flash",
        "deepseek-ai/DeepSeek-R1-0528",
        "deepseek-ai/DeepSeek-V3-0324",
        "deepseek-ai/DeepSeek-V3.1",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/DeepSeek-V3.2-Exp",
        "meta-llama/Llama-3.3-70B-Instruct",
        "mistralai/Mistral-Nemo-Instruct-2407",
        "mistralai/Mistral-Small-3.2-24B-Instruct-2506",
        "moonshotai/Kimi-K2-Thinking",
        "moonshotai/Kimi-K2.5",
        "zai-org/GLM-4.6",
        "zai-org/GLM-4.7",
        "zai-org/GLM-5"
      ],
      "docUrl": "https://docs.meganova.ai",
      "gateway": "models.dev"
    },
    "synthetic": {
      "url": "https://api.synthetic.new/openai/v1",
      "apiKeyEnvVar": "SYNTHETIC_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Synthetic",
      "models": [
        "hf:MiniMaxAI/MiniMax-M2",
        "hf:MiniMaxAI/MiniMax-M2.1",
        "hf:MiniMaxAI/MiniMax-M2.5",
        "hf:Qwen/Qwen2.5-Coder-32B-Instruct",
        "hf:Qwen/Qwen3-235B-A22B-Instruct-2507",
        "hf:Qwen/Qwen3-235B-A22B-Thinking-2507",
        "hf:Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "hf:Qwen/Qwen3.5-397B-A17B",
        "hf:deepseek-ai/DeepSeek-R1",
        "hf:deepseek-ai/DeepSeek-R1-0528",
        "hf:deepseek-ai/DeepSeek-V3",
        "hf:deepseek-ai/DeepSeek-V3-0324",
        "hf:deepseek-ai/DeepSeek-V3.1",
        "hf:deepseek-ai/DeepSeek-V3.1-Terminus",
        "hf:deepseek-ai/DeepSeek-V3.2",
        "hf:meta-llama/Llama-3.1-405B-Instruct",
        "hf:meta-llama/Llama-3.1-70B-Instruct",
        "hf:meta-llama/Llama-3.1-8B-Instruct",
        "hf:meta-llama/Llama-3.3-70B-Instruct",
        "hf:meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
        "hf:meta-llama/Llama-4-Scout-17B-16E-Instruct",
        "hf:moonshotai/Kimi-K2-Instruct-0905",
        "hf:moonshotai/Kimi-K2-Thinking",
        "hf:moonshotai/Kimi-K2.5",
        "hf:moonshotai/Kimi-K2.6",
        "hf:nvidia/Kimi-K2.5-NVFP4",
        "hf:nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-NVFP4",
        "hf:openai/gpt-oss-120b",
        "hf:zai-org/GLM-4.6",
        "hf:zai-org/GLM-4.7",
        "hf:zai-org/GLM-4.7-Flash",
        "hf:zai-org/GLM-5",
        "hf:zai-org/GLM-5.1"
      ],
      "docUrl": "https://synthetic.new/pricing",
      "gateway": "models.dev"
    },
    "inceptron": {
      "url": "https://api.inceptron.io/v1",
      "apiKeyEnvVar": "INCEPTRON_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Inceptron",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "moonshotai/Kimi-K2.6",
        "nvidia/llama-3.3-70b-instruct-fp8",
        "zai-org/GLM-5.1-FP8"
      ],
      "docUrl": "https://docs.inceptron.io",
      "gateway": "models.dev"
    },
    "minimax-coding-plan": {
      "url": "https://api.minimax.io/anthropic/v1",
      "apiKeyEnvVar": "MINIMAX_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "MiniMax Token Plan (minimax.io)",
      "models": [
        "MiniMax-M2",
        "MiniMax-M2.1",
        "MiniMax-M2.5",
        "MiniMax-M2.5-highspeed",
        "MiniMax-M2.7",
        "MiniMax-M2.7-highspeed"
      ],
      "docUrl": "https://platform.minimax.io/docs/token-plan/intro",
      "gateway": "models.dev",
      "npm": "@ai-sdk/anthropic"
    },
    "upstage": {
      "url": "https://api.upstage.ai/v1/solar",
      "apiKeyEnvVar": "UPSTAGE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Upstage",
      "models": ["solar-mini", "solar-pro2", "solar-pro3"],
      "docUrl": "https://developers.upstage.ai/docs/apis/chat",
      "gateway": "models.dev"
    },
    "vercel": {
      "apiKeyEnvVar": "AI_GATEWAY_API_KEY",
      "name": "Vercel AI Gateway",
      "models": [
        "alibaba/qwen-3-14b",
        "alibaba/qwen-3-235b",
        "alibaba/qwen-3-30b",
        "alibaba/qwen-3-32b",
        "alibaba/qwen-3.6-max-preview",
        "alibaba/qwen3-235b-a22b-thinking",
        "alibaba/qwen3-coder",
        "alibaba/qwen3-coder-30b-a3b",
        "alibaba/qwen3-coder-next",
        "alibaba/qwen3-coder-plus",
        "alibaba/qwen3-embedding-0.6b",
        "alibaba/qwen3-embedding-4b",
        "alibaba/qwen3-embedding-8b",
        "alibaba/qwen3-max",
        "alibaba/qwen3-max-preview",
        "alibaba/qwen3-max-thinking",
        "alibaba/qwen3-next-80b-a3b-instruct",
        "alibaba/qwen3-next-80b-a3b-thinking",
        "alibaba/qwen3-vl-235b-a22b-instruct",
        "alibaba/qwen3-vl-instruct",
        "alibaba/qwen3-vl-thinking",
        "alibaba/qwen3.5-flash",
        "alibaba/qwen3.5-plus",
        "alibaba/qwen3.6-27b",
        "alibaba/qwen3.6-plus",
        "alibaba/qwen3.7-max",
        "amazon/nova-2-lite",
        "amazon/nova-lite",
        "amazon/nova-micro",
        "amazon/nova-pro",
        "amazon/titan-embed-text-v2",
        "anthropic/claude-3-haiku",
        "anthropic/claude-3-opus",
        "anthropic/claude-3.5-haiku",
        "anthropic/claude-3.5-sonnet",
        "anthropic/claude-3.5-sonnet-20240620",
        "anthropic/claude-3.7-sonnet",
        "anthropic/claude-haiku-4.5",
        "anthropic/claude-opus-4",
        "anthropic/claude-opus-4.1",
        "anthropic/claude-opus-4.5",
        "anthropic/claude-opus-4.6",
        "anthropic/claude-opus-4.7",
        "anthropic/claude-sonnet-4",
        "anthropic/claude-sonnet-4.5",
        "anthropic/claude-sonnet-4.6",
        "arcee-ai/trinity-large-preview",
        "arcee-ai/trinity-large-thinking",
        "arcee-ai/trinity-mini",
        "bfl/flux-kontext-max",
        "bfl/flux-kontext-pro",
        "bfl/flux-pro-1.0-fill",
        "bfl/flux-pro-1.1",
        "bfl/flux-pro-1.1-ultra",
        "bytedance/seed-1.6",
        "bytedance/seed-1.8",
        "cohere/command-a",
        "cohere/embed-v4.0",
        "deepseek/deepseek-r1",
        "deepseek/deepseek-v3",
        "deepseek/deepseek-v3.1",
        "deepseek/deepseek-v3.1-terminus",
        "deepseek/deepseek-v3.2",
        "deepseek/deepseek-v3.2-exp",
        "deepseek/deepseek-v3.2-thinking",
        "deepseek/deepseek-v4-flash",
        "deepseek/deepseek-v4-pro",
        "google/gemini-2.0-flash",
        "google/gemini-2.0-flash-lite",
        "google/gemini-2.5-flash",
        "google/gemini-2.5-flash-image",
        "google/gemini-2.5-flash-image-preview",
        "google/gemini-2.5-flash-lite",
        "google/gemini-2.5-flash-lite-preview-09-2025",
        "google/gemini-2.5-flash-preview-09-2025",
        "google/gemini-2.5-pro",
        "google/gemini-3-flash",
        "google/gemini-3-pro-image",
        "google/gemini-3-pro-preview",
        "google/gemini-3.1-flash-image-preview",
        "google/gemini-3.1-flash-lite",
        "google/gemini-3.1-flash-lite-preview",
        "google/gemini-3.1-pro-preview",
        "google/gemini-3.5-flash",
        "google/gemini-embedding-001",
        "google/gemini-embedding-2",
        "google/gemma-4-26b-a4b-it",
        "google/gemma-4-31b-it",
        "google/imagen-4.0-fast-generate-001",
        "google/imagen-4.0-generate-001",
        "google/imagen-4.0-ultra-generate-001",
        "google/text-embedding-005",
        "google/text-multilingual-embedding-002",
        "inception/mercury-2",
        "inception/mercury-coder-small",
        "inception/mercury-edit-2",
        "interfaze/interfaze-beta",
        "kwaipilot/kat-coder-pro-v1",
        "kwaipilot/kat-coder-pro-v2",
        "meituan/longcat-flash-chat",
        "meituan/longcat-flash-thinking",
        "meituan/longcat-flash-thinking-2601",
        "meta/llama-3.1-70b",
        "meta/llama-3.1-8b",
        "meta/llama-3.2-11b",
        "meta/llama-3.2-1b",
        "meta/llama-3.2-3b",
        "meta/llama-3.2-90b",
        "meta/llama-3.3-70b",
        "meta/llama-4-maverick",
        "meta/llama-4-scout",
        "minimax/minimax-m2",
        "minimax/minimax-m2.1",
        "minimax/minimax-m2.1-lightning",
        "minimax/minimax-m2.5",
        "minimax/minimax-m2.5-highspeed",
        "minimax/minimax-m2.7",
        "minimax/minimax-m2.7-highspeed",
        "mistral/codestral",
        "mistral/codestral-embed",
        "mistral/devstral-2",
        "mistral/devstral-small",
        "mistral/devstral-small-2",
        "mistral/magistral-medium",
        "mistral/magistral-small",
        "mistral/ministral-14b",
        "mistral/ministral-3b",
        "mistral/ministral-8b",
        "mistral/mistral-embed",
        "mistral/mistral-large-3",
        "mistral/mistral-medium",
        "mistral/mistral-medium-3.5",
        "mistral/mistral-nemo",
        "mistral/mistral-small",
        "mistral/mixtral-8x22b-instruct",
        "mistral/pixtral-12b",
        "mistral/pixtral-large",
        "moonshotai/kimi-k2-0905",
        "moonshotai/kimi-k2-thinking",
        "moonshotai/kimi-k2-thinking-turbo",
        "moonshotai/kimi-k2-turbo",
        "moonshotai/kimi-k2.5",
        "moonshotai/kimi-k2.6",
        "morph/morph-v3-fast",
        "morph/morph-v3-large",
        "nvidia/nemotron-3-nano-30b-a3b",
        "nvidia/nemotron-3-super-120b-a12b",
        "nvidia/nemotron-nano-12b-v2-vl",
        "nvidia/nemotron-nano-9b-v2",
        "openai/codex-mini",
        "openai/gpt-3.5-turbo",
        "openai/gpt-3.5-turbo-instruct",
        "openai/gpt-4-turbo",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-mini",
        "openai/gpt-4o-mini-search-preview",
        "openai/gpt-5",
        "openai/gpt-5-chat",
        "openai/gpt-5-codex",
        "openai/gpt-5-mini",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.1-instant",
        "openai/gpt-5.1-thinking",
        "openai/gpt-5.2",
        "openai/gpt-5.2-chat",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.3-chat",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.5",
        "openai/gpt-5.5-pro",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-20b",
        "openai/gpt-oss-safeguard-20b",
        "openai/o1",
        "openai/o3",
        "openai/o3-deep-research",
        "openai/o3-mini",
        "openai/o3-pro",
        "openai/o4-mini",
        "openai/text-embedding-3-large",
        "openai/text-embedding-3-small",
        "openai/text-embedding-ada-002",
        "perplexity/sonar",
        "perplexity/sonar-pro",
        "perplexity/sonar-reasoning",
        "perplexity/sonar-reasoning-pro",
        "prime-intellect/intellect-3",
        "recraft/recraft-v2",
        "recraft/recraft-v3",
        "vercel/v0-1.0-md",
        "vercel/v0-1.5-md",
        "voyage/voyage-3-large",
        "voyage/voyage-3.5",
        "voyage/voyage-3.5-lite",
        "voyage/voyage-4",
        "voyage/voyage-4-large",
        "voyage/voyage-4-lite",
        "voyage/voyage-code-2",
        "voyage/voyage-code-3",
        "voyage/voyage-finance-2",
        "voyage/voyage-law-2",
        "xai/grok-4-fast-reasoning",
        "xai/grok-4.1-fast-non-reasoning",
        "xai/grok-4.1-fast-reasoning",
        "xai/grok-4.20-multi-agent",
        "xai/grok-4.20-multi-agent-beta",
        "xai/grok-4.20-non-reasoning",
        "xai/grok-4.20-non-reasoning-beta",
        "xai/grok-4.20-reasoning",
        "xai/grok-4.20-reasoning-beta",
        "xai/grok-4.3",
        "xai/grok-build-0.1",
        "xai/grok-imagine-image",
        "xai/grok-imagine-image-pro",
        "xiaomi/mimo-v2-flash",
        "xiaomi/mimo-v2-pro",
        "xiaomi/mimo-v2.5",
        "xiaomi/mimo-v2.5-pro",
        "zai/glm-4.5",
        "zai/glm-4.5-air",
        "zai/glm-4.5v",
        "zai/glm-4.6",
        "zai/glm-4.6v",
        "zai/glm-4.6v-flash",
        "zai/glm-4.7",
        "zai/glm-4.7-flash",
        "zai/glm-4.7-flashx",
        "zai/glm-5",
        "zai/glm-5-turbo",
        "zai/glm-5.1",
        "zai/glm-5v-turbo"
      ],
      "docUrl": "https://github.com/vercel/ai/tree/5eb85cc45a259553501f535b8ac79a77d0e79223/packages/gateway",
      "gateway": "models.dev"
    },
    "abliteration-ai": {
      "url": "https://api.abliteration.ai/v1",
      "apiKeyEnvVar": "ABLIT_KEY",
      "apiKeyHeader": "Authorization",
      "name": "abliteration.ai",
      "models": ["abliterated-model"],
      "docUrl": "https://docs.abliteration.ai/models",
      "gateway": "models.dev"
    },
    "deepseek": {
      "url": "https://api.deepseek.com",
      "apiKeyEnvVar": "DEEPSEEK_API_KEY",
      "name": "DeepSeek",
      "models": ["deepseek-chat", "deepseek-reasoner", "deepseek-v4-flash", "deepseek-v4-pro"],
      "docUrl": "https://api-docs.deepseek.com/quick_start/pricing",
      "gateway": "models.dev"
    },
    "perplexity": {
      "apiKeyEnvVar": "PERPLEXITY_API_KEY",
      "name": "Perplexity",
      "models": ["sonar", "sonar-deep-research", "sonar-pro", "sonar-reasoning-pro"],
      "docUrl": "https://docs.perplexity.ai",
      "gateway": "models.dev",
      "npm": "@ai-sdk/perplexity"
    },
    "iflowcn": {
      "url": "https://apis.iflow.cn/v1",
      "apiKeyEnvVar": "IFLOW_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "iFlow",
      "models": [
        "deepseek-r1",
        "deepseek-v3",
        "deepseek-v3.2",
        "glm-4.6",
        "kimi-k2",
        "kimi-k2-0905",
        "qwen3-235b",
        "qwen3-235b-a22b-instruct",
        "qwen3-235b-a22b-thinking-2507",
        "qwen3-32b",
        "qwen3-coder-plus",
        "qwen3-max",
        "qwen3-max-preview",
        "qwen3-vl-plus"
      ],
      "docUrl": "https://platform.iflow.cn/en/docs",
      "gateway": "models.dev"
    },
    "stackit": {
      "url": "https://api.openai-compat.model-serving.eu01.onstackit.cloud/v1",
      "apiKeyEnvVar": "STACKIT_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "STACKIT",
      "models": [
        "Qwen/Qwen3-VL-235B-A22B-Instruct-FP8",
        "Qwen/Qwen3-VL-Embedding-8B",
        "cortecs/Llama-3.3-70B-Instruct-FP8-Dynamic",
        "google/gemma-3-27b-it",
        "intfloat/e5-mistral-7b-instruct",
        "neuralmagic/Meta-Llama-3.1-8B-Instruct-FP8",
        "neuralmagic/Mistral-Nemo-Instruct-2407-FP8",
        "openai/gpt-oss-120b"
      ],
      "docUrl": "https://docs.stackit.cloud/products/data-and-ai/ai-model-serving/basics/available-shared-models",
      "gateway": "models.dev"
    },
    "wafer.ai": {
      "url": "https://pass.wafer.ai/v1",
      "apiKeyEnvVar": "WAFER_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Wafer",
      "models": ["GLM-5.1", "Qwen3.5-397B-A17B"],
      "docUrl": "https://docs.wafer.ai/wafer-pass",
      "gateway": "models.dev"
    },
    "evroc": {
      "url": "https://models.think.evroc.com/v1",
      "apiKeyEnvVar": "EVROC_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "evroc",
      "models": [
        "KBLab/kb-whisper-large",
        "Qwen/Qwen3-30B-A3B-Instruct-2507-FP8",
        "Qwen/Qwen3-Embedding-8B",
        "Qwen/Qwen3-VL-30B-A3B-Instruct",
        "intfloat/multilingual-e5-large-instruct",
        "microsoft/Phi-4-multimodal-instruct",
        "mistralai/Magistral-Small-2509",
        "mistralai/Voxtral-Small-24B-2507",
        "mistralai/devstral-small-2-24b-instruct-2512",
        "moonshotai/Kimi-K2.5",
        "nvidia/Llama-3.3-70B-Instruct-FP8",
        "openai/gpt-oss-120b",
        "openai/whisper-large-v3"
      ],
      "docUrl": "https://docs.evroc.com/products/think/overview.html",
      "gateway": "models.dev"
    },
    "nova": {
      "url": "https://api.nova.amazon.com/v1",
      "apiKeyEnvVar": "NOVA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Nova",
      "models": ["nova-2-lite-v1", "nova-2-pro-v1"],
      "docUrl": "https://nova.amazon.com/dev/documentation",
      "gateway": "models.dev"
    },
    "fireworks-ai": {
      "url": "https://api.fireworks.ai/inference/v1/",
      "apiKeyEnvVar": "FIREWORKS_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Fireworks AI",
      "models": [
        "accounts/fireworks/models/deepseek-v3p1",
        "accounts/fireworks/models/deepseek-v3p2",
        "accounts/fireworks/models/deepseek-v4-flash",
        "accounts/fireworks/models/deepseek-v4-pro",
        "accounts/fireworks/models/glm-4p5",
        "accounts/fireworks/models/glm-4p5-air",
        "accounts/fireworks/models/glm-4p7",
        "accounts/fireworks/models/glm-5",
        "accounts/fireworks/models/glm-5p1",
        "accounts/fireworks/models/gpt-oss-120b",
        "accounts/fireworks/models/gpt-oss-20b",
        "accounts/fireworks/models/kimi-k2-instruct",
        "accounts/fireworks/models/kimi-k2-thinking",
        "accounts/fireworks/models/kimi-k2p5",
        "accounts/fireworks/models/kimi-k2p6",
        "accounts/fireworks/models/minimax-m2p1",
        "accounts/fireworks/models/minimax-m2p5",
        "accounts/fireworks/models/minimax-m2p7",
        "accounts/fireworks/models/qwen3p6-plus",
        "accounts/fireworks/routers/kimi-k2p5-turbo"
      ],
      "docUrl": "https://fireworks.ai/docs/",
      "gateway": "models.dev"
    },
    "alibaba": {
      "url": "https://dashscope-intl.aliyuncs.com/compatible-mode/v1",
      "apiKeyEnvVar": "DASHSCOPE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Alibaba",
      "models": [
        "qvq-max",
        "qwen-flash",
        "qwen-max",
        "qwen-mt-plus",
        "qwen-mt-turbo",
        "qwen-omni-turbo",
        "qwen-omni-turbo-realtime",
        "qwen-plus",
        "qwen-plus-character-ja",
        "qwen-turbo",
        "qwen-vl-max",
        "qwen-vl-ocr",
        "qwen-vl-plus",
        "qwen2-5-14b-instruct",
        "qwen2-5-32b-instruct",
        "qwen2-5-72b-instruct",
        "qwen2-5-7b-instruct",
        "qwen2-5-omni-7b",
        "qwen2-5-vl-72b-instruct",
        "qwen2-5-vl-7b-instruct",
        "qwen3-14b",
        "qwen3-235b-a22b",
        "qwen3-32b",
        "qwen3-8b",
        "qwen3-asr-flash",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-coder-flash",
        "qwen3-coder-plus",
        "qwen3-livetranslate-flash-realtime",
        "qwen3-max",
        "qwen3-next-80b-a3b-instruct",
        "qwen3-next-80b-a3b-thinking",
        "qwen3-omni-flash",
        "qwen3-omni-flash-realtime",
        "qwen3-vl-235b-a22b",
        "qwen3-vl-30b-a3b",
        "qwen3-vl-plus",
        "qwen3.5-122b-a10b",
        "qwen3.5-27b",
        "qwen3.5-35b-a3b",
        "qwen3.5-397b-a17b",
        "qwen3.5-plus",
        "qwen3.6-27b",
        "qwen3.6-35b-a3b",
        "qwen3.6-max-preview",
        "qwen3.6-plus",
        "qwen3.7-max",
        "qwq-plus"
      ],
      "docUrl": "https://www.alibabacloud.com/help/en/model-studio/models",
      "gateway": "models.dev"
    },
    "302ai": {
      "url": "https://api.302.ai/v1",
      "apiKeyEnvVar": "302AI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "302.AI",
      "models": [
        "MiniMax-M1",
        "MiniMax-M2",
        "MiniMax-M2.1",
        "MiniMax-M2.7",
        "MiniMax-M2.7-highspeed",
        "chatgpt-4o-latest",
        "claude-3-5-haiku-20241022",
        "claude-3-5-haiku-latest",
        "claude-haiku-4-5",
        "claude-haiku-4-5-20251001",
        "claude-opus-4-1-20250805",
        "claude-opus-4-1-20250805-thinking",
        "claude-opus-4-20250514",
        "claude-opus-4-5",
        "claude-opus-4-5-20251101",
        "claude-opus-4-5-20251101-thinking",
        "claude-opus-4-6",
        "claude-opus-4-6-thinking",
        "claude-opus-4-7",
        "claude-sonnet-4-20250514",
        "claude-sonnet-4-5",
        "claude-sonnet-4-5-20250929",
        "claude-sonnet-4-5-20250929-thinking",
        "claude-sonnet-4-6",
        "claude-sonnet-4-6-thinking",
        "deepseek-chat",
        "deepseek-reasoner",
        "deepseek-v3.2",
        "deepseek-v3.2-thinking",
        "doubao-seed-1-6-thinking-250715",
        "doubao-seed-1-6-vision-250815",
        "doubao-seed-1-8-251215",
        "doubao-seed-code-preview-251028",
        "gemini-2.0-flash-lite",
        "gemini-2.5-flash",
        "gemini-2.5-flash-image",
        "gemini-2.5-flash-lite-preview-09-2025",
        "gemini-2.5-flash-nothink",
        "gemini-2.5-flash-preview-09-2025",
        "gemini-2.5-pro",
        "gemini-3-flash-preview",
        "gemini-3-pro-image-preview",
        "gemini-3-pro-preview",
        "gemini-3.1-flash-image-preview",
        "glm-4.5",
        "glm-4.5-air",
        "glm-4.5-airx",
        "glm-4.5-x",
        "glm-4.5v",
        "glm-4.6",
        "glm-4.6v",
        "glm-4.7",
        "glm-4.7-flashx",
        "glm-5",
        "glm-5-turbo",
        "glm-5.1",
        "glm-5v-turbo",
        "glm-for-coding",
        "gpt-4.1",
        "gpt-4.1-mini",
        "gpt-4.1-nano",
        "gpt-4o",
        "gpt-5",
        "gpt-5-mini",
        "gpt-5-pro",
        "gpt-5-thinking",
        "gpt-5.1",
        "gpt-5.1-chat-latest",
        "gpt-5.2",
        "gpt-5.2-chat-latest",
        "gpt-5.4",
        "gpt-5.4-mini",
        "gpt-5.4-mini-2026-03-17",
        "gpt-5.4-nano",
        "gpt-5.4-nano-2026-03-17",
        "gpt-5.4-pro",
        "grok-4-1-fast-non-reasoning",
        "grok-4-1-fast-reasoning",
        "grok-4-fast-non-reasoning",
        "grok-4-fast-reasoning",
        "grok-4.1",
        "grok-4.20-beta-0309-non-reasoning",
        "grok-4.20-beta-0309-reasoning",
        "grok-4.20-multi-agent-beta-0309",
        "kimi-k2-0905-preview",
        "kimi-k2-thinking",
        "kimi-k2-thinking-turbo",
        "ministral-14b-2512",
        "mistral-large-2512",
        "qwen-flash",
        "qwen-max-latest",
        "qwen-plus",
        "qwen3-235b-a22b",
        "qwen3-235b-a22b-instruct-2507",
        "qwen3-30b-a3b",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-max-2025-09-23"
      ],
      "docUrl": "https://doc.302.ai",
      "gateway": "models.dev"
    },
    "xpersona": {
      "url": "https://www.xpersona.co/v1",
      "apiKeyEnvVar": "XPERSONA_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Xpersona",
      "models": ["xpersona-frieren-coder"],
      "docUrl": "https://www.xpersona.co/docs",
      "gateway": "models.dev"
    },
    "stepfun": {
      "url": "https://api.stepfun.com/v1",
      "apiKeyEnvVar": "STEPFUN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "StepFun",
      "models": ["step-1-32k", "step-2-16k", "step-3.5-flash", "step-3.5-flash-2603"],
      "docUrl": "https://platform.stepfun.com/docs/zh/overview/concept",
      "gateway": "models.dev"
    },
    "xai": {
      "apiKeyEnvVar": "XAI_API_KEY",
      "name": "xAI",
      "models": [
        "grok-4.20-0309-non-reasoning",
        "grok-4.20-0309-reasoning",
        "grok-4.20-multi-agent-0309",
        "grok-4.3",
        "grok-build-0.1",
        "grok-imagine-image",
        "grok-imagine-image-quality",
        "grok-imagine-video"
      ],
      "docUrl": "https://docs.x.ai/docs/models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/xai"
    },
    "sarvam": {
      "url": "https://api.sarvam.ai/v1",
      "apiKeyEnvVar": "SARVAM_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Sarvam AI",
      "models": ["sarvam-105b", "sarvam-30b"],
      "docUrl": "https://docs.sarvam.ai/api-reference-docs/getting-started/models",
      "gateway": "models.dev"
    },
    "zhipuai": {
      "url": "https://open.bigmodel.cn/api/paas/v4",
      "apiKeyEnvVar": "ZHIPU_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Zhipu AI",
      "models": [
        "glm-4.5",
        "glm-4.5-air",
        "glm-4.5-flash",
        "glm-4.5v",
        "glm-4.6",
        "glm-4.6v",
        "glm-4.7",
        "glm-4.7-flash",
        "glm-4.7-flashx",
        "glm-5",
        "glm-5.1",
        "glm-5v-turbo"
      ],
      "docUrl": "https://docs.z.ai/guides/overview/pricing",
      "gateway": "models.dev"
    },
    "bailing": {
      "url": "https://api.tbox.cn/api/llm/v1/chat/completions",
      "apiKeyEnvVar": "BAILING_API_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "Bailing",
      "models": ["Ling-1T", "Ring-1T"],
      "docUrl": "https://alipaytbox.yuque.com/sxs0ba/ling/intro",
      "gateway": "models.dev"
    },
    "qihang-ai": {
      "url": "https://api.qhaigc.net/v1",
      "apiKeyEnvVar": "QIHANG_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "QiHang",
      "models": [
        "claude-haiku-4-5-20251001",
        "claude-opus-4-5-20251101",
        "claude-sonnet-4-5-20250929",
        "gemini-2.5-flash",
        "gemini-3-flash-preview",
        "gemini-3-pro-preview",
        "gpt-5-mini",
        "gpt-5.2",
        "gpt-5.2-codex"
      ],
      "docUrl": "https://www.qhaigc.net/docs",
      "gateway": "models.dev"
    },
    "lilac": {
      "url": "https://api.getlilac.com/v1",
      "apiKeyEnvVar": "LILAC_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Lilac",
      "models": ["google/gemma-4-31b-it", "minimaxai/minimax-m2.7", "moonshotai/kimi-k2.6", "zai-org/glm-5.1"],
      "docUrl": "https://docs.getlilac.com/inference/models",
      "gateway": "models.dev"
    },
    "alibaba-cn": {
      "url": "https://dashscope.aliyuncs.com/compatible-mode/v1",
      "apiKeyEnvVar": "DASHSCOPE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Alibaba (China)",
      "models": [
        "MiniMax-M2.5",
        "MiniMax/MiniMax-M2.7",
        "deepseek-r1",
        "deepseek-r1-0528",
        "deepseek-r1-distill-llama-70b",
        "deepseek-r1-distill-llama-8b",
        "deepseek-r1-distill-qwen-1-5b",
        "deepseek-r1-distill-qwen-14b",
        "deepseek-r1-distill-qwen-32b",
        "deepseek-r1-distill-qwen-7b",
        "deepseek-v3",
        "deepseek-v3-1",
        "deepseek-v3-2-exp",
        "deepseek-v4-flash",
        "deepseek-v4-pro",
        "glm-5",
        "glm-5.1",
        "kimi-k2-thinking",
        "kimi-k2.5",
        "kimi-k2.6",
        "kimi/kimi-k2.5",
        "moonshot-kimi-k2-instruct",
        "qvq-max",
        "qwen-deep-research",
        "qwen-doc-turbo",
        "qwen-flash",
        "qwen-long",
        "qwen-math-plus",
        "qwen-math-turbo",
        "qwen-max",
        "qwen-mt-plus",
        "qwen-mt-turbo",
        "qwen-omni-turbo",
        "qwen-omni-turbo-realtime",
        "qwen-plus",
        "qwen-plus-character",
        "qwen-turbo",
        "qwen-vl-max",
        "qwen-vl-ocr",
        "qwen-vl-plus",
        "qwen2-5-14b-instruct",
        "qwen2-5-32b-instruct",
        "qwen2-5-72b-instruct",
        "qwen2-5-7b-instruct",
        "qwen2-5-coder-32b-instruct",
        "qwen2-5-coder-7b-instruct",
        "qwen2-5-math-72b-instruct",
        "qwen2-5-math-7b-instruct",
        "qwen2-5-omni-7b",
        "qwen2-5-vl-72b-instruct",
        "qwen2-5-vl-7b-instruct",
        "qwen3-14b",
        "qwen3-235b-a22b",
        "qwen3-32b",
        "qwen3-8b",
        "qwen3-asr-flash",
        "qwen3-coder-30b-a3b-instruct",
        "qwen3-coder-480b-a35b-instruct",
        "qwen3-coder-flash",
        "qwen3-coder-plus",
        "qwen3-max",
        "qwen3-next-80b-a3b-instruct",
        "qwen3-next-80b-a3b-thinking",
        "qwen3-omni-flash",
        "qwen3-omni-flash-realtime",
        "qwen3-vl-235b-a22b",
        "qwen3-vl-30b-a3b",
        "qwen3-vl-plus",
        "qwen3.5-397b-a17b",
        "qwen3.5-flash",
        "qwen3.5-plus",
        "qwen3.6-max-preview",
        "qwen3.6-plus",
        "qwq-32b",
        "qwq-plus",
        "siliconflow/deepseek-r1-0528",
        "siliconflow/deepseek-v3-0324",
        "siliconflow/deepseek-v3.1-terminus",
        "siliconflow/deepseek-v3.2",
        "tongyi-intent-detect-v3"
      ],
      "docUrl": "https://www.alibabacloud.com/help/en/model-studio/models",
      "gateway": "models.dev"
    },
    "drun": {
      "url": "https://chat.d.run/v1",
      "apiKeyEnvVar": "DRUN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "D.Run (China)",
      "models": ["public/deepseek-r1", "public/deepseek-v3", "public/minimax-m25"],
      "docUrl": "https://www.d.run",
      "gateway": "models.dev"
    },
    "huggingface": {
      "url": "https://router.huggingface.co/v1",
      "apiKeyEnvVar": "HF_TOKEN",
      "apiKeyHeader": "Authorization",
      "name": "Hugging Face",
      "models": [
        "MiniMaxAI/MiniMax-M2.1",
        "MiniMaxAI/MiniMax-M2.5",
        "MiniMaxAI/MiniMax-M2.7",
        "Qwen/Qwen3-235B-A22B-Thinking-2507",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct",
        "Qwen/Qwen3-Coder-Next",
        "Qwen/Qwen3-Embedding-4B",
        "Qwen/Qwen3-Embedding-8B",
        "Qwen/Qwen3-Next-80B-A3B-Instruct",
        "Qwen/Qwen3-Next-80B-A3B-Thinking",
        "Qwen/Qwen3.5-397B-A17B",
        "XiaomiMiMo/MiMo-V2-Flash",
        "deepseek-ai/DeepSeek-R1-0528",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/DeepSeek-V4-Pro",
        "moonshotai/Kimi-K2-Instruct",
        "moonshotai/Kimi-K2-Instruct-0905",
        "moonshotai/Kimi-K2-Thinking",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "zai-org/GLM-4.7",
        "zai-org/GLM-4.7-Flash",
        "zai-org/GLM-5",
        "zai-org/GLM-5.1"
      ],
      "docUrl": "https://huggingface.co/docs/inference-providers",
      "gateway": "models.dev"
    },
    "umans-ai-coding-plan": {
      "url": "https://api.code.umans.ai/v1",
      "apiKeyEnvVar": "UMANS_AI_CODING_PLAN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Umans AI Coding Plan",
      "models": ["umans-coder", "umans-flash", "umans-glm-5.1", "umans-kimi-k2.6", "umans-qwen3.6-35b-a3b"],
      "docUrl": "https://app.umans.ai/offers/code/docs",
      "gateway": "models.dev"
    },
    "tencent-tokenhub": {
      "url": "https://tokenhub.tencentmaas.com/v1",
      "apiKeyEnvVar": "TENCENT_TOKENHUB_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Tencent TokenHub",
      "models": ["hy3-preview"],
      "docUrl": "https://cloud.tencent.com/document/product/1823/130050",
      "gateway": "models.dev"
    },
    "nebius": {
      "url": "https://api.tokenfactory.nebius.com/v1",
      "apiKeyEnvVar": "NEBIUS_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Nebius Token Factory",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "MiniMaxAI/MiniMax-M2.5-fast",
        "NousResearch/Hermes-4-405B",
        "NousResearch/Hermes-4-70B",
        "PrimeIntellect/INTELLECT-3",
        "Qwen/Qwen2.5-VL-72B-Instruct",
        "Qwen/Qwen3-235B-A22B-Instruct-2507",
        "Qwen/Qwen3-235B-A22B-Thinking-2507-fast",
        "Qwen/Qwen3-30B-A3B-Instruct-2507",
        "Qwen/Qwen3-32B",
        "Qwen/Qwen3-Embedding-8B",
        "Qwen/Qwen3-Next-80B-A3B-Thinking",
        "Qwen/Qwen3-Next-80B-A3B-Thinking-fast",
        "Qwen/Qwen3.5-397B-A17B",
        "Qwen/Qwen3.5-397B-A17B-fast",
        "deepseek-ai/DeepSeek-V3.2",
        "deepseek-ai/DeepSeek-V3.2-fast",
        "deepseek-ai/DeepSeek-V4-Pro",
        "google/gemma-2-2b-it",
        "google/gemma-3-27b-it",
        "meta-llama/Llama-3.3-70B-Instruct",
        "meta-llama/Meta-Llama-3.1-8B-Instruct",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.5-fast",
        "nvidia/Llama-3_1-Nemotron-Ultra-253B-v1",
        "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B",
        "nvidia/Nemotron-3-Nano-Omni",
        "nvidia/nemotron-3-super-120b-a12b",
        "openai/gpt-oss-120b",
        "openai/gpt-oss-120b-fast",
        "zai-org/GLM-5"
      ],
      "docUrl": "https://docs.tokenfactory.nebius.com/",
      "gateway": "models.dev"
    },
    "hpc-ai": {
      "url": "https://api.hpc-ai.com/inference/v1",
      "apiKeyEnvVar": "HPC_AI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "HPC-AI",
      "models": ["minimax/minimax-m2.5", "moonshotai/kimi-k2.5", "zai-org/glm-5.1"],
      "docUrl": "https://www.hpc-ai.com/doc/docs/quickstart/",
      "gateway": "models.dev"
    },
    "xiaomi": {
      "url": "https://api.xiaomimimo.com/v1",
      "apiKeyEnvVar": "XIAOMI_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Xiaomi",
      "models": ["mimo-v2-flash", "mimo-v2-omni", "mimo-v2-pro", "mimo-v2.5", "mimo-v2.5-pro"],
      "docUrl": "https://platform.xiaomimimo.com/#/docs",
      "gateway": "models.dev"
    },
    "togetherai": {
      "apiKeyEnvVar": "TOGETHER_API_KEY",
      "name": "Together AI",
      "models": [
        "MiniMaxAI/MiniMax-M2.5",
        "MiniMaxAI/MiniMax-M2.7",
        "Qwen/Qwen3-235B-A22B-Instruct-2507-tput",
        "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
        "Qwen/Qwen3-Coder-Next-FP8",
        "Qwen/Qwen3.5-397B-A17B",
        "Qwen/Qwen3.6-Plus",
        "deepseek-ai/DeepSeek-R1",
        "deepseek-ai/DeepSeek-V3",
        "deepseek-ai/DeepSeek-V3-1",
        "deepseek-ai/DeepSeek-V4-Pro",
        "essentialai/Rnj-1-Instruct",
        "google/gemma-4-31B-it",
        "meta-llama/Llama-3.3-70B-Instruct-Turbo",
        "moonshotai/Kimi-K2.5",
        "moonshotai/Kimi-K2.6",
        "openai/gpt-oss-120b",
        "zai-org/GLM-5.1"
      ],
      "docUrl": "https://docs.together.ai/docs/serverless-models",
      "gateway": "models.dev",
      "npm": "@ai-sdk/togetherai"
    },
    "stepfun-ai": {
      "url": "https://api.stepfun.ai/step_plan/v1",
      "apiKeyEnvVar": "STEPFUN_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "StepFun",
      "models": ["step-3.5-flash", "step-3.5-flash-2603"],
      "docUrl": "https://platform.stepfun.ai/docs/en/step-plan/integrations/open-code",
      "gateway": "models.dev"
    },
    "inference": {
      "url": "https://inference.net/v1",
      "apiKeyEnvVar": "INFERENCE_API_KEY",
      "apiKeyHeader": "Authorization",
      "name": "Inference",
      "models": [
        "google/gemma-3",
        "meta/llama-3.1-8b-instruct",
        "meta/llama-3.2-11b-vision-instruct",
        "meta/llama-3.2-1b-instruct",
        "meta/llama-3.2-3b-instruct",
        "mistral/mistral-nemo-12b-instruct",
        "osmosis/osmosis-structure-0.6b",
        "qwen/qwen-2.5-7b-vision-instruct",
        "qwen/qwen3-embedding-4b"
      ],
      "docUrl": "https://inference.net/models",
      "gateway": "models.dev"
    },
    "netlify": {
      "apiKeyEnvVar": ["NETLIFY_TOKEN", "NETLIFY_SITE_ID"],
      "apiKeyHeader": "Authorization",
      "name": "Netlify",
      "gateway": "netlify",
      "models": [
        "anthropic/claude-haiku-4-5",
        "anthropic/claude-haiku-4-5-20251001",
        "anthropic/claude-opus-4-1-20250805",
        "anthropic/claude-opus-4-20250514",
        "anthropic/claude-opus-4-5",
        "anthropic/claude-opus-4-5-20251101",
        "anthropic/claude-opus-4-6",
        "anthropic/claude-opus-4-7",
        "anthropic/claude-sonnet-4-0",
        "anthropic/claude-sonnet-4-20250514",
        "anthropic/claude-sonnet-4-5",
        "anthropic/claude-sonnet-4-5-20250929",
        "anthropic/claude-sonnet-4-6",
        "gemini/gemini-2.0-flash",
        "gemini/gemini-2.0-flash-lite",
        "gemini/gemini-2.5-flash",
        "gemini/gemini-2.5-flash-image",
        "gemini/gemini-2.5-flash-lite",
        "gemini/gemini-2.5-pro",
        "gemini/gemini-3-flash-preview",
        "gemini/gemini-3-pro-image-preview",
        "gemini/gemini-3.1-flash-image-preview",
        "gemini/gemini-3.1-flash-lite",
        "gemini/gemini-3.1-flash-lite-preview",
        "gemini/gemini-3.1-pro-preview",
        "gemini/gemini-3.1-pro-preview-customtools",
        "gemini/gemini-3.5-flash",
        "gemini/gemini-flash-latest",
        "gemini/gemini-flash-lite-latest",
        "openai/chat-latest",
        "openai/gpt-4.1",
        "openai/gpt-4.1-mini",
        "openai/gpt-4.1-nano",
        "openai/gpt-4o",
        "openai/gpt-4o-mini",
        "openai/gpt-5",
        "openai/gpt-5-2025-08-07",
        "openai/gpt-5-codex",
        "openai/gpt-5-mini",
        "openai/gpt-5-mini-2025-08-07",
        "openai/gpt-5-nano",
        "openai/gpt-5-pro",
        "openai/gpt-5.1",
        "openai/gpt-5.1-2025-11-13",
        "openai/gpt-5.1-codex",
        "openai/gpt-5.1-codex-max",
        "openai/gpt-5.1-codex-mini",
        "openai/gpt-5.2",
        "openai/gpt-5.2-2025-12-11",
        "openai/gpt-5.2-codex",
        "openai/gpt-5.2-pro",
        "openai/gpt-5.2-pro-2025-12-11",
        "openai/gpt-5.3-chat-latest",
        "openai/gpt-5.3-codex",
        "openai/gpt-5.4",
        "openai/gpt-5.4-2026-03-05",
        "openai/gpt-5.4-mini",
        "openai/gpt-5.4-mini-2026-03-17",
        "openai/gpt-5.4-nano",
        "openai/gpt-5.4-nano-2026-03-17",
        "openai/gpt-5.4-pro",
        "openai/gpt-5.4-pro-2026-03-05",
        "openai/gpt-5.5",
        "openai/gpt-5.5-2026-04-23",
        "openai/gpt-5.5-pro",
        "openai/gpt-5.5-pro-2026-04-23",
        "openai/o3",
        "openai/o3-mini",
        "openai/o4-mini"
      ],
      "docUrl": "https://docs.netlify.com/build/ai-gateway/overview/"
    }
  },
  "models": {
    "helicone": [
      "chatgpt-4o-latest",
      "claude-3-haiku-20240307",
      "claude-3.5-haiku",
      "claude-3.5-sonnet-v2",
      "claude-3.7-sonnet",
      "claude-4.5-haiku",
      "claude-4.5-opus",
      "claude-4.5-sonnet",
      "claude-haiku-4-5-20251001",
      "claude-opus-4",
      "claude-opus-4-1",
      "claude-opus-4-1-20250805",
      "claude-sonnet-4",
      "claude-sonnet-4-5-20250929",
      "deepseek-r1-distill-llama-70b",
      "deepseek-reasoner",
      "deepseek-tng-r1t2-chimera",
      "deepseek-v3",
      "deepseek-v3.1-terminus",
      "deepseek-v3.2",
      "ernie-4.5-21b-a3b-thinking",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.5-pro",
      "gemini-3-pro-preview",
      "gemma-3-12b-it",
      "gemma2-9b-it",
      "glm-4.6",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-mini-2025-04-14",
      "gpt-4.1-nano",
      "gpt-4o",
      "gpt-4o-mini",
      "gpt-5",
      "gpt-5-chat-latest",
      "gpt-5-codex",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5-pro",
      "gpt-5.1",
      "gpt-5.1-chat-latest",
      "gpt-5.1-codex",
      "gpt-5.1-codex-mini",
      "gpt-oss-120b",
      "gpt-oss-20b",
      "grok-3",
      "grok-3-mini",
      "grok-4",
      "grok-4-1-fast-non-reasoning",
      "grok-4-1-fast-reasoning",
      "grok-4-fast-non-reasoning",
      "grok-4-fast-reasoning",
      "grok-code-fast-1",
      "hermes-2-pro-llama-3-8b",
      "kimi-k2-0711",
      "kimi-k2-0905",
      "kimi-k2-thinking",
      "llama-3.1-8b-instant",
      "llama-3.1-8b-instruct",
      "llama-3.1-8b-instruct-turbo",
      "llama-3.3-70b-instruct",
      "llama-3.3-70b-versatile",
      "llama-4-maverick",
      "llama-4-scout",
      "llama-guard-4",
      "llama-prompt-guard-2-22m",
      "llama-prompt-guard-2-86m",
      "mistral-large-2411",
      "mistral-nemo",
      "mistral-small",
      "o1",
      "o1-mini",
      "o3",
      "o3-mini",
      "o3-pro",
      "o4-mini",
      "qwen2.5-coder-7b-fast",
      "qwen3-235b-a22b-thinking",
      "qwen3-30b-a3b",
      "qwen3-32b",
      "qwen3-coder",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-next-80b-a3b-instruct",
      "qwen3-vl-235b-a22b-instruct",
      "sonar",
      "sonar-deep-research",
      "sonar-pro",
      "sonar-reasoning",
      "sonar-reasoning-pro"
    ],
    "auriko": [
      "claude-opus-4-6",
      "claude-opus-4-7",
      "claude-sonnet-4-6",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "gemini-2.5-flash",
      "gemini-2.5-pro",
      "gemini-3.1-pro-preview",
      "glm-5.1",
      "grok-4.3",
      "kimi-k2.5",
      "kimi-k2.6",
      "minimax-m2-7",
      "minimax-m2-7-highspeed",
      "qwen-3.6-plus"
    ],
    "firepass": ["accounts/fireworks/routers/kimi-k2p6-turbo"],
    "nano-gpt": [
      "Alibaba-NLP/Tongyi-DeepResearch-30B-A3B",
      "Baichuan-M2",
      "Baichuan4-Air",
      "Baichuan4-Turbo",
      "CrucibleLab/L3.3-70B-Loki-V2.0",
      "Doctor-Shotgun/MS3.2-24B-Magnum-Diamond",
      "EVA-UNIT-01/EVA-LLaMA-3.33-70B-v0.0",
      "EVA-UNIT-01/EVA-LLaMA-3.33-70B-v0.1",
      "EVA-UNIT-01/EVA-Qwen2.5-32B-v0.2",
      "EVA-UNIT-01/EVA-Qwen2.5-72B-v0.2",
      "Envoid/Llama-3.05-NT-Storybreaker-Ministral-70B",
      "Envoid/Llama-3.05-Nemotron-Tenyxchat-Storybreaker-70B",
      "GLM-4.5-Air-Derestricted",
      "GLM-4.5-Air-Derestricted-Iceblink",
      "GLM-4.5-Air-Derestricted-Iceblink-ReExtract",
      "GLM-4.5-Air-Derestricted-Iceblink-v2",
      "GLM-4.5-Air-Derestricted-Iceblink-v2-ReExtract",
      "GLM-4.5-Air-Derestricted-Steam",
      "GLM-4.5-Air-Derestricted-Steam-ReExtract",
      "GLM-4.6-Derestricted-v5",
      "GalrionSoftworks/MN-LooseCannon-12B-v1",
      "Gemma-3-27B-ArliAI-RPMax-v3",
      "Gemma-3-27B-Big-Tiger-v3",
      "Gemma-3-27B-CardProjector-v4",
      "Gemma-3-27B-Glitter",
      "Gemma-3-27B-Nidum-Uncensored",
      "Gemma-3-27B-it",
      "Gemma-3-27B-it-Abliterated",
      "Gryphe/MythoMax-L2-13b",
      "Infermatic/MN-12B-Inferor-v0.0",
      "KAT-Coder-Air-V1",
      "KAT-Coder-Exp-72B-1010",
      "KAT-Coder-Pro-V1",
      "LLM360/K2-Think",
      "LatitudeGames/Wayfarer-Large-70B-Llama-3.3",
      "Llama-3.3+(3.1v3.3)-70B-Hanami-x1",
      "Llama-3.3+(3.1v3.3)-70B-New-Dawn-v1.1",
      "Llama-3.3+(3v3.3)-70B-TenyxChat-DaybreakStorywriter",
      "Llama-3.3-70B-Anthrobomination",
      "Llama-3.3-70B-Argunaut-1-SFT",
      "Llama-3.3-70B-ArliAI-RPMax-v1.4",
      "Llama-3.3-70B-ArliAI-RPMax-v2",
      "Llama-3.3-70B-ArliAI-RPMax-v3",
      "Llama-3.3-70B-Aurora-Borealis",
      "Llama-3.3-70B-Bigger-Body",
      "Llama-3.3-70B-Cirrus-x1",
      "Llama-3.3-70B-Cu-Mai-R1",
      "Llama-3.3-70B-Damascus-R1",
      "Llama-3.3-70B-Dark-Ages-v0.1",
      "Llama-3.3-70B-Electra-R1",
      "Llama-3.3-70B-Electranova-v1.0",
      "Llama-3.3-70B-Fallen-R1-v1",
      "Llama-3.3-70B-Fallen-v1",
      "Llama-3.3-70B-Forgotten-Abomination-v5.0",
      "Llama-3.3-70B-Forgotten-Safeword-3.6",
      "Llama-3.3-70B-GeneticLemonade-Opus",
      "Llama-3.3-70B-GeneticLemonade-Unleashed-v3",
      "Llama-3.3-70B-Ignition-v0.1",
      "Llama-3.3-70B-Incandescent-Malevolence",
      "Llama-3.3-70B-Legion-V2.1",
      "Llama-3.3-70B-MS-Nevoria",
      "Llama-3.3-70B-Magnum-v4-SE",
      "Llama-3.3-70B-Magnum-v4-SE-Cirrus-x1-SLERP",
      "Llama-3.3-70B-Mhnnn-x1",
      "Llama-3.3-70B-MiraiFanfare",
      "Llama-3.3-70B-Mokume-Gane-R1",
      "Llama-3.3-70B-Nova",
      "Llama-3.3-70B-Predatorial-Extasy",
      "Llama-3.3-70B-Progenitor-V3.3",
      "Llama-3.3-70B-RAWMAW",
      "Llama-3.3-70B-Sapphira-0.1",
      "Llama-3.3-70B-Sapphira-0.2",
      "Llama-3.3-70B-Shakudo",
      "Llama-3.3-70B-StrawberryLemonade-v1.0",
      "Llama-3.3-70B-Strawberrylemonade-v1.2",
      "Llama-3.3-70B-The-Omega-Directive-Unslop-v2.0",
      "Llama-3.3-70B-The-Omega-Directive-Unslop-v2.1",
      "Llama-3.3-70B-Vulpecula-R1",
      "Magistral-Small-2506",
      "MarinaraSpaghetti/NemoMix-Unleashed-12B",
      "Meta-Llama-3-1-8B-Instruct-FP8",
      "MiniMax-M1",
      "MiniMax-M2",
      "MiniMaxAI/MiniMax-M1-80k",
      "Mistral-Nemo-12B-Instruct-2407",
      "NeverSleep/Llama-3-Lumimaid-70B-v0.1",
      "NeverSleep/Lumimaid-v0.2-70B",
      "NousResearch 2/DeepHermes-3-Mistral-24B-Preview",
      "NousResearch 2/Hermes-4-70B:thinking",
      "NousResearch 2/hermes-3-llama-3.1-70b",
      "NousResearch 2/hermes-4-405b",
      "NousResearch 2/hermes-4-405b:thinking",
      "NousResearch 2/hermes-4-70b",
      "QwQ-32B-ArliAI-RpR-v1",
      "Qwen2.5-32B-EVA-v0.2",
      "ReadyArt/MS3.2-The-Omega-Directive-24B-Unslop-v2.0",
      "ReadyArt/The-Omega-Abomination-L-70B-v1.0",
      "Salesforce/Llama-xLAM-2-70b-fc-r",
      "Sao10K/L3-8B-Stheno-v3.2",
      "Sao10K/L3.1-70B-Euryale-v2.2",
      "Sao10K/L3.1-70B-Hanami-x1",
      "Sao10K/L3.3-70B-Euryale-v2.3",
      "Steelskull/L3.3-Cu-Mai-R1-70b",
      "Steelskull/L3.3-Electra-R1-70b",
      "Steelskull/L3.3-MS-Evalebis-70b",
      "Steelskull/L3.3-MS-Evayale-70B",
      "Steelskull/L3.3-MS-Nevoria-70b",
      "Steelskull/L3.3-Nevoria-R1-70b",
      "TEE/deepseek-r1-0528",
      "TEE/deepseek-v3.1",
      "TEE/deepseek-v3.2",
      "TEE/gemma-3-27b-it",
      "TEE/glm-4.6",
      "TEE/glm-4.7",
      "TEE/glm-4.7-flash",
      "TEE/glm-5",
      "TEE/gpt-oss-120b",
      "TEE/gpt-oss-20b",
      "TEE/kimi-k2-thinking",
      "TEE/kimi-k2.5",
      "TEE/kimi-k2.5-thinking",
      "TEE/llama3-3-70b",
      "TEE/minimax-m2.1",
      "TEE/qwen2.5-vl-72b-instruct",
      "TEE/qwen3-30b-a3b-instruct-2507",
      "TEE/qwen3-coder",
      "TEE/qwen3.5-397b-a17b",
      "THUDM/GLM-4-32B-0414",
      "THUDM/GLM-4-9B-0414",
      "THUDM/GLM-Z1-32B-0414",
      "THUDM/GLM-Z1-9B-0414",
      "THUDM/GLM-Z1-Rumination-32B-0414",
      "TheDrummer 2/Anubis-70B-v1",
      "TheDrummer 2/Anubis-70B-v1.1",
      "TheDrummer 2/Cydonia-24B-v2",
      "TheDrummer 2/Cydonia-24B-v4",
      "TheDrummer 2/Cydonia-24B-v4.1",
      "TheDrummer 2/Cydonia-24B-v4.3",
      "TheDrummer 2/Magidonia-24B-v4.3",
      "TheDrummer 2/Rocinante-12B-v1.1",
      "TheDrummer 2/UnslopNemo-12B-v4.1",
      "TheDrummer 2/skyfall-36b-v2",
      "Tongyi-Zhiwen/QwenLong-L1-32B",
      "VongolaChouko/Starcannon-Unleashed-12B-v1.0",
      "abacusai/Dracarys-72B-Instruct",
      "aion-labs/aion-1.0",
      "aion-labs/aion-1.0-mini",
      "aion-labs/aion-rp-llama-3.1-8b",
      "alibaba/qwen3.6-flash",
      "allenai/molmo-2-8b",
      "allenai/olmo-3-32b-think",
      "allenai/olmo-3.1-32b-instruct",
      "allenai/olmo-3.1-32b-think",
      "amazon/nova-2-lite-v1",
      "amazon/nova-lite-v1",
      "amazon/nova-micro-v1",
      "amazon/nova-pro-v1",
      "anthracite-org/magnum-v2-72b",
      "anthracite-org/magnum-v4-72b",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.6:thinking",
      "anthropic/claude-opus-4.6:thinking:low",
      "anthropic/claude-opus-4.6:thinking:max",
      "anthropic/claude-opus-4.6:thinking:medium",
      "anthropic/claude-sonnet-4.6",
      "anthropic/claude-sonnet-4.6:thinking",
      "arcee-ai/trinity-large",
      "arcee-ai/trinity-mini",
      "asi1-mini",
      "auto-model",
      "auto-model-basic",
      "auto-model-premium",
      "auto-model-standard",
      "azure-gpt-4-turbo",
      "azure-gpt-4o",
      "azure-gpt-4o-mini",
      "azure-o1",
      "azure-o3-mini",
      "baidu/ernie-4.5-300b-a47b",
      "baidu/ernie-4.5-vl-28b-a3b",
      "baseten/Kimi-K2-Instruct-FP4",
      "brave",
      "brave-pro",
      "brave-research",
      "chroma",
      "chutesai/Mistral-Small-3.2-24B-Instruct-2506",
      "claude-3-5-haiku-20241022",
      "claude-3-5-sonnet-20240620",
      "claude-3-5-sonnet-20241022",
      "claude-3-7-sonnet-20250219",
      "claude-3-7-sonnet-reasoner",
      "claude-3-7-sonnet-thinking",
      "claude-3-7-sonnet-thinking:1024",
      "claude-3-7-sonnet-thinking:128000",
      "claude-3-7-sonnet-thinking:32768",
      "claude-3-7-sonnet-thinking:8192",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-1-20250805",
      "claude-opus-4-1-thinking",
      "claude-opus-4-1-thinking:1024",
      "claude-opus-4-1-thinking:32000",
      "claude-opus-4-1-thinking:32768",
      "claude-opus-4-1-thinking:8192",
      "claude-opus-4-20250514",
      "claude-opus-4-5-20251101",
      "claude-opus-4-5-20251101:thinking",
      "claude-opus-4-thinking",
      "claude-opus-4-thinking:1024",
      "claude-opus-4-thinking:32000",
      "claude-opus-4-thinking:32768",
      "claude-opus-4-thinking:8192",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5-20250929",
      "claude-sonnet-4-5-20250929-thinking",
      "claude-sonnet-4-thinking",
      "claude-sonnet-4-thinking:1024",
      "claude-sonnet-4-thinking:32768",
      "claude-sonnet-4-thinking:64000",
      "claude-sonnet-4-thinking:8192",
      "cognitivecomputations/dolphin-2.9.2-qwen2-72b",
      "cohere/command-r",
      "cohere/command-r-plus-08-2024",
      "command-a-reasoning-08-2025",
      "deepclaude",
      "deepcogito/cogito-v1-preview-qwen-32B",
      "deepcogito/cogito-v2.1-671b",
      "deepseek-ai/DeepSeek-R1-0528",
      "deepseek-ai/DeepSeek-V3.1",
      "deepseek-ai/DeepSeek-V3.1-Terminus",
      "deepseek-ai/DeepSeek-V3.1-Terminus:thinking",
      "deepseek-ai/DeepSeek-V3.1:thinking",
      "deepseek-ai/deepseek-v3.2-exp",
      "deepseek-ai/deepseek-v3.2-exp-thinking",
      "deepseek-chat",
      "deepseek-chat-cheaper",
      "deepseek-math-v2",
      "deepseek-r1",
      "deepseek-r1-sambanova",
      "deepseek-reasoner",
      "deepseek-reasoner-cheaper",
      "deepseek-v3-0324",
      "deepseek/deepseek-prover-v2-671b",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-speciale",
      "deepseek/deepseek-v3.2:thinking",
      "dmind/dmind-1",
      "dmind/dmind-1-mini",
      "doubao-1-5-thinking-pro-250415",
      "doubao-1-5-thinking-pro-vision-250415",
      "doubao-1-5-thinking-vision-pro-250428",
      "doubao-1.5-pro-256k",
      "doubao-1.5-pro-32k",
      "doubao-1.5-vision-pro-32k",
      "doubao-seed-1-6-250615",
      "doubao-seed-1-6-flash-250615",
      "doubao-seed-1-6-thinking-250615",
      "doubao-seed-1-8-251215",
      "doubao-seed-2-0-code-preview-260215",
      "doubao-seed-2-0-lite-260215",
      "doubao-seed-2-0-mini-260215",
      "doubao-seed-2-0-pro-260215",
      "doubao-seed-code-preview-latest",
      "ernie-4.5-8k-preview",
      "ernie-4.5-turbo-128k",
      "ernie-4.5-turbo-vl-32k",
      "ernie-5.0-thinking-latest",
      "ernie-5.0-thinking-preview",
      "ernie-x1-32k",
      "ernie-x1-32k-preview",
      "ernie-x1-turbo-32k",
      "ernie-x1.1-preview",
      "essentialai/rnj-1-instruct",
      "exa-answer",
      "exa-research",
      "exa-research-pro",
      "failspy/Meta-Llama-3-70B-Instruct-abliterated-v3.5",
      "fastgpt",
      "featherless-ai/Qwerky-72B",
      "gemini-2.0-flash-001",
      "gemini-2.0-flash-exp-image-generation",
      "gemini-2.0-flash-lite",
      "gemini-2.0-flash-thinking-exp-01-21",
      "gemini-2.0-flash-thinking-exp-1219",
      "gemini-2.0-pro-exp-02-05",
      "gemini-2.0-pro-reasoner",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.5-flash-lite-preview-06-17",
      "gemini-2.5-flash-lite-preview-09-2025",
      "gemini-2.5-flash-lite-preview-09-2025-thinking",
      "gemini-2.5-flash-nothinking",
      "gemini-2.5-flash-preview-04-17",
      "gemini-2.5-flash-preview-04-17:thinking",
      "gemini-2.5-flash-preview-05-20",
      "gemini-2.5-flash-preview-05-20:thinking",
      "gemini-2.5-flash-preview-09-2025",
      "gemini-2.5-flash-preview-09-2025-thinking",
      "gemini-2.5-pro",
      "gemini-2.5-pro-exp-03-25",
      "gemini-2.5-pro-preview-03-25",
      "gemini-2.5-pro-preview-05-06",
      "gemini-2.5-pro-preview-06-05",
      "gemini-3-pro-image-preview",
      "gemini-3-pro-preview",
      "gemini-3-pro-preview-thinking",
      "gemini-exp-1206",
      "glm-4",
      "glm-4-air",
      "glm-4-air-0111",
      "glm-4-airx",
      "glm-4-flash",
      "glm-4-long",
      "glm-4-plus",
      "glm-4-plus-0111",
      "glm-4.1v-thinking-flash",
      "glm-4.1v-thinking-flashx",
      "glm-z1-air",
      "glm-z1-airx",
      "glm-zero-preview",
      "google/gemini-3-flash-preview",
      "google/gemini-3-flash-preview-thinking",
      "google/gemini-flash-1.5",
      "grok-3-beta",
      "grok-3-fast-beta",
      "grok-3-mini-beta",
      "grok-3-mini-fast-beta",
      "hidream",
      "huihui-ai/DeepSeek-R1-Distill-Llama-70B-abliterated",
      "huihui-ai/DeepSeek-R1-Distill-Qwen-32B-abliterated",
      "huihui-ai/Llama-3.1-Nemotron-70B-Instruct-HF-abliterated",
      "huihui-ai/Llama-3.3-70B-Instruct-abliterated",
      "huihui-ai/Qwen2.5-32B-Instruct-abliterated",
      "hunyuan-t1-latest",
      "hunyuan-turbos-20250226",
      "inflatebot/MN-12B-Mag-Mell-R1",
      "inflection/inflection-3-pi",
      "inflection/inflection-3-productivity",
      "jamba-large",
      "jamba-large-1.6",
      "jamba-large-1.7",
      "jamba-mini",
      "jamba-mini-1.6",
      "jamba-mini-1.7",
      "kimi-k2-instruct-fast",
      "kimi-thinking-preview",
      "learnlm-1.5-pro-experimental",
      "meganova-ai/manta-flash-1.0",
      "meganova-ai/manta-mini-1.0",
      "meganova-ai/manta-pro-1.0",
      "meituan-longcat/LongCat-Flash-Chat-FP8",
      "meta-llama/llama-3.1-8b-instruct",
      "meta-llama/llama-3.2-3b-instruct",
      "meta-llama/llama-3.2-90b-vision-instruct",
      "meta-llama/llama-3.3-70b-instruct",
      "meta-llama/llama-4-maverick",
      "meta-llama/llama-4-scout",
      "microsoft/MAI-DS-R1-FP8",
      "microsoft/wizardlm-2-8x22b",
      "minimax/minimax-01",
      "minimax/minimax-m2-her",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.7",
      "miromind-ai/mirothinker-v1.5-235b",
      "mistral-small-31-24b-instruct",
      "mistralai/Devstral-Small-2505",
      "mistralai/Mistral-Nemo-Instruct-2407",
      "mistralai/codestral-2508",
      "mistralai/devstral-2-123b-instruct-2512",
      "mistralai/ministral-14b-2512",
      "mistralai/ministral-14b-instruct-2512",
      "mistralai/ministral-3b-2512",
      "mistralai/ministral-8b-2512",
      "mistralai/mistral-7b-instruct",
      "mistralai/mistral-large",
      "mistralai/mistral-large-3-675b-instruct-2512",
      "mistralai/mistral-medium-3",
      "mistralai/mistral-medium-3.1",
      "mistralai/mistral-saba",
      "mistralai/mistral-small-creative",
      "mistralai/mistral-tiny",
      "mistralai/mixtral-8x22b-instruct-v0.1",
      "mistralai/mixtral-8x7b-instruct-v0.1",
      "mlabonne/NeuralDaredevil-8B-abliterated",
      "moonshotai/Kimi-Dev-72B",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/kimi-k2-instruct",
      "moonshotai/kimi-k2-instruct-0711",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2-thinking-original",
      "moonshotai/kimi-k2-thinking-turbo-original",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.5:thinking",
      "moonshotai/kimi-k2.6",
      "moonshotai/kimi-k2.6:thinking",
      "nex-agi/deepseek-v3.1-nex-n1",
      "nothingiisreal/L3.1-70B-Celeste-V0.1-BF16",
      "nvidia/Llama-3.1-Nemotron-70B-Instruct-HF",
      "nvidia/Llama-3.1-Nemotron-Ultra-253B-v1",
      "nvidia/Llama-3.3-Nemotron-Super-49B-v1",
      "nvidia/Llama-3_3-Nemotron-Super-49B-v1_5",
      "nvidia/nemotron-3-nano-30b-a3b",
      "nvidia/nvidia-nemotron-nano-9b-v2",
      "openai/chatgpt-4o-latest",
      "openai/gpt-3.5-turbo",
      "openai/gpt-4-turbo",
      "openai/gpt-4-turbo-preview",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-2024-08-06",
      "openai/gpt-4o-2024-11-20",
      "openai/gpt-4o-mini",
      "openai/gpt-4o-mini-search-preview",
      "openai/gpt-4o-search-preview",
      "openai/gpt-5",
      "openai/gpt-5-chat-latest",
      "openai/gpt-5-codex",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-2025-11-13",
      "openai/gpt-5.1-chat",
      "openai/gpt-5.1-chat-latest",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "openai/gpt-oss-safeguard-20b",
      "openai/o1",
      "openai/o1-preview",
      "openai/o1-pro",
      "openai/o3",
      "openai/o3-deep-research",
      "openai/o3-mini",
      "openai/o3-mini-high",
      "openai/o3-mini-low",
      "openai/o3-pro-2025-06-10",
      "openai/o4-mini",
      "openai/o4-mini-deep-research",
      "openai/o4-mini-high",
      "pamanseau/OpenReasoning-Nemotron-32B",
      "phi-4-mini-instruct",
      "phi-4-multimodal-instruct",
      "qvq-max",
      "qwen-3.6-plus",
      "qwen-image",
      "qwen-long",
      "qwen-max",
      "qwen-plus",
      "qwen-turbo",
      "qwen/Qwen3.6-35B-A3B",
      "qwen/Qwen3.6-35B-A3B:thinking",
      "qwen/qwen3.5-397b-a17b",
      "qwen25-vl-72b-instruct",
      "qwen3-30b-a3b-instruct-2507",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-max-2026-01-23",
      "qwen3-vl-235b-a22b-instruct-original",
      "qwen3-vl-235b-a22b-thinking",
      "qwen3.6-max-preview",
      "qwq-32b",
      "raifle/sorcererlm-8x22b",
      "sarvan-medium",
      "shisa-ai/shisa-v2-llama3.3-70b",
      "shisa-ai/shisa-v2.1-llama3.3-70b",
      "sonar",
      "sonar-deep-research",
      "sonar-pro",
      "sonar-reasoning-pro",
      "soob3123/GrayLine-Qwen3-8B",
      "soob3123/Veiled-Calla-12B",
      "soob3123/amoral-gemma3-27B-v2",
      "step-2-16k-exp",
      "step-2-mini",
      "step-3",
      "step-r1-v-mini",
      "stepfun-ai/step-3.5-flash",
      "stepfun-ai/step-3.5-flash:thinking",
      "study_gpt-chatgpt-4o-latest",
      "tencent/Hunyuan-MT-7B",
      "tngtech/DeepSeek-TNG-R1T2-Chimera",
      "tngtech/tng-r1t-chimera",
      "undi95/remm-slerp-l2-13b",
      "universal-summarizer",
      "unsloth/gemma-3-12b-it",
      "unsloth/gemma-3-1b-it",
      "unsloth/gemma-3-27b-it",
      "unsloth/gemma-3-4b-it",
      "v0-1.0-md",
      "v0-1.5-lg",
      "v0-1.5-md",
      "venice-uncensored",
      "venice-uncensored:web",
      "x-ai/grok-4-07-09",
      "x-ai/grok-4-fast",
      "x-ai/grok-4-fast:thinking",
      "x-ai/grok-4.1-fast",
      "x-ai/grok-4.1-fast-reasoning",
      "x-ai/grok-code-fast-1",
      "xiaomi/mimo-v2-flash",
      "xiaomi/mimo-v2-flash-original",
      "xiaomi/mimo-v2-flash-thinking",
      "xiaomi/mimo-v2-flash-thinking-original",
      "yi-large",
      "yi-lightning",
      "yi-medium-200k",
      "z-ai/glm-4.5v",
      "z-ai/glm-4.5v:thinking",
      "z-ai/glm-4.6",
      "z-ai/glm-4.6:thinking",
      "z-image-turbo",
      "zai-org/glm-4.7",
      "zai-org/glm-4.7-flash",
      "zai-org/glm-5",
      "zai-org/glm-5.1",
      "zai-org/glm-5.1:thinking",
      "zai-org/glm-5:thinking"
    ],
    "io-net": [
      "Intel/Qwen3-Coder-480B-A35B-Instruct-int4-mixed-ar",
      "Qwen/Qwen2.5-VL-32B-Instruct",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-Next-80B-A3B-Instruct",
      "deepseek-ai/DeepSeek-R1-0528",
      "meta-llama/Llama-3.2-90B-Vision-Instruct",
      "meta-llama/Llama-3.3-70B-Instruct",
      "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
      "mistralai/Devstral-Small-2505",
      "mistralai/Magistral-Small-2506",
      "mistralai/Mistral-Large-Instruct-2411",
      "mistralai/Mistral-Nemo-Instruct-2407",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/Kimi-K2-Thinking",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "zai-org/GLM-4.6"
    ],
    "inception": ["mercury-2", "mercury-edit-2"],
    "submodel": [
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
      "deepseek-ai/DeepSeek-R1-0528",
      "deepseek-ai/DeepSeek-V3-0324",
      "deepseek-ai/DeepSeek-V3.1",
      "openai/gpt-oss-120b",
      "zai-org/GLM-4.5-Air",
      "zai-org/GLM-4.5-FP8"
    ],
    "requesty": [
      "anthropic/claude-3-7-sonnet",
      "anthropic/claude-haiku-4-5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4-1",
      "anthropic/claude-opus-4-5",
      "anthropic/claude-opus-4-6",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4-5",
      "anthropic/claude-sonnet-4-6",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash-preview",
      "google/gemini-3-pro-preview",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4o-mini",
      "openai/gpt-5",
      "openai/gpt-5-chat",
      "openai/gpt-5-codex",
      "openai/gpt-5-image",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-chat",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-pro",
      "openai/o4-mini",
      "xai/grok-4",
      "xai/grok-4-fast"
    ],
    "zai": [
      "glm-4.5",
      "glm-4.5-air",
      "glm-4.5-flash",
      "glm-4.5v",
      "glm-4.6",
      "glm-4.6v",
      "glm-4.7",
      "glm-4.7-flash",
      "glm-4.7-flashx",
      "glm-5",
      "glm-5-turbo",
      "glm-5.1",
      "glm-5v-turbo"
    ],
    "zai-coding-plan": ["glm-4.5-air", "glm-4.7", "glm-5-turbo", "glm-5.1", "glm-5v-turbo"],
    "deepinfra": [
      "MiniMaxAI/MiniMax-M2",
      "MiniMaxAI/MiniMax-M2.1",
      "MiniMaxAI/MiniMax-M2.5",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct-Turbo",
      "Qwen/Qwen3.5-35B-A3B",
      "Qwen/Qwen3.5-397B-A17B",
      "Qwen/Qwen3.6-35B-A3B",
      "anthropic/claude-3-7-sonnet-latest",
      "anthropic/claude-4-opus",
      "deepseek-ai/DeepSeek-R1-0528",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/DeepSeek-V4-Flash",
      "deepseek-ai/DeepSeek-V4-Pro",
      "google/gemma-4-26B-A4B-it",
      "google/gemma-4-31B-it",
      "meta-llama/Llama-3.1-70B-Instruct",
      "meta-llama/Llama-3.1-70B-Instruct-Turbo",
      "meta-llama/Llama-3.1-8B-Instruct",
      "meta-llama/Llama-3.1-8B-Instruct-Turbo",
      "meta-llama/Llama-3.3-70B-Instruct-Turbo",
      "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
      "meta-llama/Llama-4-Scout-17B-16E-Instruct",
      "moonshotai/Kimi-K2-Instruct",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/Kimi-K2-Thinking",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "xiaomi/mimo-v2.5",
      "xiaomi/mimo-v2.5-pro",
      "zai-org/GLM-4.6",
      "zai-org/GLM-4.6V",
      "zai-org/GLM-4.7",
      "zai-org/GLM-4.7-Flash",
      "zai-org/GLM-5",
      "zai-org/GLM-5.1"
    ],
    "clarifai": [
      "arcee_ai/AFM/models/trinity-mini",
      "clarifai/main/models/mm-poly-8b",
      "deepseek-ai/deepseek-ocr/models/DeepSeek-OCR",
      "minimaxai/chat-completion/models/MiniMax-M2_5-high-throughput",
      "mistralai/completion/models/Ministral-3-14B-Reasoning-2512",
      "mistralai/completion/models/Ministral-3-3B-Reasoning-2512",
      "moonshotai/chat-completion/models/Kimi-K2_6",
      "openai/chat-completion/models/gpt-oss-120b-high-throughput",
      "openai/chat-completion/models/gpt-oss-20b",
      "qwen/qwenCoder/models/Qwen3-Coder-30B-A3B-Instruct",
      "qwen/qwenLM/models/Qwen3-30B-A3B-Instruct-2507",
      "qwen/qwenLM/models/Qwen3-30B-A3B-Thinking-2507"
    ],
    "moark": ["GLM-4.7", "MiniMax-M2.1"],
    "frogbot": [
      "claude-haiku-4-5",
      "claude-opus-4-6",
      "claude-opus-4-7",
      "claude-sonnet-4-6",
      "deepseek-v4-pro",
      "gemini-2.5-flash",
      "gemini-2.5-pro",
      "gemini-3-1-pro-preview",
      "gemini-3-flash-preview",
      "gpt-4o",
      "gpt-5-3-codex",
      "gpt-5-4-mini",
      "gpt-5-4-nano",
      "gpt-5-5",
      "gpt-oss-120b",
      "gpt-oss-20b",
      "grok-4-1-fast-non-reasoning",
      "grok-4-1-fast-reasoning",
      "grok-4-3",
      "grok-code-fast-1",
      "kimi-k2-6",
      "kimi-k2.5",
      "minimax-m2-5",
      "minimax-m2-7",
      "qwen-3-6-plus",
      "zai-glm-5-1"
    ],
    "wandb": [
      "MiniMaxAI/MiniMax-M2.5",
      "OpenPipe/Qwen3-14B-Instruct",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "deepseek-ai/DeepSeek-V3.1",
      "meta-llama/Llama-3.1-70B-Instruct",
      "meta-llama/Llama-3.1-8B-Instruct",
      "meta-llama/Llama-3.3-70B-Instruct",
      "meta-llama/Llama-4-Scout-17B-16E-Instruct",
      "microsoft/Phi-4-mini-instruct",
      "moonshotai/Kimi-K2.5",
      "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-FP8",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "zai-org/GLM-5-FP8",
      "zai-org/GLM-5.1"
    ],
    "gmicloud": [
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-sonnet-4.6",
      "deepseek-ai/DeepSeek-V4-Flash",
      "deepseek-ai/DeepSeek-V4-Pro",
      "moonshotai/Kimi-K2.6",
      "zai-org/GLM-5-FP8",
      "zai-org/GLM-5.1-FP8"
    ],
    "crof": [
      "deepseek-v3.2",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "deepseek-v4-pro-precision",
      "gemma-4-31b-it",
      "glm-4.7",
      "glm-4.7-flash",
      "glm-5",
      "glm-5.1",
      "glm-5.1-precision",
      "greg",
      "kimi-k2.5",
      "kimi-k2.5-lightning",
      "kimi-k2.6",
      "kimi-k2.6-precision",
      "mimo-v2.5-pro",
      "mimo-v2.5-pro-precision",
      "minimax-m2.5",
      "qwen3.5-397b-a17b",
      "qwen3.5-9b",
      "qwen3.6-27b"
    ],
    "ambient": ["moonshotai/kimi-k2.6", "zai-org/GLM-5.1-FP8"],
    "routing-run": [
      "route/deepseek-v3.2",
      "route/deepseek-v4-flash",
      "route/deepseek-v4-flash-6bit",
      "route/deepseek-v4-pro",
      "route/deepseek-v4-pro-6bit",
      "route/gemma-4-31b-it",
      "route/glm-5.1",
      "route/glm-5.1-6bit",
      "route/kimi-k2.5",
      "route/kimi-k2.6",
      "route/kimi-k2.6-6bit",
      "route/mimo-v2.5-pro",
      "route/mimo-v2.5-pro-6bit",
      "route/minimax-m2.5",
      "route/minimax-m2.5-highspeed",
      "route/minimax-m2.7",
      "route/minimax-m2.7-highspeed",
      "route/mistral-large-3",
      "route/mistral-medium-2505",
      "route/mistral-small-2503",
      "route/qwen3.6-27b",
      "route/step-3.5-flash",
      "route/step-3.5-flash-2603",
      "route/stepfun-3.5-flash"
    ],
    "the-grid-ai": [
      "agent-max",
      "agent-prime",
      "agent-standard",
      "code-max",
      "code-prime",
      "code-standard",
      "text-max",
      "text-prime",
      "text-standard"
    ],
    "fastrouter": [
      "anthropic/claude-opus-4.1",
      "anthropic/claude-sonnet-4",
      "deepseek-ai/deepseek-r1-distill-llama-70b",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-pro",
      "moonshotai/kimi-k2",
      "openai/gpt-4.1",
      "openai/gpt-5",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "qwen/qwen3-coder",
      "x-ai/grok-4",
      "z-ai/glm-5"
    ],
    "tencent-coding-plan": [
      "glm-5",
      "hunyuan-2.0-instruct",
      "hunyuan-2.0-thinking",
      "hunyuan-t1",
      "hunyuan-turbos",
      "kimi-k2.5",
      "minimax-m2.5",
      "tc-code-latest"
    ],
    "cortecs": [
      "claude-4-5-sonnet",
      "claude-4-6-sonnet",
      "claude-haiku-4-5",
      "claude-opus4-5",
      "claude-opus4-6",
      "claude-opus4-7",
      "claude-sonnet-4",
      "codestral-2508",
      "deepseek-r1-0528",
      "deepseek-v3-0324",
      "deepseek-v3.2",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "devstral-2512",
      "devstral-small-2512",
      "gemini-2.5-pro",
      "glm-4.5",
      "glm-4.5-air",
      "glm-4.7",
      "glm-4.7-flash",
      "glm-5",
      "glm-5.1",
      "gpt-4.1",
      "gpt-oss-120b",
      "hermes-4-70b",
      "intellect-3",
      "kimi-k2-instruct",
      "kimi-k2-thinking",
      "kimi-k2.5",
      "kimi-k2.6",
      "llama-3.1-405b-instruct",
      "llama-3.3-70b-instruct",
      "minimax-m2",
      "minimax-m2.1",
      "minimax-m2.5",
      "minimax-m2.7",
      "mistral-large-2512",
      "mixtral-8x7B-instruct-v0.1",
      "nemotron-3-super-120b-a12b",
      "nova-pro-v1",
      "qwen-2.5-72b-instruct",
      "qwen3-235b-a22b-instruct-2507",
      "qwen3-32b",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-coder-next",
      "qwen3-next-80b-a3b-thinking",
      "qwen3.5-122b-a10b",
      "qwen3.5-397b-a17b"
    ],
    "baseten": [
      "MiniMaxAI/MiniMax-M2.5",
      "deepseek-ai/DeepSeek-V3-0324",
      "deepseek-ai/DeepSeek-V3.1",
      "deepseek-ai/DeepSeek-V4-Pro",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "nvidia/Nemotron-120B-A12B",
      "openai/gpt-oss-120b",
      "zai-org/GLM-4.6",
      "zai-org/GLM-4.7",
      "zai-org/GLM-5"
    ],
    "llama": [
      "cerebras-llama-4-maverick-17b-128e-instruct",
      "cerebras-llama-4-scout-17b-16e-instruct",
      "groq-llama-4-maverick-17b-128e-instruct",
      "llama-3.3-70b-instruct",
      "llama-3.3-8b-instruct",
      "llama-4-maverick-17b-128e-instruct-fp8",
      "llama-4-scout-17b-16e-instruct-fp8"
    ],
    "novita-ai": [
      "baichuan/baichuan-m2-32b",
      "baidu/ernie-4.5-21B-a3b",
      "baidu/ernie-4.5-21B-a3b-thinking",
      "baidu/ernie-4.5-300b-a47b-paddle",
      "baidu/ernie-4.5-vl-28b-a3b",
      "baidu/ernie-4.5-vl-28b-a3b-thinking",
      "baidu/ernie-4.5-vl-424b-a47b",
      "deepseek/deepseek-ocr",
      "deepseek/deepseek-ocr-2",
      "deepseek/deepseek-prover-v2-671b",
      "deepseek/deepseek-r1-0528",
      "deepseek/deepseek-r1-0528-qwen3-8b",
      "deepseek/deepseek-r1-distill-llama-70b",
      "deepseek/deepseek-r1-distill-qwen-14b",
      "deepseek/deepseek-r1-distill-qwen-32b",
      "deepseek/deepseek-r1-turbo",
      "deepseek/deepseek-v3-0324",
      "deepseek/deepseek-v3-turbo",
      "deepseek/deepseek-v3.1",
      "deepseek/deepseek-v3.1-terminus",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-pro",
      "google/gemma-3-12b-it",
      "google/gemma-3-27b-it",
      "google/gemma-4-26b-a4b-it",
      "google/gemma-4-31b-it",
      "gryphe/mythomax-l2-13b",
      "inclusionai/ling-2.6-1t",
      "inclusionai/ling-2.6-flash",
      "kwaipilot/kat-coder-pro",
      "meta-llama/llama-3-70b-instruct",
      "meta-llama/llama-3-8b-instruct",
      "meta-llama/llama-3.1-8b-instruct",
      "meta-llama/llama-3.2-3b-instruct",
      "meta-llama/llama-3.3-70b-instruct",
      "meta-llama/llama-4-maverick-17b-128e-instruct-fp8",
      "meta-llama/llama-4-scout-17b-16e-instruct",
      "microsoft/wizardlm-2-8x22b",
      "minimax/minimax-m2",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5-highspeed",
      "minimax/minimax-m2.7",
      "minimaxai/minimax-m1-80k",
      "mistralai/mistral-nemo",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-instruct",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.6",
      "nousresearch/hermes-2-pro-llama-3-8b",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "paddlepaddle/paddleocr-vl",
      "qwen/qwen-2.5-72b-instruct",
      "qwen/qwen-mt-plus",
      "qwen/qwen2.5-7b-instruct",
      "qwen/qwen2.5-vl-72b-instruct",
      "qwen/qwen3-235b-a22b-fp8",
      "qwen/qwen3-235b-a22b-instruct-2507",
      "qwen/qwen3-235b-a22b-thinking-2507",
      "qwen/qwen3-30b-a3b-fp8",
      "qwen/qwen3-32b-fp8",
      "qwen/qwen3-4b-fp8",
      "qwen/qwen3-8b-fp8",
      "qwen/qwen3-coder-30b-a3b-instruct",
      "qwen/qwen3-coder-480b-a35b-instruct",
      "qwen/qwen3-coder-next",
      "qwen/qwen3-max",
      "qwen/qwen3-next-80b-a3b-instruct",
      "qwen/qwen3-next-80b-a3b-thinking",
      "qwen/qwen3-omni-30b-a3b-instruct",
      "qwen/qwen3-omni-30b-a3b-thinking",
      "qwen/qwen3-vl-235b-a22b-instruct",
      "qwen/qwen3-vl-235b-a22b-thinking",
      "qwen/qwen3-vl-30b-a3b-instruct",
      "qwen/qwen3-vl-30b-a3b-thinking",
      "qwen/qwen3-vl-8b-instruct",
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-27b",
      "qwen/qwen3.5-35b-a3b",
      "qwen/qwen3.5-397b-a17b",
      "sao10K/L3-8B-stheno-v3.2",
      "sao10K/l3-70b-euryale-v2.1",
      "sao10K/l3-8b-lunaris",
      "sao10K/l31-70b-euryale-v2.2",
      "xiaomimimo/mimo-v2-flash",
      "zai-org/autoglm-phone-9b-multilingual",
      "zai-org/glm-4.5",
      "zai-org/glm-4.5-air",
      "zai-org/glm-4.5v",
      "zai-org/glm-4.6",
      "zai-org/glm-4.6v",
      "zai-org/glm-4.7",
      "zai-org/glm-4.7-flash",
      "zai-org/glm-5",
      "zai-org/glm-5.1"
    ],
    "digitalocean": [
      "alibaba-qwen3-32b",
      "all-mini-lm-l6-v2",
      "anthropic-claude-4.1-opus",
      "anthropic-claude-4.5-haiku",
      "anthropic-claude-4.5-sonnet",
      "anthropic-claude-4.6-sonnet",
      "anthropic-claude-haiku-4.5",
      "anthropic-claude-opus-4",
      "anthropic-claude-opus-4.5",
      "anthropic-claude-opus-4.6",
      "anthropic-claude-opus-4.7",
      "anthropic-claude-sonnet-4",
      "arcee-trinity-large-thinking",
      "bge-m3",
      "bge-reranker-v2-m3",
      "deepseek-3.2",
      "deepseek-r1-distill-llama-70b",
      "deepseek-v3",
      "deepseek-v4-pro",
      "e5-large-v2",
      "fal-ai/elevenlabs/tts/multilingual-v2",
      "fal-ai/fast-sdxl",
      "fal-ai/flux/schnell",
      "fal-ai/stable-audio-25/text-to-audio",
      "gemma-4-31B-it",
      "glm-5",
      "gte-large-en-v1.5",
      "kimi-k2.5",
      "kimi-k2.6",
      "llama-4-maverick",
      "llama3-8b-instruct",
      "llama3.3-70b-instruct",
      "minimax-m2.5",
      "ministral-3-8b-instruct-2512",
      "mistral-3-14B",
      "mistral-7b-instruct-v0.3",
      "multi-qa-mpnet-base-dot-v1",
      "nemotron-3-nano-30b",
      "nemotron-3-nano-omni",
      "nemotron-nano-12b-v2-vl",
      "nvidia-nemotron-3-super-120b",
      "openai-gpt-4.1",
      "openai-gpt-4o",
      "openai-gpt-4o-mini",
      "openai-gpt-5",
      "openai-gpt-5-mini",
      "openai-gpt-5-nano",
      "openai-gpt-5.1-codex-max",
      "openai-gpt-5.2",
      "openai-gpt-5.2-pro",
      "openai-gpt-5.3-codex",
      "openai-gpt-5.4",
      "openai-gpt-5.4-mini",
      "openai-gpt-5.4-nano",
      "openai-gpt-5.4-pro",
      "openai-gpt-5.5",
      "openai-gpt-image-1",
      "openai-gpt-image-1.5",
      "openai-gpt-image-2",
      "openai-gpt-oss-120b",
      "openai-gpt-oss-20b",
      "openai-o1",
      "openai-o3",
      "openai-o3-mini",
      "qwen-2.5-14b-instruct",
      "qwen3-coder-flash",
      "qwen3-embedding-0.6b",
      "qwen3-tts-voicedesign",
      "qwen3.5-397b-a17b",
      "stable-diffusion-3.5-large",
      "wan2-2-t2v-a14b"
    ],
    "moonshotai": [
      "kimi-k2-0711-preview",
      "kimi-k2-0905-preview",
      "kimi-k2-thinking",
      "kimi-k2-thinking-turbo",
      "kimi-k2-turbo-preview",
      "kimi-k2.5",
      "kimi-k2.6"
    ],
    "mistral": [
      "codestral-latest",
      "devstral-2512",
      "devstral-medium-2507",
      "devstral-medium-latest",
      "devstral-small-2505",
      "devstral-small-2507",
      "labs-devstral-small-2512",
      "magistral-medium-latest",
      "magistral-small",
      "ministral-3b-latest",
      "ministral-8b-latest",
      "mistral-embed",
      "mistral-large-2411",
      "mistral-large-2512",
      "mistral-large-latest",
      "mistral-medium-2505",
      "mistral-medium-2508",
      "mistral-medium-2604",
      "mistral-medium-latest",
      "mistral-nemo",
      "mistral-small-2506",
      "mistral-small-2603",
      "mistral-small-latest",
      "open-mistral-7b",
      "open-mixtral-8x22b",
      "open-mixtral-8x7b",
      "pixtral-12b",
      "pixtral-large-latest"
    ],
    "kilo": [
      "ai21/jamba-large-1.7",
      "aion-labs/aion-1.0",
      "aion-labs/aion-1.0-mini",
      "aion-labs/aion-2.0",
      "aion-labs/aion-rp-llama-3.1-8b",
      "alfredpros/codellama-7b-instruct-solidity",
      "alibaba/tongyi-deepresearch-30b-a3b",
      "allenai/olmo-3-32b-think",
      "amazon/nova-2-lite-v1",
      "amazon/nova-lite-v1",
      "amazon/nova-micro-v1",
      "amazon/nova-premier-v1",
      "amazon/nova-pro-v1",
      "anthracite-org/magnum-v4-72b",
      "anthropic/claude-3-haiku",
      "anthropic/claude-3.5-haiku",
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.6-fast",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-opus-4.7-fast",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "arcee-ai/coder-large",
      "arcee-ai/maestro-reasoning",
      "arcee-ai/spotlight",
      "arcee-ai/trinity-large-preview",
      "arcee-ai/trinity-large-thinking",
      "arcee-ai/trinity-mini",
      "arcee-ai/virtuoso-large",
      "baidu/cobuddy:free",
      "baidu/ernie-4.5-21b-a3b",
      "baidu/ernie-4.5-21b-a3b-thinking",
      "baidu/ernie-4.5-300b-a47b",
      "baidu/ernie-4.5-vl-28b-a3b",
      "baidu/ernie-4.5-vl-424b-a47b",
      "baidu/qianfan-ocr-fast",
      "bytedance-seed/seed-1.6",
      "bytedance-seed/seed-1.6-flash",
      "bytedance-seed/seed-2.0-lite",
      "bytedance-seed/seed-2.0-mini",
      "bytedance/ui-tars-1.5-7b",
      "cohere/command-a",
      "cohere/command-r-08-2024",
      "cohere/command-r-plus-08-2024",
      "cohere/command-r7b-12-2024",
      "deepcogito/cogito-v2.1-671b",
      "deepseek/deepseek-chat",
      "deepseek/deepseek-chat-v3-0324",
      "deepseek/deepseek-chat-v3.1",
      "deepseek/deepseek-r1",
      "deepseek/deepseek-r1-0528",
      "deepseek/deepseek-r1-distill-llama-70b",
      "deepseek/deepseek-r1-distill-qwen-32b",
      "deepseek/deepseek-v3.1-terminus",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v3.2-speciale",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-flash:free",
      "deepseek/deepseek-v4-pro",
      "essentialai/rnj-1-instruct",
      "google/gemini-2.0-flash-001",
      "google/gemini-2.0-flash-lite-001",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-image",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-flash-lite-preview-09-2025",
      "google/gemini-2.5-pro",
      "google/gemini-2.5-pro-preview",
      "google/gemini-2.5-pro-preview-05-06",
      "google/gemini-3-flash-preview",
      "google/gemini-3-pro-image-preview",
      "google/gemini-3.1-flash-image-preview",
      "google/gemini-3.1-flash-lite",
      "google/gemini-3.1-flash-lite-preview",
      "google/gemini-3.1-pro-preview",
      "google/gemini-3.1-pro-preview-customtools",
      "google/gemma-2-27b-it",
      "google/gemma-3-12b-it",
      "google/gemma-3-27b-it",
      "google/gemma-3-4b-it",
      "google/gemma-3n-e4b-it",
      "google/gemma-4-26b-a4b-it",
      "google/gemma-4-31b-it",
      "google/lyria-3-clip-preview",
      "google/lyria-3-pro-preview",
      "gryphe/mythomax-l2-13b",
      "ibm-granite/granite-4.0-h-micro",
      "ibm-granite/granite-4.1-8b",
      "inception/mercury-2",
      "inclusionai/ling-2.6-1t",
      "inclusionai/ling-2.6-flash",
      "inclusionai/ring-2.6-1t",
      "inflection/inflection-3-pi",
      "inflection/inflection-3-productivity",
      "kilo-auto/balanced",
      "kilo-auto/free",
      "kilo-auto/frontier",
      "kilo-auto/small",
      "kwaipilot/kat-coder-pro-v2",
      "liquid/lfm-2-24b-a2b",
      "mancer/weaver",
      "meta-llama/llama-3-70b-instruct",
      "meta-llama/llama-3-8b-instruct",
      "meta-llama/llama-3.1-70b-instruct",
      "meta-llama/llama-3.1-8b-instruct",
      "meta-llama/llama-3.2-11b-vision-instruct",
      "meta-llama/llama-3.2-1b-instruct",
      "meta-llama/llama-3.2-3b-instruct",
      "meta-llama/llama-3.3-70b-instruct",
      "meta-llama/llama-4-maverick",
      "meta-llama/llama-4-scout",
      "meta-llama/llama-guard-3-8b",
      "meta-llama/llama-guard-4-12b",
      "microsoft/phi-4",
      "microsoft/phi-4-mini-instruct",
      "microsoft/wizardlm-2-8x22b",
      "minimax/minimax-01",
      "minimax/minimax-m1",
      "minimax/minimax-m2",
      "minimax/minimax-m2-her",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.7",
      "mistralai/codestral-2508",
      "mistralai/devstral-2512",
      "mistralai/devstral-medium",
      "mistralai/devstral-small",
      "mistralai/ministral-14b-2512",
      "mistralai/ministral-3b-2512",
      "mistralai/ministral-8b-2512",
      "mistralai/mistral-7b-instruct-v0.1",
      "mistralai/mistral-large",
      "mistralai/mistral-large-2407",
      "mistralai/mistral-large-2411",
      "mistralai/mistral-large-2512",
      "mistralai/mistral-medium-3",
      "mistralai/mistral-medium-3-5",
      "mistralai/mistral-medium-3.1",
      "mistralai/mistral-nemo",
      "mistralai/mistral-saba",
      "mistralai/mistral-small-24b-instruct-2501",
      "mistralai/mistral-small-2603",
      "mistralai/mistral-small-3.1-24b-instruct",
      "mistralai/mistral-small-3.2-24b-instruct",
      "mistralai/mixtral-8x22b-instruct",
      "mistralai/pixtral-large-2411",
      "mistralai/voxtral-small-24b-2507",
      "moonshotai/kimi-k2",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.6",
      "morph/morph-v3-fast",
      "morph/morph-v3-large",
      "nex-agi/deepseek-v3.1-nex-n1",
      "nousresearch/hermes-2-pro-llama-3-8b",
      "nousresearch/hermes-3-llama-3.1-405b",
      "nousresearch/hermes-3-llama-3.1-70b",
      "nousresearch/hermes-4-405b",
      "nousresearch/hermes-4-70b",
      "nvidia/llama-3.3-nemotron-super-49b-v1.5",
      "nvidia/nemotron-3-nano-30b-a3b",
      "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
      "nvidia/nemotron-3-super-120b-a12b",
      "nvidia/nemotron-3-super-120b-a12b:free",
      "nvidia/nemotron-nano-9b-v2",
      "openai/gpt-3.5-turbo",
      "openai/gpt-3.5-turbo-0613",
      "openai/gpt-3.5-turbo-16k",
      "openai/gpt-3.5-turbo-instruct",
      "openai/gpt-4",
      "openai/gpt-4-0314",
      "openai/gpt-4-1106-preview",
      "openai/gpt-4-turbo",
      "openai/gpt-4-turbo-preview",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-2024-05-13",
      "openai/gpt-4o-2024-08-06",
      "openai/gpt-4o-2024-11-20",
      "openai/gpt-4o-audio-preview",
      "openai/gpt-4o-mini",
      "openai/gpt-4o-mini-2024-07-18",
      "openai/gpt-4o-mini-search-preview",
      "openai/gpt-4o-search-preview",
      "openai/gpt-5",
      "openai/gpt-5-chat",
      "openai/gpt-5-codex",
      "openai/gpt-5-image",
      "openai/gpt-5-image-mini",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-chat",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-chat",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-image-2",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "openai/gpt-audio",
      "openai/gpt-audio-mini",
      "openai/gpt-chat-latest",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "openai/gpt-oss-safeguard-20b",
      "openai/o1",
      "openai/o1-pro",
      "openai/o3",
      "openai/o3-deep-research",
      "openai/o3-mini",
      "openai/o3-mini-high",
      "openai/o3-pro",
      "openai/o4-mini",
      "openai/o4-mini-deep-research",
      "openai/o4-mini-high",
      "openrouter/auto",
      "openrouter/bodybuilder",
      "openrouter/free",
      "openrouter/owl-alpha",
      "openrouter/pareto-code",
      "perceptron/perceptron-mk1",
      "perplexity/sonar",
      "perplexity/sonar-deep-research",
      "perplexity/sonar-pro",
      "perplexity/sonar-pro-search",
      "perplexity/sonar-reasoning-pro",
      "poolside/laguna-m.1:free",
      "poolside/laguna-xs.2:free",
      "prime-intellect/intellect-3",
      "qwen/qwen-2.5-72b-instruct",
      "qwen/qwen-2.5-7b-instruct",
      "qwen/qwen-2.5-coder-32b-instruct",
      "qwen/qwen-plus",
      "qwen/qwen-plus-2025-07-28",
      "qwen/qwen-plus-2025-07-28:thinking",
      "qwen/qwen2.5-vl-72b-instruct",
      "qwen/qwen3-14b",
      "qwen/qwen3-235b-a22b",
      "qwen/qwen3-235b-a22b-2507",
      "qwen/qwen3-235b-a22b-thinking-2507",
      "qwen/qwen3-30b-a3b",
      "qwen/qwen3-30b-a3b-instruct-2507",
      "qwen/qwen3-30b-a3b-thinking-2507",
      "qwen/qwen3-32b",
      "qwen/qwen3-8b",
      "qwen/qwen3-coder",
      "qwen/qwen3-coder-30b-a3b-instruct",
      "qwen/qwen3-coder-flash",
      "qwen/qwen3-coder-next",
      "qwen/qwen3-coder-plus",
      "qwen/qwen3-max",
      "qwen/qwen3-max-thinking",
      "qwen/qwen3-next-80b-a3b-instruct",
      "qwen/qwen3-next-80b-a3b-thinking",
      "qwen/qwen3-vl-235b-a22b-instruct",
      "qwen/qwen3-vl-235b-a22b-thinking",
      "qwen/qwen3-vl-30b-a3b-instruct",
      "qwen/qwen3-vl-30b-a3b-thinking",
      "qwen/qwen3-vl-32b-instruct",
      "qwen/qwen3-vl-8b-instruct",
      "qwen/qwen3-vl-8b-thinking",
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-27b",
      "qwen/qwen3.5-35b-a3b",
      "qwen/qwen3.5-397b-a17b",
      "qwen/qwen3.5-9b",
      "qwen/qwen3.5-flash-02-23",
      "qwen/qwen3.5-plus-02-15",
      "qwen/qwen3.5-plus-20260420",
      "qwen/qwen3.6-27b",
      "qwen/qwen3.6-35b-a3b",
      "qwen/qwen3.6-flash",
      "qwen/qwen3.6-max-preview",
      "qwen/qwen3.6-plus",
      "rekaai/reka-edge",
      "rekaai/reka-flash-3",
      "relace/relace-apply-3",
      "relace/relace-search",
      "sao10k/l3-euryale-70b",
      "sao10k/l3-lunaris-8b",
      "sao10k/l3.1-70b-hanami-x1",
      "sao10k/l3.1-euryale-70b",
      "sao10k/l3.3-euryale-70b",
      "stepfun/step-3.5-flash",
      "stepfun/step-3.5-flash:free",
      "switchpoint/router",
      "tencent/hunyuan-a13b-instruct",
      "tencent/hy3-preview",
      "thedrummer/cydonia-24b-v4.1",
      "thedrummer/rocinante-12b",
      "thedrummer/skyfall-36b-v2",
      "thedrummer/unslopnemo-12b",
      "undi95/remm-slerp-l2-13b",
      "upstage/solar-pro-3",
      "writer/palmyra-x5",
      "x-ai/grok-4.20",
      "x-ai/grok-4.20-multi-agent",
      "x-ai/grok-4.3",
      "x-ai/grok-code-fast-1:optimized:free",
      "xiaomi/mimo-v2-flash",
      "xiaomi/mimo-v2-omni",
      "xiaomi/mimo-v2-pro",
      "xiaomi/mimo-v2.5",
      "xiaomi/mimo-v2.5-pro",
      "z-ai/glm-4-32b",
      "z-ai/glm-4.5",
      "z-ai/glm-4.5-air",
      "z-ai/glm-4.5v",
      "z-ai/glm-4.6",
      "z-ai/glm-4.6v",
      "z-ai/glm-4.7",
      "z-ai/glm-4.7-flash",
      "z-ai/glm-5",
      "z-ai/glm-5-turbo",
      "z-ai/glm-5.1",
      "z-ai/glm-5v-turbo",
      "~anthropic/claude-haiku-latest",
      "~anthropic/claude-opus-latest",
      "~anthropic/claude-sonnet-latest",
      "~google/gemini-flash-latest",
      "~google/gemini-pro-latest",
      "~moonshotai/kimi-latest",
      "~openai/gpt-latest",
      "~openai/gpt-mini-latest"
    ],
    "cloudflare-workers-ai": [
      "@cf/aisingapore/gemma-sea-lion-v4-27b-it",
      "@cf/deepseek-ai/deepseek-r1-distill-qwen-32b",
      "@cf/google/gemma-3-12b-it",
      "@cf/google/gemma-4-26b-a4b-it",
      "@cf/ibm-granite/granite-4.0-h-micro",
      "@cf/meta/llama-2-7b-chat-fp16",
      "@cf/meta/llama-3-8b-instruct",
      "@cf/meta/llama-3-8b-instruct-awq",
      "@cf/meta/llama-3.1-8b-instruct-awq",
      "@cf/meta/llama-3.1-8b-instruct-fp8",
      "@cf/meta/llama-3.2-11b-vision-instruct",
      "@cf/meta/llama-3.2-1b-instruct",
      "@cf/meta/llama-3.2-3b-instruct",
      "@cf/meta/llama-3.3-70b-instruct-fp8-fast",
      "@cf/meta/llama-4-scout-17b-16e-instruct",
      "@cf/meta/llama-guard-3-8b",
      "@cf/mistral/mistral-7b-instruct-v0.1",
      "@cf/mistralai/mistral-small-3.1-24b-instruct",
      "@cf/moonshotai/kimi-k2.5",
      "@cf/moonshotai/kimi-k2.6",
      "@cf/nvidia/nemotron-3-120b-a12b",
      "@cf/openai/gpt-oss-120b",
      "@cf/openai/gpt-oss-20b",
      "@cf/qwen/qwen2.5-coder-32b-instruct",
      "@cf/qwen/qwen3-30b-a3b-fp8",
      "@cf/qwen/qwq-32b",
      "@cf/zai-org/glm-4.7-flash"
    ],
    "lmstudio": ["openai/gpt-oss-20b", "qwen/qwen3-30b-a3b-2507", "qwen/qwen3-coder-30b"],
    "xiaomi-token-plan-cn": [
      "mimo-v2-flash",
      "mimo-v2-omni",
      "mimo-v2-pro",
      "mimo-v2-tts",
      "mimo-v2.5",
      "mimo-v2.5-pro"
    ],
    "morph": ["auto", "morph-v3-fast", "morph-v3-large"],
    "nearai": [
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-Embedding-0.6B",
      "Qwen/Qwen3-Reranker-0.6B",
      "Qwen/Qwen3-VL-30B-A3B-Instruct",
      "Qwen/Qwen3.5-122B-A10B",
      "anthropic/claude-haiku-4-5",
      "anthropic/claude-opus-4-6",
      "anthropic/claude-opus-4-7",
      "anthropic/claude-sonnet-4-5",
      "anthropic/claude-sonnet-4-6",
      "black-forest-labs/FLUX.2-klein-4B",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-pro",
      "google/gemini-3.1-flash-lite",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-5",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5.1",
      "openai/gpt-5.2",
      "openai/gpt-5.4",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.5",
      "openai/gpt-oss-120b",
      "openai/o3",
      "openai/o3-mini",
      "openai/o4-mini",
      "openai/whisper-large-v3",
      "zai-org/GLM-5.1-FP8"
    ],
    "abacus": [
      "Qwen/QwQ-32B",
      "Qwen/Qwen2.5-72B-Instruct",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-32B",
      "Qwen/qwen3-coder-480b-a35b-instruct",
      "claude-3-7-sonnet-20250219",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-1-20250805",
      "claude-opus-4-20250514",
      "claude-opus-4-5-20251101",
      "claude-opus-4-6",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5-20250929",
      "claude-sonnet-4-6",
      "deepseek-ai/DeepSeek-R1",
      "deepseek-ai/DeepSeek-V3.1-Terminus",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek/deepseek-v3.1",
      "gemini-2.5-flash",
      "gemini-2.5-pro",
      "gemini-3-flash-preview",
      "gemini-3.1-flash-lite-preview",
      "gemini-3.1-pro-preview",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-nano",
      "gpt-4o-2024-11-20",
      "gpt-4o-mini",
      "gpt-5",
      "gpt-5-codex",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5.1",
      "gpt-5.1-chat-latest",
      "gpt-5.1-codex",
      "gpt-5.1-codex-max",
      "gpt-5.2",
      "gpt-5.2-chat-latest",
      "gpt-5.2-codex",
      "gpt-5.3-chat-latest",
      "gpt-5.3-codex",
      "gpt-5.3-codex-xhigh",
      "gpt-5.4",
      "grok-4-0709",
      "grok-4-1-fast-non-reasoning",
      "grok-4-fast-non-reasoning",
      "grok-code-fast-1",
      "kimi-k2-turbo-preview",
      "kimi-k2.5",
      "llama-3.3-70b-versatile",
      "meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
      "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
      "meta-llama/Meta-Llama-3.1-8B-Instruct",
      "o3",
      "o3-mini",
      "o3-pro",
      "o4-mini",
      "openai/gpt-oss-120b",
      "qwen-2.5-coder-32b",
      "qwen3-max",
      "route-llm",
      "zai-org/glm-4.5",
      "zai-org/glm-4.6",
      "zai-org/glm-4.7",
      "zai-org/glm-5"
    ],
    "privatemode-ai": ["gemma-3-27b", "gpt-oss-120b", "qwen3-coder-30b-a3b", "qwen3-embedding-4b", "whisper-large-v3"],
    "minimax-cn-coding-plan": [
      "MiniMax-M2",
      "MiniMax-M2.1",
      "MiniMax-M2.5",
      "MiniMax-M2.5-highspeed",
      "MiniMax-M2.7",
      "MiniMax-M2.7-highspeed"
    ],
    "xiaomi-token-plan-ams": [
      "mimo-v2-flash",
      "mimo-v2-omni",
      "mimo-v2-pro",
      "mimo-v2-tts",
      "mimo-v2.5",
      "mimo-v2.5-pro"
    ],
    "cloudferro-sherlock": [
      "MiniMaxAI/MiniMax-M2.5",
      "meta-llama/Llama-3.3-70B-Instruct",
      "openai/gpt-oss-120b",
      "speakleash/Bielik-11B-v2.6-Instruct",
      "speakleash/Bielik-11B-v3.0-Instruct"
    ],
    "openai": [
      "chatgpt-image-latest",
      "gpt-3.5-turbo",
      "gpt-4",
      "gpt-4-turbo",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-nano",
      "gpt-4o",
      "gpt-4o-2024-05-13",
      "gpt-4o-2024-08-06",
      "gpt-4o-2024-11-20",
      "gpt-4o-mini",
      "gpt-5",
      "gpt-5-chat-latest",
      "gpt-5-codex",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5-pro",
      "gpt-5.1",
      "gpt-5.1-chat-latest",
      "gpt-5.1-codex",
      "gpt-5.1-codex-max",
      "gpt-5.1-codex-mini",
      "gpt-5.2",
      "gpt-5.2-chat-latest",
      "gpt-5.2-codex",
      "gpt-5.2-pro",
      "gpt-5.3-chat-latest",
      "gpt-5.3-codex",
      "gpt-5.3-codex-spark",
      "gpt-5.4",
      "gpt-5.4-mini",
      "gpt-5.4-nano",
      "gpt-5.4-pro",
      "gpt-5.5",
      "gpt-5.5-pro",
      "gpt-image-1",
      "gpt-image-1-mini",
      "gpt-image-1.5",
      "o1",
      "o1-mini",
      "o1-preview",
      "o1-pro",
      "o3",
      "o3-deep-research",
      "o3-mini",
      "o3-pro",
      "o4-mini",
      "o4-mini-deep-research",
      "text-embedding-3-large",
      "text-embedding-3-small",
      "text-embedding-ada-002"
    ],
    "dinference": ["glm-4.7", "glm-5", "glm-5.1", "gpt-oss-120b", "minimax-m2.5"],
    "vivgrid": [
      "deepseek-v3.2",
      "deepseek-v4-pro",
      "gemini-3.1-flash-lite-preview",
      "gemini-3.1-pro-preview",
      "gpt-5-mini",
      "gpt-5.1-codex",
      "gpt-5.1-codex-max",
      "gpt-5.2-codex",
      "gpt-5.3-codex",
      "gpt-5.4",
      "gpt-5.4-mini",
      "gpt-5.4-nano",
      "gpt-5.5"
    ],
    "cerebras": ["gpt-oss-120b", "llama3.1-8b", "qwen-3-235b-a22b-instruct-2507", "zai-glm-4.7"],
    "vultr": ["DeepSeek-V3.2", "GLM-5-FP8", "Kimi-K2.5", "MiniMax-M2.5", "gpt-oss-120b"],
    "kuae-cloud-coding-plan": ["GLM-4.7"],
    "modelscope": [
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-30B-A3B-Thinking-2507",
      "Qwen/Qwen3-Coder-30B-A3B-Instruct",
      "ZhipuAI/GLM-4.5",
      "ZhipuAI/GLM-4.6"
    ],
    "kimi-for-coding": ["k2p5", "k2p6", "kimi-k2-thinking"],
    "lucidquery": ["lucidnova-rf1-100b", "lucidquery-nexus-coder"],
    "neuralwatt": [
      "MiniMaxAI/MiniMax-M2.5",
      "Qwen/Qwen3.5-397B-A17B-FP8",
      "Qwen/Qwen3.6-35B-A3B",
      "glm-5-fast",
      "glm-5.1-fast",
      "kimi-k2.5-fast",
      "kimi-k2.6-fast",
      "mistralai/Devstral-Small-2-24B-Instruct-2512",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "openai/gpt-oss-20b",
      "qwen3.5-397b-fast",
      "qwen3.6-35b-fast",
      "zai-org/GLM-5.1-FP8"
    ],
    "jiekou": [
      "baidu/ernie-4.5-300b-a47b-paddle",
      "baidu/ernie-4.5-vl-424b-a47b",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-1-20250805",
      "claude-opus-4-20250514",
      "claude-opus-4-5-20251101",
      "claude-opus-4-6",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5-20250929",
      "deepseek/deepseek-r1-0528",
      "deepseek/deepseek-v3-0324",
      "deepseek/deepseek-v3.1",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.5-flash-lite-preview-06-17",
      "gemini-2.5-flash-lite-preview-09-2025",
      "gemini-2.5-flash-preview-05-20",
      "gemini-2.5-pro",
      "gemini-2.5-pro-preview-06-05",
      "gemini-3-flash-preview",
      "gemini-3-pro-preview",
      "gpt-5-chat-latest",
      "gpt-5-codex",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5-pro",
      "gpt-5.1",
      "gpt-5.1-codex",
      "gpt-5.1-codex-max",
      "gpt-5.1-codex-mini",
      "gpt-5.2",
      "gpt-5.2-codex",
      "gpt-5.2-pro",
      "grok-4-0709",
      "grok-4-1-fast-non-reasoning",
      "grok-4-1-fast-reasoning",
      "grok-4-fast-non-reasoning",
      "grok-4-fast-reasoning",
      "grok-code-fast-1",
      "minimax/minimax-m2.1",
      "minimaxai/minimax-m1-80k",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-instruct",
      "moonshotai/kimi-k2.5",
      "o3",
      "o3-mini",
      "o4-mini",
      "qwen/qwen3-235b-a22b-fp8",
      "qwen/qwen3-235b-a22b-instruct-2507",
      "qwen/qwen3-235b-a22b-thinking-2507",
      "qwen/qwen3-30b-a3b-fp8",
      "qwen/qwen3-32b-fp8",
      "qwen/qwen3-coder-480b-a35b-instruct",
      "qwen/qwen3-coder-next",
      "qwen/qwen3-next-80b-a3b-instruct",
      "qwen/qwen3-next-80b-a3b-thinking",
      "xiaomimimo/mimo-v2-flash",
      "zai-org/glm-4.5",
      "zai-org/glm-4.5v",
      "zai-org/glm-4.7",
      "zai-org/glm-4.7-flash"
    ],
    "ovhcloud": [
      "gpt-oss-120b",
      "gpt-oss-20b",
      "llama-3.1-8b-instruct",
      "meta-llama-3_3-70b-instruct",
      "mistral-7b-instruct-v0.3",
      "mistral-nemo-instruct-2407",
      "mistral-small-3.2-24b-instruct-2506",
      "qwen2.5-vl-72b-instruct",
      "qwen3-32b",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3.5-9b"
    ],
    "friendli": [
      "MiniMaxAI/MiniMax-M2.5",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "meta-llama/Llama-3.1-8B-Instruct",
      "meta-llama/Llama-3.3-70B-Instruct",
      "zai-org/GLM-5",
      "zai-org/GLM-5.1"
    ],
    "openrouter": [
      "ai21/jamba-large-1.7",
      "aion-labs/aion-1.0",
      "aion-labs/aion-1.0-mini",
      "aion-labs/aion-2.0",
      "aion-labs/aion-rp-llama-3.1-8b",
      "alfredpros/codellama-7b-instruct-solidity",
      "alibaba/tongyi-deepresearch-30b-a3b",
      "allenai/olmo-3-32b-think",
      "amazon/nova-2-lite-v1",
      "amazon/nova-lite-v1",
      "amazon/nova-micro-v1",
      "amazon/nova-premier-v1",
      "amazon/nova-pro-v1",
      "anthracite-org/magnum-v4-72b",
      "anthropic/claude-3-haiku",
      "anthropic/claude-3.5-haiku",
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.6-fast",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-opus-4.7-fast",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "arcee-ai/coder-large",
      "arcee-ai/maestro-reasoning",
      "arcee-ai/spotlight",
      "arcee-ai/trinity-large-thinking",
      "arcee-ai/trinity-large-thinking:free",
      "arcee-ai/trinity-mini",
      "arcee-ai/virtuoso-large",
      "baidu/cobuddy:free",
      "baidu/ernie-4.5-21b-a3b",
      "baidu/ernie-4.5-21b-a3b-thinking",
      "baidu/ernie-4.5-300b-a47b",
      "baidu/ernie-4.5-vl-28b-a3b",
      "baidu/ernie-4.5-vl-424b-a47b",
      "baidu/qianfan-ocr-fast",
      "bytedance-seed/seed-1.6",
      "bytedance-seed/seed-1.6-flash",
      "bytedance-seed/seed-2.0-lite",
      "bytedance-seed/seed-2.0-mini",
      "bytedance/ui-tars-1.5-7b",
      "cognitivecomputations/dolphin-mistral-24b-venice-edition:free",
      "cohere/command-a",
      "cohere/command-r-08-2024",
      "cohere/command-r-plus-08-2024",
      "cohere/command-r7b-12-2024",
      "deepcogito/cogito-v2.1-671b",
      "deepseek/deepseek-chat",
      "deepseek/deepseek-chat-v3-0324",
      "deepseek/deepseek-chat-v3.1",
      "deepseek/deepseek-r1",
      "deepseek/deepseek-r1-0528",
      "deepseek/deepseek-r1-distill-llama-70b",
      "deepseek/deepseek-r1-distill-qwen-32b",
      "deepseek/deepseek-v3.1-terminus",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v3.2-speciale",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-flash:free",
      "deepseek/deepseek-v4-pro",
      "essentialai/rnj-1-instruct",
      "google/gemini-2.0-flash-001",
      "google/gemini-2.0-flash-lite-001",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-image",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-flash-lite-preview-09-2025",
      "google/gemini-2.5-pro",
      "google/gemini-2.5-pro-preview",
      "google/gemini-2.5-pro-preview-05-06",
      "google/gemini-3-flash-preview",
      "google/gemini-3-pro-image-preview",
      "google/gemini-3.1-flash-image-preview",
      "google/gemini-3.1-flash-lite",
      "google/gemini-3.1-flash-lite-preview",
      "google/gemini-3.1-pro-preview",
      "google/gemini-3.1-pro-preview-customtools",
      "google/gemini-3.5-flash",
      "google/gemma-2-27b-it",
      "google/gemma-3-12b-it",
      "google/gemma-3-27b-it",
      "google/gemma-3-4b-it",
      "google/gemma-3n-e4b-it",
      "google/gemma-4-26b-a4b-it",
      "google/gemma-4-26b-a4b-it:free",
      "google/gemma-4-31b-it",
      "google/gemma-4-31b-it:free",
      "google/lyria-3-clip-preview",
      "google/lyria-3-pro-preview",
      "gryphe/mythomax-l2-13b",
      "ibm-granite/granite-4.0-h-micro",
      "ibm-granite/granite-4.1-8b",
      "inception/mercury-2",
      "inclusionai/ling-2.6-1t",
      "inclusionai/ling-2.6-flash",
      "inclusionai/ring-2.6-1t",
      "inflection/inflection-3-pi",
      "inflection/inflection-3-productivity",
      "kwaipilot/kat-coder-pro-v2",
      "liquid/lfm-2-24b-a2b",
      "liquid/lfm-2.5-1.2b-instruct:free",
      "liquid/lfm-2.5-1.2b-thinking:free",
      "mancer/weaver",
      "meta-llama/llama-3-70b-instruct",
      "meta-llama/llama-3-8b-instruct",
      "meta-llama/llama-3.1-70b-instruct",
      "meta-llama/llama-3.1-8b-instruct",
      "meta-llama/llama-3.2-11b-vision-instruct",
      "meta-llama/llama-3.2-1b-instruct",
      "meta-llama/llama-3.2-3b-instruct",
      "meta-llama/llama-3.2-3b-instruct:free",
      "meta-llama/llama-3.3-70b-instruct",
      "meta-llama/llama-3.3-70b-instruct:free",
      "meta-llama/llama-4-maverick",
      "meta-llama/llama-4-scout",
      "meta-llama/llama-guard-3-8b",
      "meta-llama/llama-guard-4-12b",
      "microsoft/phi-4",
      "microsoft/phi-4-mini-instruct",
      "microsoft/wizardlm-2-8x22b",
      "minimax/minimax-01",
      "minimax/minimax-m1",
      "minimax/minimax-m2",
      "minimax/minimax-m2-her",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5:free",
      "minimax/minimax-m2.7",
      "mistralai/codestral-2508",
      "mistralai/devstral-2512",
      "mistralai/devstral-medium",
      "mistralai/devstral-small",
      "mistralai/ministral-14b-2512",
      "mistralai/ministral-3b-2512",
      "mistralai/ministral-8b-2512",
      "mistralai/mistral-7b-instruct-v0.1",
      "mistralai/mistral-large",
      "mistralai/mistral-large-2407",
      "mistralai/mistral-large-2411",
      "mistralai/mistral-large-2512",
      "mistralai/mistral-medium-3",
      "mistralai/mistral-medium-3-5",
      "mistralai/mistral-medium-3.1",
      "mistralai/mistral-nemo",
      "mistralai/mistral-saba",
      "mistralai/mistral-small-24b-instruct-2501",
      "mistralai/mistral-small-2603",
      "mistralai/mistral-small-3.1-24b-instruct",
      "mistralai/mistral-small-3.2-24b-instruct",
      "mistralai/mixtral-8x22b-instruct",
      "mistralai/pixtral-large-2411",
      "mistralai/voxtral-small-24b-2507",
      "moonshotai/kimi-k2",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.6",
      "morph/morph-v3-fast",
      "morph/morph-v3-large",
      "nex-agi/deepseek-v3.1-nex-n1",
      "nousresearch/hermes-2-pro-llama-3-8b",
      "nousresearch/hermes-3-llama-3.1-405b",
      "nousresearch/hermes-3-llama-3.1-405b:free",
      "nousresearch/hermes-3-llama-3.1-70b",
      "nousresearch/hermes-4-405b",
      "nousresearch/hermes-4-70b",
      "nvidia/llama-3.3-nemotron-super-49b-v1.5",
      "nvidia/nemotron-3-nano-30b-a3b",
      "nvidia/nemotron-3-nano-30b-a3b:free",
      "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
      "nvidia/nemotron-3-super-120b-a12b",
      "nvidia/nemotron-3-super-120b-a12b:free",
      "nvidia/nemotron-nano-12b-v2-vl:free",
      "nvidia/nemotron-nano-9b-v2",
      "nvidia/nemotron-nano-9b-v2:free",
      "openai/gpt-3.5-turbo",
      "openai/gpt-3.5-turbo-0613",
      "openai/gpt-3.5-turbo-16k",
      "openai/gpt-3.5-turbo-instruct",
      "openai/gpt-4",
      "openai/gpt-4-0314",
      "openai/gpt-4-1106-preview",
      "openai/gpt-4-turbo",
      "openai/gpt-4-turbo-preview",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-2024-05-13",
      "openai/gpt-4o-2024-08-06",
      "openai/gpt-4o-2024-11-20",
      "openai/gpt-4o-audio-preview",
      "openai/gpt-4o-mini",
      "openai/gpt-4o-mini-2024-07-18",
      "openai/gpt-4o-mini-search-preview",
      "openai/gpt-4o-search-preview",
      "openai/gpt-5",
      "openai/gpt-5-chat",
      "openai/gpt-5-codex",
      "openai/gpt-5-image",
      "openai/gpt-5-image-mini",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-chat",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-chat",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-image-2",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "openai/gpt-audio",
      "openai/gpt-audio-mini",
      "openai/gpt-chat-latest",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-120b:free",
      "openai/gpt-oss-20b",
      "openai/gpt-oss-20b:free",
      "openai/gpt-oss-safeguard-20b",
      "openai/o1",
      "openai/o1-pro",
      "openai/o3",
      "openai/o3-deep-research",
      "openai/o3-mini",
      "openai/o3-mini-high",
      "openai/o3-pro",
      "openai/o4-mini",
      "openai/o4-mini-deep-research",
      "openai/o4-mini-high",
      "openrouter/auto",
      "openrouter/bodybuilder",
      "openrouter/free",
      "openrouter/owl-alpha",
      "openrouter/pareto-code",
      "perceptron/perceptron-mk1",
      "perplexity/sonar",
      "perplexity/sonar-deep-research",
      "perplexity/sonar-pro",
      "perplexity/sonar-pro-search",
      "perplexity/sonar-reasoning-pro",
      "poolside/laguna-m.1:free",
      "poolside/laguna-xs.2:free",
      "prime-intellect/intellect-3",
      "qwen/qwen-2.5-72b-instruct",
      "qwen/qwen-2.5-7b-instruct",
      "qwen/qwen-2.5-coder-32b-instruct",
      "qwen/qwen-plus",
      "qwen/qwen-plus-2025-07-28",
      "qwen/qwen-plus-2025-07-28:thinking",
      "qwen/qwen2.5-vl-72b-instruct",
      "qwen/qwen3-14b",
      "qwen/qwen3-235b-a22b",
      "qwen/qwen3-235b-a22b-2507",
      "qwen/qwen3-235b-a22b-thinking-2507",
      "qwen/qwen3-30b-a3b",
      "qwen/qwen3-30b-a3b-instruct-2507",
      "qwen/qwen3-30b-a3b-thinking-2507",
      "qwen/qwen3-32b",
      "qwen/qwen3-8b",
      "qwen/qwen3-coder",
      "qwen/qwen3-coder-30b-a3b-instruct",
      "qwen/qwen3-coder-flash",
      "qwen/qwen3-coder-next",
      "qwen/qwen3-coder-plus",
      "qwen/qwen3-coder:free",
      "qwen/qwen3-max",
      "qwen/qwen3-max-thinking",
      "qwen/qwen3-next-80b-a3b-instruct",
      "qwen/qwen3-next-80b-a3b-instruct:free",
      "qwen/qwen3-next-80b-a3b-thinking",
      "qwen/qwen3-vl-235b-a22b-instruct",
      "qwen/qwen3-vl-235b-a22b-thinking",
      "qwen/qwen3-vl-30b-a3b-instruct",
      "qwen/qwen3-vl-30b-a3b-thinking",
      "qwen/qwen3-vl-32b-instruct",
      "qwen/qwen3-vl-8b-instruct",
      "qwen/qwen3-vl-8b-thinking",
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-27b",
      "qwen/qwen3.5-35b-a3b",
      "qwen/qwen3.5-397b-a17b",
      "qwen/qwen3.5-9b",
      "qwen/qwen3.5-flash-02-23",
      "qwen/qwen3.5-plus-02-15",
      "qwen/qwen3.5-plus-20260420",
      "qwen/qwen3.6-27b",
      "qwen/qwen3.6-35b-a3b",
      "qwen/qwen3.6-flash",
      "qwen/qwen3.6-max-preview",
      "qwen/qwen3.6-plus",
      "qwen/qwen3.7-max",
      "rekaai/reka-edge",
      "rekaai/reka-flash-3",
      "relace/relace-apply-3",
      "relace/relace-search",
      "sao10k/l3-euryale-70b",
      "sao10k/l3-lunaris-8b",
      "sao10k/l3.1-70b-hanami-x1",
      "sao10k/l3.1-euryale-70b",
      "sao10k/l3.3-euryale-70b",
      "stepfun/step-3.5-flash",
      "switchpoint/router",
      "tencent/hunyuan-a13b-instruct",
      "tencent/hy3-preview",
      "thedrummer/cydonia-24b-v4.1",
      "thedrummer/rocinante-12b",
      "thedrummer/skyfall-36b-v2",
      "thedrummer/unslopnemo-12b",
      "undi95/remm-slerp-l2-13b",
      "upstage/solar-pro-3",
      "writer/palmyra-x5",
      "x-ai/grok-4.20",
      "x-ai/grok-4.20-multi-agent",
      "x-ai/grok-4.3",
      "x-ai/grok-build-0.1",
      "xiaomi/mimo-v2-flash",
      "xiaomi/mimo-v2-omni",
      "xiaomi/mimo-v2-pro",
      "xiaomi/mimo-v2.5",
      "xiaomi/mimo-v2.5-pro",
      "z-ai/glm-4-32b",
      "z-ai/glm-4.5",
      "z-ai/glm-4.5-air",
      "z-ai/glm-4.5-air:free",
      "z-ai/glm-4.5v",
      "z-ai/glm-4.6",
      "z-ai/glm-4.6v",
      "z-ai/glm-4.7",
      "z-ai/glm-4.7-flash",
      "z-ai/glm-5",
      "z-ai/glm-5-turbo",
      "z-ai/glm-5.1",
      "z-ai/glm-5v-turbo",
      "~anthropic/claude-haiku-latest",
      "~anthropic/claude-opus-latest",
      "~anthropic/claude-sonnet-latest",
      "~google/gemini-flash-latest",
      "~google/gemini-pro-latest",
      "~moonshotai/kimi-latest",
      "~openai/gpt-latest",
      "~openai/gpt-mini-latest"
    ],
    "regolo-ai": [
      "gpt-oss-120b",
      "gpt-oss-20b",
      "llama-3.1-8b-instruct",
      "llama-3.3-70b-instruct",
      "minimax-m2.5",
      "mistral-small-4-119b",
      "mistral-small3.2",
      "qwen-image",
      "qwen3-coder-next",
      "qwen3-embedding-8b",
      "qwen3-reranker-4b",
      "qwen3.5-122b",
      "qwen3.5-9b"
    ],
    "claudinio": ["claudinio"],
    "orcarouter": [
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "deepseek/deepseek-chat",
      "deepseek/deepseek-reasoner",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-pro",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash-preview",
      "google/gemini-3-pro-preview",
      "google/gemini-3.1-flash-lite-preview",
      "google/gemini-3.1-pro-preview",
      "google/gemini-3.1-pro-preview-customtools",
      "google/gemini-flash-latest",
      "google/gemini-flash-lite-latest",
      "google/gemma-4-26b-a4b-it",
      "google/gemma-4-31b-it",
      "grok/grok-4.3",
      "kimi/kimi-k2.5",
      "kimi/kimi-k2.6",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5-highspeed",
      "minimax/minimax-m2.7",
      "minimax/minimax-m2.7-highspeed",
      "openai/gpt-3.5-turbo",
      "openai/gpt-4",
      "openai/gpt-4-turbo",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-2024-05-13",
      "openai/gpt-4o-2024-08-06",
      "openai/gpt-4o-2024-11-20",
      "openai/gpt-4o-mini",
      "openai/gpt-5",
      "openai/gpt-5-chat-latest",
      "openai/gpt-5-codex",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-chat-latest",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat-latest",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-chat-latest",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "orcarouter/auto",
      "qwen/qwen3-max",
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-27b",
      "qwen/qwen3.5-35b-a3b",
      "qwen/qwen3.5-397b-a17b",
      "qwen/qwen3.5-plus",
      "qwen/qwen3.6-35b-a3b",
      "qwen/qwen3.6-plus",
      "z-ai/glm-4.5",
      "z-ai/glm-4.5-air",
      "z-ai/glm-4.6",
      "z-ai/glm-4.7",
      "z-ai/glm-5",
      "z-ai/glm-5.1"
    ],
    "opencode-go": [
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "glm-5",
      "glm-5.1",
      "kimi-k2.5",
      "kimi-k2.6",
      "mimo-v2.5",
      "mimo-v2.5-pro",
      "minimax-m2.5",
      "minimax-m2.7",
      "qwen3.5-plus",
      "qwen3.6-plus"
    ],
    "llmgateway": [
      "auto",
      "claude-3-5-sonnet-20241022",
      "claude-3-7-sonnet",
      "claude-3-7-sonnet-20250219",
      "claude-3-opus",
      "claude-haiku-4-5",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-1-20250805",
      "claude-opus-4-20250514",
      "claude-opus-4-5-20251101",
      "claude-opus-4-6",
      "claude-opus-4-7",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5",
      "claude-sonnet-4-5-20250929",
      "claude-sonnet-4-6",
      "codestral-2508",
      "custom",
      "deepseek-r1-0528",
      "deepseek-v3.1",
      "deepseek-v3.2",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "devstral-2512",
      "devstral-small-2507",
      "gemini-2.0-flash",
      "gemini-2.0-flash-lite",
      "gemini-2.5-flash",
      "gemini-2.5-flash-lite",
      "gemini-2.5-pro",
      "gemini-3-flash-preview",
      "gemini-3.1-flash-lite",
      "gemini-3.1-flash-lite-preview",
      "gemini-3.1-pro-preview",
      "gemini-3.5-flash",
      "gemini-pro-latest",
      "gemma-2-27b-it-together",
      "gemma-3-1b-it",
      "gemma-3-27b",
      "glm-4-32b-0414-128k",
      "glm-4.5",
      "glm-4.5-air",
      "glm-4.5-airx",
      "glm-4.5-flash",
      "glm-4.5-x",
      "glm-4.5v",
      "glm-4.6",
      "glm-4.6v",
      "glm-4.6v-flash",
      "glm-4.6v-flashx",
      "glm-4.7",
      "glm-4.7-flash",
      "glm-4.7-flashx",
      "glm-5",
      "glm-5.1",
      "gpt-3.5-turbo",
      "gpt-4",
      "gpt-4-turbo",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-nano",
      "gpt-4o",
      "gpt-4o-mini",
      "gpt-4o-mini-search-preview",
      "gpt-4o-search-preview",
      "gpt-5",
      "gpt-5-chat-latest",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5-pro",
      "gpt-5.1",
      "gpt-5.1-codex",
      "gpt-5.1-codex-mini",
      "gpt-5.2",
      "gpt-5.2-chat-latest",
      "gpt-5.2-codex",
      "gpt-5.2-pro",
      "gpt-5.3-chat-latest",
      "gpt-5.3-codex",
      "gpt-5.4",
      "gpt-5.4-mini",
      "gpt-5.4-nano",
      "gpt-5.4-pro",
      "gpt-5.5",
      "gpt-5.5-pro",
      "gpt-oss-120b",
      "gpt-oss-20b",
      "grok-4-0709",
      "grok-4-1-fast-reasoning",
      "grok-4-20-beta-0309-non-reasoning",
      "grok-4-20-beta-0309-reasoning",
      "grok-4-20-non-reasoning",
      "grok-4-20-reasoning",
      "grok-4-3",
      "grok-4-fast-reasoning",
      "hermes-2-pro-llama-3-8b",
      "kimi-k2",
      "kimi-k2-thinking",
      "kimi-k2-thinking-turbo",
      "kimi-k2.5",
      "kimi-k2.6",
      "llama-3-70b-instruct",
      "llama-3-8b-instruct",
      "llama-3.1-70b-instruct",
      "llama-3.1-8b-instruct",
      "llama-3.1-nemotron-ultra-253b",
      "llama-3.2-11b-instruct",
      "llama-3.2-3b-instruct",
      "llama-3.3-70b-instruct",
      "llama-4-maverick-17b-instruct",
      "llama-4-scout",
      "llama-4-scout-17b-instruct",
      "mimo-v2-flash",
      "mimo-v2-omni",
      "mimo-v2-pro",
      "mimo-v2.5",
      "mimo-v2.5-pro",
      "minimax-m2",
      "minimax-m2.1",
      "minimax-m2.1-lightning",
      "minimax-m2.5",
      "minimax-m2.5-highspeed",
      "minimax-m2.7",
      "minimax-m2.7-highspeed",
      "minimax-text-01",
      "ministral-14b-2512",
      "ministral-3b-2512",
      "ministral-8b-2512",
      "mistral-large-2512",
      "mistral-large-latest",
      "mistral-small-2506",
      "o1",
      "o3",
      "o3-mini",
      "o4-mini",
      "pixtral-large-latest",
      "qwen-coder-plus",
      "qwen-flash",
      "qwen-max",
      "qwen-max-latest",
      "qwen-omni-turbo",
      "qwen-plus",
      "qwen-plus-latest",
      "qwen-turbo",
      "qwen-vl-max",
      "qwen-vl-plus",
      "qwen2-5-vl-32b-instruct",
      "qwen2-5-vl-72b-instruct",
      "qwen25-coder-7b",
      "qwen3-235b-a22b-fp8",
      "qwen3-235b-a22b-instruct-2507",
      "qwen3-235b-a22b-thinking-2507",
      "qwen3-30b-a3b-fp8",
      "qwen3-30b-a3b-instruct-2507",
      "qwen3-30b-a3b-thinking-2507",
      "qwen3-32b",
      "qwen3-32b-fp8",
      "qwen3-4b-fp8",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-coder-flash",
      "qwen3-coder-next",
      "qwen3-coder-plus",
      "qwen3-max",
      "qwen3-max-2026-01-23",
      "qwen3-next-80b-a3b-instruct",
      "qwen3-next-80b-a3b-thinking",
      "qwen3-vl-235b-a22b-instruct",
      "qwen3-vl-235b-a22b-thinking",
      "qwen3-vl-30b-a3b-instruct",
      "qwen3-vl-30b-a3b-thinking",
      "qwen3-vl-8b-instruct",
      "qwen3-vl-flash",
      "qwen3-vl-plus",
      "qwen3.6-35b-a3b",
      "qwen3.6-max-preview",
      "qwen3.6-plus",
      "qwen35-397b-a17b",
      "qwen37-max",
      "qwq-plus",
      "seed-1-6-250615",
      "seed-1-6-250915",
      "seed-1-6-flash-250715",
      "seed-1-8-251228",
      "sonar",
      "sonar-pro",
      "sonar-reasoning-pro"
    ],
    "poe": [
      "anthropic/claude-haiku-3",
      "anthropic/claude-haiku-3.5",
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-sonnet-3.7",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "cerebras/gpt-oss-120b-cs",
      "cerebras/llama-3.1-8b-cs",
      "elevenlabs/elevenlabs-music",
      "elevenlabs/elevenlabs-v2.5-turbo",
      "elevenlabs/elevenlabs-v3",
      "empiriolabs/deepseek-v4-flash-el",
      "empiriolabs/deepseek-v4-pro-el",
      "fireworks-ai/kimi-k2.5-fw",
      "google/gemini-2.0-flash",
      "google/gemini-2.0-flash-lite",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash",
      "google/gemini-3.1-flash-lite",
      "google/gemini-3.1-pro",
      "google/gemini-3.5-flash",
      "google/gemma-4-31b",
      "google/imagen-3",
      "google/imagen-3-fast",
      "google/imagen-4",
      "google/imagen-4-fast",
      "google/imagen-4-ultra",
      "google/lyria",
      "google/nano-banana",
      "google/nano-banana-pro",
      "google/veo-2",
      "google/veo-3",
      "google/veo-3-fast",
      "google/veo-3.1",
      "google/veo-3.1-fast",
      "ideogramai/ideogram",
      "ideogramai/ideogram-v2",
      "ideogramai/ideogram-v2a",
      "ideogramai/ideogram-v2a-turbo",
      "lumalabs/ray2",
      "novita/deepseek-v3.2",
      "novita/glm-4.6",
      "novita/glm-4.6v",
      "novita/glm-4.7-flash",
      "novita/glm-4.7-n",
      "novita/glm-5",
      "novita/kimi-k2-thinking",
      "novita/kimi-k2.5",
      "novita/kimi-k2.6",
      "novita/minimax-m2.1",
      "openai/dall-e-3",
      "openai/gpt-3.5-turbo",
      "openai/gpt-3.5-turbo-instruct",
      "openai/gpt-3.5-turbo-raw",
      "openai/gpt-4-turbo",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-aug",
      "openai/gpt-4o-mini",
      "openai/gpt-4o-mini-search",
      "openai/gpt-4o-search",
      "openai/gpt-5",
      "openai/gpt-5-chat",
      "openai/gpt-5-codex",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.1-instant",
      "openai/gpt-5.2",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-instant",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.3-codex-spark",
      "openai/gpt-5.3-instant",
      "openai/gpt-5.4",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "openai/gpt-image-1",
      "openai/gpt-image-1-mini",
      "openai/gpt-image-1.5",
      "openai/gpt-image-2",
      "openai/o1",
      "openai/o1-pro",
      "openai/o3",
      "openai/o3-deep-research",
      "openai/o3-mini",
      "openai/o3-mini-high",
      "openai/o3-pro",
      "openai/o4-mini",
      "openai/o4-mini-deep-research",
      "openai/sora-2",
      "openai/sora-2-pro",
      "poetools/claude-code",
      "runwayml/runway",
      "runwayml/runway-gen-4-turbo",
      "stabilityai/stablediffusionxl",
      "topazlabs-co/topazlabs",
      "trytako/tako",
      "xai/grok-3",
      "xai/grok-3-mini",
      "xai/grok-4",
      "xai/grok-4-fast-non-reasoning",
      "xai/grok-4-fast-reasoning",
      "xai/grok-4.1-fast-non-reasoning",
      "xai/grok-4.1-fast-reasoning",
      "xai/grok-4.20-multi-agent",
      "xai/grok-code-fast-1"
    ],
    "minimax": [
      "MiniMax-M2",
      "MiniMax-M2.1",
      "MiniMax-M2.5",
      "MiniMax-M2.5-highspeed",
      "MiniMax-M2.7",
      "MiniMax-M2.7-highspeed"
    ],
    "groq": [
      "allam-2-7b",
      "canopylabs/orpheus-arabic-saudi",
      "canopylabs/orpheus-v1-english",
      "groq/compound",
      "groq/compound-mini",
      "llama-3.1-8b-instant",
      "llama-3.3-70b-versatile",
      "meta-llama/llama-4-scout-17b-16e-instruct",
      "meta-llama/llama-prompt-guard-2-22m",
      "meta-llama/llama-prompt-guard-2-86m",
      "moonshotai/kimi-k2-instruct-0905",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "openai/gpt-oss-safeguard-20b",
      "qwen/qwen3-32b",
      "whisper-large-v3",
      "whisper-large-v3-turbo"
    ],
    "xiaomi-token-plan-sgp": [
      "mimo-v2-flash",
      "mimo-v2-omni",
      "mimo-v2-pro",
      "mimo-v2-tts",
      "mimo-v2.5",
      "mimo-v2.5-pro"
    ],
    "siliconflow": [
      "ByteDance-Seed/Seed-OSS-36B-Instruct",
      "MiniMaxAI/MiniMax-M2.1",
      "MiniMaxAI/MiniMax-M2.5",
      "Qwen/QwQ-32B",
      "Qwen/Qwen2.5-14B-Instruct",
      "Qwen/Qwen2.5-32B-Instruct",
      "Qwen/Qwen2.5-72B-Instruct",
      "Qwen/Qwen2.5-72B-Instruct-128K",
      "Qwen/Qwen2.5-7B-Instruct",
      "Qwen/Qwen2.5-Coder-32B-Instruct",
      "Qwen/Qwen2.5-VL-32B-Instruct",
      "Qwen/Qwen2.5-VL-72B-Instruct",
      "Qwen/Qwen2.5-VL-7B-Instruct",
      "Qwen/Qwen3-14B",
      "Qwen/Qwen3-235B-A22B",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-30B-A3B-Thinking-2507",
      "Qwen/Qwen3-32B",
      "Qwen/Qwen3-8B",
      "Qwen/Qwen3-Coder-30B-A3B-Instruct",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "Qwen/Qwen3-Next-80B-A3B-Instruct",
      "Qwen/Qwen3-Next-80B-A3B-Thinking",
      "Qwen/Qwen3-Omni-30B-A3B-Captioner",
      "Qwen/Qwen3-Omni-30B-A3B-Instruct",
      "Qwen/Qwen3-Omni-30B-A3B-Thinking",
      "Qwen/Qwen3-VL-235B-A22B-Instruct",
      "Qwen/Qwen3-VL-235B-A22B-Thinking",
      "Qwen/Qwen3-VL-30B-A3B-Instruct",
      "Qwen/Qwen3-VL-30B-A3B-Thinking",
      "Qwen/Qwen3-VL-32B-Instruct",
      "Qwen/Qwen3-VL-32B-Thinking",
      "Qwen/Qwen3-VL-8B-Instruct",
      "Qwen/Qwen3-VL-8B-Thinking",
      "THUDM/GLM-4-32B-0414",
      "THUDM/GLM-4-9B-0414",
      "THUDM/GLM-Z1-32B-0414",
      "THUDM/GLM-Z1-9B-0414",
      "baidu/ERNIE-4.5-300B-A47B",
      "deepseek-ai/DeepSeek-R1",
      "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
      "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
      "deepseek-ai/DeepSeek-V3",
      "deepseek-ai/DeepSeek-V3.1",
      "deepseek-ai/DeepSeek-V3.1-Terminus",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/DeepSeek-V3.2-Exp",
      "deepseek-ai/deepseek-v4-flash",
      "deepseek-ai/deepseek-v4-pro",
      "deepseek-ai/deepseek-vl2",
      "inclusionAI/Ling-flash-2.0",
      "inclusionAI/Ling-mini-2.0",
      "inclusionAI/Ring-flash-2.0",
      "meta-llama/Meta-Llama-3.1-8B-Instruct",
      "moonshotai/Kimi-K2-Instruct",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/Kimi-K2-Thinking",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "nex-agi/DeepSeek-V3.1-Nex-N1",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "stepfun-ai/Step-3.5-Flash",
      "tencent/Hunyuan-A13B-Instruct",
      "tencent/Hunyuan-MT-7B",
      "zai-org/GLM-4.5",
      "zai-org/GLM-4.5-Air",
      "zai-org/GLM-4.5V",
      "zai-org/GLM-4.6",
      "zai-org/GLM-4.6V",
      "zai-org/GLM-4.7",
      "zai-org/GLM-5",
      "zai-org/GLM-5.1",
      "zai-org/GLM-5V-Turbo"
    ],
    "ollama-cloud": [
      "cogito-2.1:671b",
      "deepseek-v3.1:671b",
      "deepseek-v3.2",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "devstral-2:123b",
      "devstral-small-2:24b",
      "gemini-3-flash-preview",
      "gemma3:12b",
      "gemma3:27b",
      "gemma3:4b",
      "gemma4:31b",
      "glm-4.6",
      "glm-4.7",
      "glm-5",
      "glm-5.1",
      "gpt-oss:120b",
      "gpt-oss:20b",
      "kimi-k2-thinking",
      "kimi-k2.5",
      "kimi-k2.6",
      "kimi-k2:1t",
      "minimax-m2",
      "minimax-m2.1",
      "minimax-m2.5",
      "minimax-m2.7",
      "ministral-3:14b",
      "ministral-3:3b",
      "ministral-3:8b",
      "mistral-large-3:675b",
      "nemotron-3-nano:30b",
      "nemotron-3-super",
      "qwen3-coder-next",
      "qwen3-coder:480b",
      "qwen3-next:80b",
      "qwen3-vl:235b",
      "qwen3-vl:235b-instruct",
      "qwen3.5:397b",
      "rnj-1:8b"
    ],
    "databricks": [
      "databricks-claude-haiku-4-5",
      "databricks-claude-opus-4-1",
      "databricks-claude-opus-4-5",
      "databricks-claude-opus-4-6",
      "databricks-claude-opus-4-7",
      "databricks-claude-sonnet-4",
      "databricks-claude-sonnet-4-5",
      "databricks-claude-sonnet-4-6",
      "databricks-gemini-2-5-flash",
      "databricks-gemini-2-5-pro",
      "databricks-gemini-3-1-flash-lite",
      "databricks-gemini-3-1-pro",
      "databricks-gemini-3-flash",
      "databricks-gemini-3-pro",
      "databricks-gpt-5",
      "databricks-gpt-5-1",
      "databricks-gpt-5-2",
      "databricks-gpt-5-4",
      "databricks-gpt-5-4-mini",
      "databricks-gpt-5-4-nano",
      "databricks-gpt-5-5",
      "databricks-gpt-5-mini",
      "databricks-gpt-5-nano",
      "databricks-gpt-oss-120b",
      "databricks-gpt-oss-20b"
    ],
    "berget": [
      "google/gemma-4-31B-it",
      "meta-llama/Llama-3.3-70B-Instruct",
      "mistralai/Mistral-Medium-3.5-128B",
      "mistralai/Mistral-Small-3.2-24B-Instruct-2506",
      "moonshotai/Kimi-K2.6",
      "openai/gpt-oss-120b",
      "zai-org/GLM-4.7"
    ],
    "moonshotai-cn": [
      "kimi-k2-0711-preview",
      "kimi-k2-0905-preview",
      "kimi-k2-thinking",
      "kimi-k2-thinking-turbo",
      "kimi-k2-turbo-preview",
      "kimi-k2.5",
      "kimi-k2.6"
    ],
    "alibaba-coding-plan-cn": [
      "MiniMax-M2.5",
      "glm-4.7",
      "glm-5",
      "kimi-k2.5",
      "qwen3-coder-next",
      "qwen3-coder-plus",
      "qwen3-max-2026-01-23",
      "qwen3.5-plus",
      "qwen3.6-plus"
    ],
    "minimax-cn": [
      "MiniMax-M2",
      "MiniMax-M2.1",
      "MiniMax-M2.5",
      "MiniMax-M2.5-highspeed",
      "MiniMax-M2.7",
      "MiniMax-M2.7-highspeed"
    ],
    "chutes": [
      "MiniMaxAI/MiniMax-M2.5-TEE",
      "NousResearch/DeepHermes-3-Mistral-24B-Preview",
      "NousResearch/Hermes-4-14B",
      "Qwen/Qwen2.5-72B-Instruct",
      "Qwen/Qwen2.5-Coder-32B-Instruct",
      "Qwen/Qwen2.5-VL-32B-Instruct",
      "Qwen/Qwen3-235B-A22B-Instruct-2507-TEE",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-30B-A3B",
      "Qwen/Qwen3-32B-TEE",
      "Qwen/Qwen3-Coder-Next-TEE",
      "Qwen/Qwen3-Next-80B-A3B-Instruct",
      "Qwen/Qwen3.5-397B-A17B-TEE",
      "Qwen/Qwen3.6-27B-TEE",
      "Qwen/Qwen3Guard-Gen-0.6B",
      "XiaomiMiMo/MiMo-V2-Flash-TEE",
      "deepseek-ai/DeepSeek-R1-0528-TEE",
      "deepseek-ai/DeepSeek-R1-Distill-Llama-70B",
      "deepseek-ai/DeepSeek-V3-0324-TEE",
      "deepseek-ai/DeepSeek-V3.1-TEE",
      "deepseek-ai/DeepSeek-V3.2-TEE",
      "google/gemma-4-31B-turbo-TEE",
      "moonshotai/Kimi-K2.5-TEE",
      "moonshotai/Kimi-K2.6-TEE",
      "openai/gpt-oss-120b-TEE",
      "rednote-hilab/dots.ocr",
      "tngtech/DeepSeek-TNG-R1T2-Chimera-TEE",
      "unsloth/Llama-3.2-1B-Instruct",
      "unsloth/Llama-3.2-3B-Instruct",
      "unsloth/Mistral-Nemo-Instruct-2407",
      "unsloth/gemma-3-12b-it",
      "unsloth/gemma-3-27b-it",
      "unsloth/gemma-3-4b-it",
      "zai-org/GLM-4.6V",
      "zai-org/GLM-4.7-FP8",
      "zai-org/GLM-4.7-TEE",
      "zai-org/GLM-5-TEE",
      "zai-org/GLM-5-Turbo",
      "zai-org/GLM-5.1-TEE"
    ],
    "siliconflow-cn": [
      "ByteDance-Seed/Seed-OSS-36B-Instruct",
      "Kwaipilot/KAT-Dev",
      "PaddlePaddle/PaddleOCR-VL",
      "PaddlePaddle/PaddleOCR-VL-1.5",
      "Pro/MiniMaxAI/MiniMax-M2.1",
      "Pro/MiniMaxAI/MiniMax-M2.5",
      "Pro/deepseek-ai/DeepSeek-R1",
      "Pro/deepseek-ai/DeepSeek-V3",
      "Pro/deepseek-ai/DeepSeek-V3.1-Terminus",
      "Pro/deepseek-ai/DeepSeek-V3.2",
      "Pro/moonshotai/Kimi-K2-Instruct-0905",
      "Pro/moonshotai/Kimi-K2-Thinking",
      "Pro/moonshotai/Kimi-K2.5",
      "Pro/moonshotai/Kimi-K2.6",
      "Pro/zai-org/GLM-4.7",
      "Pro/zai-org/GLM-5",
      "Pro/zai-org/GLM-5.1",
      "Qwen/QwQ-32B",
      "Qwen/Qwen2.5-14B-Instruct",
      "Qwen/Qwen2.5-32B-Instruct",
      "Qwen/Qwen2.5-72B-Instruct",
      "Qwen/Qwen2.5-72B-Instruct-128K",
      "Qwen/Qwen2.5-7B-Instruct",
      "Qwen/Qwen2.5-Coder-32B-Instruct",
      "Qwen/Qwen2.5-VL-32B-Instruct",
      "Qwen/Qwen2.5-VL-72B-Instruct",
      "Qwen/Qwen3-14B",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-30B-A3B-Thinking-2507",
      "Qwen/Qwen3-32B",
      "Qwen/Qwen3-8B",
      "Qwen/Qwen3-Coder-30B-A3B-Instruct",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "Qwen/Qwen3-Next-80B-A3B-Instruct",
      "Qwen/Qwen3-Next-80B-A3B-Thinking",
      "Qwen/Qwen3-Omni-30B-A3B-Captioner",
      "Qwen/Qwen3-Omni-30B-A3B-Instruct",
      "Qwen/Qwen3-Omni-30B-A3B-Thinking",
      "Qwen/Qwen3-VL-235B-A22B-Instruct",
      "Qwen/Qwen3-VL-235B-A22B-Thinking",
      "Qwen/Qwen3-VL-30B-A3B-Instruct",
      "Qwen/Qwen3-VL-30B-A3B-Thinking",
      "Qwen/Qwen3-VL-32B-Instruct",
      "Qwen/Qwen3-VL-32B-Thinking",
      "Qwen/Qwen3-VL-8B-Instruct",
      "Qwen/Qwen3-VL-8B-Thinking",
      "Qwen/Qwen3.5-122B-A10B",
      "Qwen/Qwen3.5-27B",
      "Qwen/Qwen3.5-35B-A3B",
      "Qwen/Qwen3.5-397B-A17B",
      "Qwen/Qwen3.5-4B",
      "Qwen/Qwen3.5-9B",
      "Qwen/Qwen3.6-35B-A3B",
      "THUDM/GLM-4-32B-0414",
      "THUDM/GLM-4-9B-0414",
      "THUDM/GLM-Z1-32B-0414",
      "THUDM/GLM-Z1-9B-0414",
      "ascend-tribe/pangu-pro-moe",
      "baidu/ERNIE-4.5-300B-A47B",
      "deepseek-ai/DeepSeek-OCR",
      "deepseek-ai/DeepSeek-R1",
      "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
      "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
      "deepseek-ai/DeepSeek-V3",
      "deepseek-ai/DeepSeek-V3.1-Terminus",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/deepseek-vl2",
      "inclusionAI/Ling-flash-2.0",
      "inclusionAI/Ling-mini-2.0",
      "inclusionAI/Ring-flash-2.0",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/Kimi-K2-Thinking",
      "stepfun-ai/Step-3.5-Flash",
      "tencent/Hunyuan-A13B-Instruct",
      "tencent/Hunyuan-MT-7B",
      "zai-org/GLM-4.5-Air",
      "zai-org/GLM-4.5V",
      "zai-org/GLM-4.6",
      "zai-org/GLM-4.6V"
    ],
    "nvidia": [
      "abacusai/dracarys-llama-3_1-70b-instruct",
      "baai/bge-m3",
      "black-forest-labs/flux.1-dev",
      "black-forest-labs/flux_1-kontext-dev",
      "black-forest-labs/flux_1-schnell",
      "black-forest-labs/flux_2-klein-4b",
      "bytedance/seed-oss-36b-instruct",
      "deepseek-ai/deepseek-v3.1-terminus",
      "deepseek-ai/deepseek-v3.2",
      "deepseek-ai/deepseek-v4-flash",
      "deepseek-ai/deepseek-v4-pro",
      "google/gemma-2-2b-it",
      "google/gemma-3-27b-it",
      "google/gemma-3n-e2b-it",
      "google/gemma-3n-e4b-it",
      "google/gemma-4-31b-it",
      "google/google-paligemma",
      "meta/esm2-650m",
      "meta/esmfold",
      "meta/llama-3.1-70b-instruct",
      "meta/llama-3.1-8b-instruct",
      "meta/llama-3.2-11b-vision-instruct",
      "meta/llama-3.2-1b-instruct",
      "meta/llama-3.2-3b-instruct",
      "meta/llama-3.2-90b-vision-instruct",
      "meta/llama-3.3-70b-instruct",
      "meta/llama-4-maverick-17b-128e-instruct",
      "meta/llama-guard-4-12b",
      "microsoft/phi-4-mini-instruct",
      "microsoft/phi-4-multimodal-instruct",
      "minimaxai/minimax-m2.5",
      "minimaxai/minimax-m2.7",
      "mistralai/devstral-2-123b-instruct-2512",
      "mistralai/magistral-small-2506",
      "mistralai/mistral-7b-instruct-v03",
      "mistralai/mistral-large-3-675b-instruct-2512",
      "mistralai/mistral-medium-3-instruct",
      "mistralai/mistral-nemotron",
      "mistralai/mistral-small-4-119b-2603",
      "mistralai/mixtral-8x22b-instruct",
      "mistralai/mixtral-8x7b-instruct",
      "moonshotai/kimi-k2-instruct",
      "moonshotai/kimi-k2-instruct-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2.6",
      "nvidia/active-speaker-detection",
      "nvidia/bevformer",
      "nvidia/cosmos-predict1-5b",
      "nvidia/cosmos-transfer1-7b",
      "nvidia/cosmos-transfer2_5-2b",
      "nvidia/gliner-pii",
      "nvidia/llama-3_1-nemotron-safety-guard-8b-v3",
      "nvidia/llama-3_2-nemoretriever-300m-embed-v1",
      "nvidia/llama-3_3-nemotron-super-49b-v1",
      "nvidia/llama-3_3-nemotron-super-49b-v1_5",
      "nvidia/llama-nemotron-embed-vl-1b-v2",
      "nvidia/llama-nemotron-rerank-vl-1b-v2",
      "nvidia/magpie-tts-zeroshot",
      "nvidia/nemotron-3-content-safety",
      "nvidia/nemotron-3-nano-30b-a3b",
      "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning",
      "nvidia/nemotron-3-super-120b-a12b",
      "nvidia/nemotron-content-safety-reasoning-4b",
      "nvidia/nemotron-mini-4b-instruct",
      "nvidia/nemotron-voicechat",
      "nvidia/nv-embed-v1",
      "nvidia/nv-embedcode-7b-v1",
      "nvidia/nvidia-nemotron-nano-9b-v2",
      "nvidia/rerank-qa-mistral-4b",
      "nvidia/riva-translate-4b-instruct-v1_1",
      "nvidia/sparsedrive",
      "nvidia/streampetr",
      "nvidia/studiovoice",
      "nvidia/synthetic-video-detector",
      "nvidia/usdcode",
      "nvidia/usdvalidate",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "openai/whisper-large-v3",
      "qwen/qwen-image",
      "qwen/qwen-image-edit",
      "qwen/qwen2.5-coder-32b-instruct",
      "qwen/qwen3-coder-480b-a35b-instruct",
      "qwen/qwen3-next-80b-a3b-instruct",
      "qwen/qwen3-next-80b-a3b-thinking",
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-397b-a17b",
      "sarvamai/sarvam-m",
      "stepfun-ai/step-3.5-flash",
      "upstage/solar-10_7b-instruct",
      "z-ai/glm-5.1",
      "z-ai/glm4.7"
    ],
    "anthropic": [
      "claude-3-5-haiku-20241022",
      "claude-3-5-haiku-latest",
      "claude-3-5-sonnet-20240620",
      "claude-3-5-sonnet-20241022",
      "claude-3-7-sonnet-20250219",
      "claude-3-haiku-20240307",
      "claude-3-opus-20240229",
      "claude-3-sonnet-20240229",
      "claude-haiku-4-5",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-0",
      "claude-opus-4-1",
      "claude-opus-4-1-20250805",
      "claude-opus-4-20250514",
      "claude-opus-4-5",
      "claude-opus-4-5-20251101",
      "claude-opus-4-6",
      "claude-opus-4-7",
      "claude-sonnet-4-0",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5",
      "claude-sonnet-4-5-20250929",
      "claude-sonnet-4-6"
    ],
    "zhipuai-coding-plan": ["glm-4.5-air", "glm-4.7", "glm-5-turbo", "glm-5.1", "glm-5v-turbo"],
    "atomic-chat": [
      "Meta-Llama-3_1-8B-Instruct-GGUF",
      "Qwen3_5-9B-MLX-4bit",
      "Qwen3_5-9B-Q4_K_M",
      "gemma-4-E4B-it-IQ4_XS",
      "gemma-4-E4B-it-MLX-4bit"
    ],
    "github-models": [
      "ai21-labs/ai21-jamba-1.5-large",
      "ai21-labs/ai21-jamba-1.5-mini",
      "cohere/cohere-command-a",
      "cohere/cohere-command-r",
      "cohere/cohere-command-r-08-2024",
      "cohere/cohere-command-r-plus",
      "cohere/cohere-command-r-plus-08-2024",
      "core42/jais-30b-chat",
      "deepseek/deepseek-r1",
      "deepseek/deepseek-r1-0528",
      "deepseek/deepseek-v3-0324",
      "meta/llama-3.2-11b-vision-instruct",
      "meta/llama-3.2-90b-vision-instruct",
      "meta/llama-3.3-70b-instruct",
      "meta/llama-4-maverick-17b-128e-instruct-fp8",
      "meta/llama-4-scout-17b-16e-instruct",
      "meta/meta-llama-3-70b-instruct",
      "meta/meta-llama-3-8b-instruct",
      "meta/meta-llama-3.1-405b-instruct",
      "meta/meta-llama-3.1-70b-instruct",
      "meta/meta-llama-3.1-8b-instruct",
      "microsoft/mai-ds-r1",
      "microsoft/phi-3-medium-128k-instruct",
      "microsoft/phi-3-medium-4k-instruct",
      "microsoft/phi-3-mini-128k-instruct",
      "microsoft/phi-3-mini-4k-instruct",
      "microsoft/phi-3-small-128k-instruct",
      "microsoft/phi-3-small-8k-instruct",
      "microsoft/phi-3.5-mini-instruct",
      "microsoft/phi-3.5-moe-instruct",
      "microsoft/phi-3.5-vision-instruct",
      "microsoft/phi-4",
      "microsoft/phi-4-mini-instruct",
      "microsoft/phi-4-mini-reasoning",
      "microsoft/phi-4-multimodal-instruct",
      "microsoft/phi-4-reasoning",
      "mistral-ai/codestral-2501",
      "mistral-ai/ministral-3b",
      "mistral-ai/mistral-large-2411",
      "mistral-ai/mistral-medium-2505",
      "mistral-ai/mistral-nemo",
      "mistral-ai/mistral-small-2503",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-mini",
      "openai/o1",
      "openai/o1-mini",
      "openai/o1-preview",
      "openai/o3",
      "openai/o3-mini",
      "openai/o4-mini",
      "xai/grok-3",
      "xai/grok-3-mini"
    ],
    "qiniu-ai": [
      "MiniMax-M1",
      "claude-3.5-haiku",
      "claude-3.5-sonnet",
      "claude-3.7-sonnet",
      "claude-4.0-opus",
      "claude-4.0-sonnet",
      "claude-4.1-opus",
      "claude-4.5-haiku",
      "claude-4.5-opus",
      "claude-4.5-sonnet",
      "deepseek-r1",
      "deepseek-r1-0528",
      "deepseek-v3",
      "deepseek-v3-0324",
      "deepseek-v3.1",
      "deepseek/deepseek-math-v2",
      "deepseek/deepseek-v3.1-terminus",
      "deepseek/deepseek-v3.1-terminus-thinking",
      "deepseek/deepseek-v3.2-251201",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v3.2-exp-thinking",
      "doubao-1.5-pro-32k",
      "doubao-1.5-thinking-pro",
      "doubao-1.5-vision-pro",
      "doubao-seed-1.6",
      "doubao-seed-1.6-flash",
      "doubao-seed-1.6-thinking",
      "doubao-seed-2.0-code",
      "doubao-seed-2.0-lite",
      "doubao-seed-2.0-mini",
      "doubao-seed-2.0-pro",
      "gemini-2.0-flash",
      "gemini-2.0-flash-lite",
      "gemini-2.5-flash",
      "gemini-2.5-flash-image",
      "gemini-2.5-flash-lite",
      "gemini-2.5-pro",
      "gemini-3.0-flash-preview",
      "gemini-3.0-pro-image-preview",
      "gemini-3.0-pro-preview",
      "glm-4.5",
      "glm-4.5-air",
      "gpt-oss-120b",
      "gpt-oss-20b",
      "kimi-k2",
      "kling-v2-6",
      "meituan/longcat-flash-chat",
      "meituan/longcat-flash-lite",
      "mimo-v2-flash",
      "minimax/minimax-m2",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5-highspeed",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2.5",
      "openai/gpt-5",
      "openai/gpt-5.2",
      "qwen-max-2025-01-25",
      "qwen-turbo",
      "qwen-vl-max-2025-01-25",
      "qwen2.5-vl-72b-instruct",
      "qwen2.5-vl-7b-instruct",
      "qwen3-235b-a22b",
      "qwen3-235b-a22b-instruct-2507",
      "qwen3-235b-a22b-thinking-2507",
      "qwen3-30b-a3b",
      "qwen3-30b-a3b-instruct-2507",
      "qwen3-30b-a3b-thinking-2507",
      "qwen3-32b",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-max",
      "qwen3-max-preview",
      "qwen3-next-80b-a3b-instruct",
      "qwen3-next-80b-a3b-thinking",
      "qwen3-vl-30b-a3b-thinking",
      "qwen3.5-397b-a17b",
      "stepfun-ai/gelab-zero-4b-preview",
      "stepfun/step-3.5-flash",
      "x-ai/grok-4-fast",
      "x-ai/grok-4-fast-non-reasoning",
      "x-ai/grok-4-fast-reasoning",
      "x-ai/grok-4.1-fast",
      "x-ai/grok-4.1-fast-non-reasoning",
      "x-ai/grok-4.1-fast-reasoning",
      "x-ai/grok-code-fast-1",
      "xiaomi/mimo-v2-flash",
      "z-ai/autoglm-phone-9b",
      "z-ai/glm-4.6",
      "z-ai/glm-4.7",
      "z-ai/glm-5"
    ],
    "google": [
      "gemini-2.0-flash",
      "gemini-2.0-flash-lite",
      "gemini-2.5-flash",
      "gemini-2.5-flash-image",
      "gemini-2.5-flash-lite",
      "gemini-2.5-flash-preview-tts",
      "gemini-2.5-pro",
      "gemini-2.5-pro-preview-tts",
      "gemini-3-flash-preview",
      "gemini-3-pro-preview",
      "gemini-3.1-flash-image-preview",
      "gemini-3.1-flash-lite",
      "gemini-3.1-flash-lite-preview",
      "gemini-3.1-pro-preview",
      "gemini-3.1-pro-preview-customtools",
      "gemini-3.5-flash",
      "gemini-embedding-001",
      "gemini-flash-latest",
      "gemini-flash-lite-latest",
      "gemma-4-26b-a4b-it",
      "gemma-4-31b-it"
    ],
    "scaleway": [
      "bge-multilingual-gemma2",
      "deepseek-r1-distill-llama-70b",
      "devstral-2-123b-instruct-2512",
      "gemma-3-27b-it",
      "gpt-oss-120b",
      "llama-3.1-8b-instruct",
      "llama-3.3-70b-instruct",
      "mistral-medium-3.5-128b",
      "mistral-nemo-instruct-2407",
      "mistral-small-3.2-24b-instruct-2506",
      "pixtral-12b-2409",
      "qwen3-235b-a22b-instruct-2507",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-embedding-8b",
      "qwen3.5-397b-a17b",
      "voxtral-small-24b-2507",
      "whisper-large-v3"
    ],
    "opencode": [
      "big-pickle",
      "claude-haiku-4-5",
      "claude-opus-4-1",
      "claude-opus-4-5",
      "claude-opus-4-6",
      "claude-opus-4-7",
      "claude-sonnet-4",
      "claude-sonnet-4-5",
      "claude-sonnet-4-6",
      "deepseek-v4-flash-free",
      "gemini-3-flash",
      "gemini-3.1-pro",
      "gemini-3.5-flash",
      "glm-5",
      "glm-5.1",
      "gpt-5",
      "gpt-5-codex",
      "gpt-5-nano",
      "gpt-5.1",
      "gpt-5.1-codex",
      "gpt-5.1-codex-max",
      "gpt-5.1-codex-mini",
      "gpt-5.2",
      "gpt-5.2-codex",
      "gpt-5.3-codex",
      "gpt-5.3-codex-spark",
      "gpt-5.4",
      "gpt-5.4-mini",
      "gpt-5.4-nano",
      "gpt-5.4-pro",
      "gpt-5.5",
      "gpt-5.5-pro",
      "grok-build-0.1",
      "kimi-k2.5",
      "kimi-k2.6",
      "minimax-m2.5",
      "minimax-m2.7",
      "nemotron-3-super-free",
      "qwen3.5-plus",
      "qwen3.6-plus"
    ],
    "mixlayer": [
      "qwen/qwen3.5-122b-a10b",
      "qwen/qwen3.5-27b",
      "qwen/qwen3.5-35b-a3b",
      "qwen/qwen3.5-397b-a17b",
      "qwen/qwen3.5-9b"
    ],
    "zenmux": [
      "anthropic/claude-3.5-haiku",
      "anthropic/claude-3.7-sonnet",
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "baidu/ernie-5.0-thinking-preview",
      "deepseek/deepseek-chat",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-pro",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash-preview",
      "google/gemini-3.1-flash-lite-preview",
      "google/gemini-3.1-pro-preview",
      "inclusionai/ling-1t",
      "inclusionai/ring-1t",
      "kuaishou/kat-coder-pro-v2",
      "minimax/minimax-m2",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5-lightning",
      "minimax/minimax-m2.7",
      "minimax/minimax-m2.7-highspeed",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2-thinking-turbo",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.6",
      "openai/gpt-5",
      "openai/gpt-5-codex",
      "openai/gpt-5.1",
      "openai/gpt-5.1-chat",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-chat",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "qwen/qwen3-coder-plus",
      "qwen/qwen3-max",
      "qwen/qwen3.5-flash",
      "qwen/qwen3.5-plus",
      "qwen/qwen3.6-plus",
      "sapiens-ai/agnes-1.5-lite",
      "sapiens-ai/agnes-1.5-pro",
      "stepfun/step-3",
      "stepfun/step-3.5-flash",
      "stepfun/step-3.5-flash-free",
      "tencent/hy3-preview",
      "volcengine/doubao-seed-1.8",
      "volcengine/doubao-seed-2.0-code",
      "volcengine/doubao-seed-2.0-lite",
      "volcengine/doubao-seed-2.0-mini",
      "volcengine/doubao-seed-2.0-pro",
      "volcengine/doubao-seed-code",
      "x-ai/grok-4",
      "x-ai/grok-4-fast",
      "x-ai/grok-4.1-fast",
      "x-ai/grok-4.1-fast-non-reasoning",
      "x-ai/grok-4.2-fast",
      "x-ai/grok-4.2-fast-non-reasoning",
      "x-ai/grok-code-fast-1",
      "xiaomi/mimo-v2-flash",
      "xiaomi/mimo-v2-omni",
      "xiaomi/mimo-v2-pro",
      "xiaomi/mimo-v2.5",
      "xiaomi/mimo-v2.5-pro",
      "z-ai/glm-4.5",
      "z-ai/glm-4.5-air",
      "z-ai/glm-4.6",
      "z-ai/glm-4.6v",
      "z-ai/glm-4.6v-flash",
      "z-ai/glm-4.6v-flash-free",
      "z-ai/glm-4.7",
      "z-ai/glm-4.7-flash-free",
      "z-ai/glm-4.7-flashx",
      "z-ai/glm-5",
      "z-ai/glm-5-turbo",
      "z-ai/glm-5.1",
      "z-ai/glm-5v-turbo"
    ],
    "perplexity-agent": [
      "anthropic/claude-haiku-4-5",
      "anthropic/claude-opus-4-5",
      "anthropic/claude-opus-4-6",
      "anthropic/claude-opus-4-7",
      "anthropic/claude-sonnet-4-5",
      "anthropic/claude-sonnet-4-6",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash-preview",
      "google/gemini-3.1-pro-preview",
      "nvidia/nemotron-3-super-120b-a12b",
      "openai/gpt-5-mini",
      "openai/gpt-5.1",
      "openai/gpt-5.2",
      "openai/gpt-5.4",
      "openai/gpt-5.5",
      "perplexity/sonar",
      "xai/grok-4-1-fast-non-reasoning"
    ],
    "alibaba-coding-plan": [
      "MiniMax-M2.5",
      "glm-4.7",
      "glm-5",
      "kimi-k2.5",
      "qwen3-coder-next",
      "qwen3-coder-plus",
      "qwen3-max-2026-01-23",
      "qwen3.5-plus",
      "qwen3.6-plus"
    ],
    "meganova": [
      "MiniMaxAI/MiniMax-M2.1",
      "MiniMaxAI/MiniMax-M2.5",
      "Qwen/Qwen2.5-VL-32B-Instruct",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3.5-Plus",
      "XiaomiMiMo/MiMo-V2-Flash",
      "deepseek-ai/DeepSeek-R1-0528",
      "deepseek-ai/DeepSeek-V3-0324",
      "deepseek-ai/DeepSeek-V3.1",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/DeepSeek-V3.2-Exp",
      "meta-llama/Llama-3.3-70B-Instruct",
      "mistralai/Mistral-Nemo-Instruct-2407",
      "mistralai/Mistral-Small-3.2-24B-Instruct-2506",
      "moonshotai/Kimi-K2-Thinking",
      "moonshotai/Kimi-K2.5",
      "zai-org/GLM-4.6",
      "zai-org/GLM-4.7",
      "zai-org/GLM-5"
    ],
    "synthetic": [
      "hf:MiniMaxAI/MiniMax-M2",
      "hf:MiniMaxAI/MiniMax-M2.1",
      "hf:MiniMaxAI/MiniMax-M2.5",
      "hf:Qwen/Qwen2.5-Coder-32B-Instruct",
      "hf:Qwen/Qwen3-235B-A22B-Instruct-2507",
      "hf:Qwen/Qwen3-235B-A22B-Thinking-2507",
      "hf:Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "hf:Qwen/Qwen3.5-397B-A17B",
      "hf:deepseek-ai/DeepSeek-R1",
      "hf:deepseek-ai/DeepSeek-R1-0528",
      "hf:deepseek-ai/DeepSeek-V3",
      "hf:deepseek-ai/DeepSeek-V3-0324",
      "hf:deepseek-ai/DeepSeek-V3.1",
      "hf:deepseek-ai/DeepSeek-V3.1-Terminus",
      "hf:deepseek-ai/DeepSeek-V3.2",
      "hf:meta-llama/Llama-3.1-405B-Instruct",
      "hf:meta-llama/Llama-3.1-70B-Instruct",
      "hf:meta-llama/Llama-3.1-8B-Instruct",
      "hf:meta-llama/Llama-3.3-70B-Instruct",
      "hf:meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
      "hf:meta-llama/Llama-4-Scout-17B-16E-Instruct",
      "hf:moonshotai/Kimi-K2-Instruct-0905",
      "hf:moonshotai/Kimi-K2-Thinking",
      "hf:moonshotai/Kimi-K2.5",
      "hf:moonshotai/Kimi-K2.6",
      "hf:nvidia/Kimi-K2.5-NVFP4",
      "hf:nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-NVFP4",
      "hf:openai/gpt-oss-120b",
      "hf:zai-org/GLM-4.6",
      "hf:zai-org/GLM-4.7",
      "hf:zai-org/GLM-4.7-Flash",
      "hf:zai-org/GLM-5",
      "hf:zai-org/GLM-5.1"
    ],
    "inceptron": [
      "MiniMaxAI/MiniMax-M2.5",
      "moonshotai/Kimi-K2.6",
      "nvidia/llama-3.3-70b-instruct-fp8",
      "zai-org/GLM-5.1-FP8"
    ],
    "minimax-coding-plan": [
      "MiniMax-M2",
      "MiniMax-M2.1",
      "MiniMax-M2.5",
      "MiniMax-M2.5-highspeed",
      "MiniMax-M2.7",
      "MiniMax-M2.7-highspeed"
    ],
    "upstage": ["solar-mini", "solar-pro2", "solar-pro3"],
    "vercel": [
      "alibaba/qwen-3-14b",
      "alibaba/qwen-3-235b",
      "alibaba/qwen-3-30b",
      "alibaba/qwen-3-32b",
      "alibaba/qwen-3.6-max-preview",
      "alibaba/qwen3-235b-a22b-thinking",
      "alibaba/qwen3-coder",
      "alibaba/qwen3-coder-30b-a3b",
      "alibaba/qwen3-coder-next",
      "alibaba/qwen3-coder-plus",
      "alibaba/qwen3-embedding-0.6b",
      "alibaba/qwen3-embedding-4b",
      "alibaba/qwen3-embedding-8b",
      "alibaba/qwen3-max",
      "alibaba/qwen3-max-preview",
      "alibaba/qwen3-max-thinking",
      "alibaba/qwen3-next-80b-a3b-instruct",
      "alibaba/qwen3-next-80b-a3b-thinking",
      "alibaba/qwen3-vl-235b-a22b-instruct",
      "alibaba/qwen3-vl-instruct",
      "alibaba/qwen3-vl-thinking",
      "alibaba/qwen3.5-flash",
      "alibaba/qwen3.5-plus",
      "alibaba/qwen3.6-27b",
      "alibaba/qwen3.6-plus",
      "alibaba/qwen3.7-max",
      "amazon/nova-2-lite",
      "amazon/nova-lite",
      "amazon/nova-micro",
      "amazon/nova-pro",
      "amazon/titan-embed-text-v2",
      "anthropic/claude-3-haiku",
      "anthropic/claude-3-opus",
      "anthropic/claude-3.5-haiku",
      "anthropic/claude-3.5-sonnet",
      "anthropic/claude-3.5-sonnet-20240620",
      "anthropic/claude-3.7-sonnet",
      "anthropic/claude-haiku-4.5",
      "anthropic/claude-opus-4",
      "anthropic/claude-opus-4.1",
      "anthropic/claude-opus-4.5",
      "anthropic/claude-opus-4.6",
      "anthropic/claude-opus-4.7",
      "anthropic/claude-sonnet-4",
      "anthropic/claude-sonnet-4.5",
      "anthropic/claude-sonnet-4.6",
      "arcee-ai/trinity-large-preview",
      "arcee-ai/trinity-large-thinking",
      "arcee-ai/trinity-mini",
      "bfl/flux-kontext-max",
      "bfl/flux-kontext-pro",
      "bfl/flux-pro-1.0-fill",
      "bfl/flux-pro-1.1",
      "bfl/flux-pro-1.1-ultra",
      "bytedance/seed-1.6",
      "bytedance/seed-1.8",
      "cohere/command-a",
      "cohere/embed-v4.0",
      "deepseek/deepseek-r1",
      "deepseek/deepseek-v3",
      "deepseek/deepseek-v3.1",
      "deepseek/deepseek-v3.1-terminus",
      "deepseek/deepseek-v3.2",
      "deepseek/deepseek-v3.2-exp",
      "deepseek/deepseek-v3.2-thinking",
      "deepseek/deepseek-v4-flash",
      "deepseek/deepseek-v4-pro",
      "google/gemini-2.0-flash",
      "google/gemini-2.0-flash-lite",
      "google/gemini-2.5-flash",
      "google/gemini-2.5-flash-image",
      "google/gemini-2.5-flash-image-preview",
      "google/gemini-2.5-flash-lite",
      "google/gemini-2.5-flash-lite-preview-09-2025",
      "google/gemini-2.5-flash-preview-09-2025",
      "google/gemini-2.5-pro",
      "google/gemini-3-flash",
      "google/gemini-3-pro-image",
      "google/gemini-3-pro-preview",
      "google/gemini-3.1-flash-image-preview",
      "google/gemini-3.1-flash-lite",
      "google/gemini-3.1-flash-lite-preview",
      "google/gemini-3.1-pro-preview",
      "google/gemini-3.5-flash",
      "google/gemini-embedding-001",
      "google/gemini-embedding-2",
      "google/gemma-4-26b-a4b-it",
      "google/gemma-4-31b-it",
      "google/imagen-4.0-fast-generate-001",
      "google/imagen-4.0-generate-001",
      "google/imagen-4.0-ultra-generate-001",
      "google/text-embedding-005",
      "google/text-multilingual-embedding-002",
      "inception/mercury-2",
      "inception/mercury-coder-small",
      "inception/mercury-edit-2",
      "interfaze/interfaze-beta",
      "kwaipilot/kat-coder-pro-v1",
      "kwaipilot/kat-coder-pro-v2",
      "meituan/longcat-flash-chat",
      "meituan/longcat-flash-thinking",
      "meituan/longcat-flash-thinking-2601",
      "meta/llama-3.1-70b",
      "meta/llama-3.1-8b",
      "meta/llama-3.2-11b",
      "meta/llama-3.2-1b",
      "meta/llama-3.2-3b",
      "meta/llama-3.2-90b",
      "meta/llama-3.3-70b",
      "meta/llama-4-maverick",
      "meta/llama-4-scout",
      "minimax/minimax-m2",
      "minimax/minimax-m2.1",
      "minimax/minimax-m2.1-lightning",
      "minimax/minimax-m2.5",
      "minimax/minimax-m2.5-highspeed",
      "minimax/minimax-m2.7",
      "minimax/minimax-m2.7-highspeed",
      "mistral/codestral",
      "mistral/codestral-embed",
      "mistral/devstral-2",
      "mistral/devstral-small",
      "mistral/devstral-small-2",
      "mistral/magistral-medium",
      "mistral/magistral-small",
      "mistral/ministral-14b",
      "mistral/ministral-3b",
      "mistral/ministral-8b",
      "mistral/mistral-embed",
      "mistral/mistral-large-3",
      "mistral/mistral-medium",
      "mistral/mistral-medium-3.5",
      "mistral/mistral-nemo",
      "mistral/mistral-small",
      "mistral/mixtral-8x22b-instruct",
      "mistral/pixtral-12b",
      "mistral/pixtral-large",
      "moonshotai/kimi-k2-0905",
      "moonshotai/kimi-k2-thinking",
      "moonshotai/kimi-k2-thinking-turbo",
      "moonshotai/kimi-k2-turbo",
      "moonshotai/kimi-k2.5",
      "moonshotai/kimi-k2.6",
      "morph/morph-v3-fast",
      "morph/morph-v3-large",
      "nvidia/nemotron-3-nano-30b-a3b",
      "nvidia/nemotron-3-super-120b-a12b",
      "nvidia/nemotron-nano-12b-v2-vl",
      "nvidia/nemotron-nano-9b-v2",
      "openai/codex-mini",
      "openai/gpt-3.5-turbo",
      "openai/gpt-3.5-turbo-instruct",
      "openai/gpt-4-turbo",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-mini",
      "openai/gpt-4o-mini-search-preview",
      "openai/gpt-5",
      "openai/gpt-5-chat",
      "openai/gpt-5-codex",
      "openai/gpt-5-mini",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.1-instant",
      "openai/gpt-5.1-thinking",
      "openai/gpt-5.2",
      "openai/gpt-5.2-chat",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.3-chat",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.5",
      "openai/gpt-5.5-pro",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-20b",
      "openai/gpt-oss-safeguard-20b",
      "openai/o1",
      "openai/o3",
      "openai/o3-deep-research",
      "openai/o3-mini",
      "openai/o3-pro",
      "openai/o4-mini",
      "openai/text-embedding-3-large",
      "openai/text-embedding-3-small",
      "openai/text-embedding-ada-002",
      "perplexity/sonar",
      "perplexity/sonar-pro",
      "perplexity/sonar-reasoning",
      "perplexity/sonar-reasoning-pro",
      "prime-intellect/intellect-3",
      "recraft/recraft-v2",
      "recraft/recraft-v3",
      "vercel/v0-1.0-md",
      "vercel/v0-1.5-md",
      "voyage/voyage-3-large",
      "voyage/voyage-3.5",
      "voyage/voyage-3.5-lite",
      "voyage/voyage-4",
      "voyage/voyage-4-large",
      "voyage/voyage-4-lite",
      "voyage/voyage-code-2",
      "voyage/voyage-code-3",
      "voyage/voyage-finance-2",
      "voyage/voyage-law-2",
      "xai/grok-4-fast-reasoning",
      "xai/grok-4.1-fast-non-reasoning",
      "xai/grok-4.1-fast-reasoning",
      "xai/grok-4.20-multi-agent",
      "xai/grok-4.20-multi-agent-beta",
      "xai/grok-4.20-non-reasoning",
      "xai/grok-4.20-non-reasoning-beta",
      "xai/grok-4.20-reasoning",
      "xai/grok-4.20-reasoning-beta",
      "xai/grok-4.3",
      "xai/grok-build-0.1",
      "xai/grok-imagine-image",
      "xai/grok-imagine-image-pro",
      "xiaomi/mimo-v2-flash",
      "xiaomi/mimo-v2-pro",
      "xiaomi/mimo-v2.5",
      "xiaomi/mimo-v2.5-pro",
      "zai/glm-4.5",
      "zai/glm-4.5-air",
      "zai/glm-4.5v",
      "zai/glm-4.6",
      "zai/glm-4.6v",
      "zai/glm-4.6v-flash",
      "zai/glm-4.7",
      "zai/glm-4.7-flash",
      "zai/glm-4.7-flashx",
      "zai/glm-5",
      "zai/glm-5-turbo",
      "zai/glm-5.1",
      "zai/glm-5v-turbo"
    ],
    "abliteration-ai": ["abliterated-model"],
    "deepseek": ["deepseek-chat", "deepseek-reasoner", "deepseek-v4-flash", "deepseek-v4-pro"],
    "perplexity": ["sonar", "sonar-deep-research", "sonar-pro", "sonar-reasoning-pro"],
    "iflowcn": [
      "deepseek-r1",
      "deepseek-v3",
      "deepseek-v3.2",
      "glm-4.6",
      "kimi-k2",
      "kimi-k2-0905",
      "qwen3-235b",
      "qwen3-235b-a22b-instruct",
      "qwen3-235b-a22b-thinking-2507",
      "qwen3-32b",
      "qwen3-coder-plus",
      "qwen3-max",
      "qwen3-max-preview",
      "qwen3-vl-plus"
    ],
    "stackit": [
      "Qwen/Qwen3-VL-235B-A22B-Instruct-FP8",
      "Qwen/Qwen3-VL-Embedding-8B",
      "cortecs/Llama-3.3-70B-Instruct-FP8-Dynamic",
      "google/gemma-3-27b-it",
      "intfloat/e5-mistral-7b-instruct",
      "neuralmagic/Meta-Llama-3.1-8B-Instruct-FP8",
      "neuralmagic/Mistral-Nemo-Instruct-2407-FP8",
      "openai/gpt-oss-120b"
    ],
    "wafer.ai": ["GLM-5.1", "Qwen3.5-397B-A17B"],
    "evroc": [
      "KBLab/kb-whisper-large",
      "Qwen/Qwen3-30B-A3B-Instruct-2507-FP8",
      "Qwen/Qwen3-Embedding-8B",
      "Qwen/Qwen3-VL-30B-A3B-Instruct",
      "intfloat/multilingual-e5-large-instruct",
      "microsoft/Phi-4-multimodal-instruct",
      "mistralai/Magistral-Small-2509",
      "mistralai/Voxtral-Small-24B-2507",
      "mistralai/devstral-small-2-24b-instruct-2512",
      "moonshotai/Kimi-K2.5",
      "nvidia/Llama-3.3-70B-Instruct-FP8",
      "openai/gpt-oss-120b",
      "openai/whisper-large-v3"
    ],
    "nova": ["nova-2-lite-v1", "nova-2-pro-v1"],
    "fireworks-ai": [
      "accounts/fireworks/models/deepseek-v3p1",
      "accounts/fireworks/models/deepseek-v3p2",
      "accounts/fireworks/models/deepseek-v4-flash",
      "accounts/fireworks/models/deepseek-v4-pro",
      "accounts/fireworks/models/glm-4p5",
      "accounts/fireworks/models/glm-4p5-air",
      "accounts/fireworks/models/glm-4p7",
      "accounts/fireworks/models/glm-5",
      "accounts/fireworks/models/glm-5p1",
      "accounts/fireworks/models/gpt-oss-120b",
      "accounts/fireworks/models/gpt-oss-20b",
      "accounts/fireworks/models/kimi-k2-instruct",
      "accounts/fireworks/models/kimi-k2-thinking",
      "accounts/fireworks/models/kimi-k2p5",
      "accounts/fireworks/models/kimi-k2p6",
      "accounts/fireworks/models/minimax-m2p1",
      "accounts/fireworks/models/minimax-m2p5",
      "accounts/fireworks/models/minimax-m2p7",
      "accounts/fireworks/models/qwen3p6-plus",
      "accounts/fireworks/routers/kimi-k2p5-turbo"
    ],
    "alibaba": [
      "qvq-max",
      "qwen-flash",
      "qwen-max",
      "qwen-mt-plus",
      "qwen-mt-turbo",
      "qwen-omni-turbo",
      "qwen-omni-turbo-realtime",
      "qwen-plus",
      "qwen-plus-character-ja",
      "qwen-turbo",
      "qwen-vl-max",
      "qwen-vl-ocr",
      "qwen-vl-plus",
      "qwen2-5-14b-instruct",
      "qwen2-5-32b-instruct",
      "qwen2-5-72b-instruct",
      "qwen2-5-7b-instruct",
      "qwen2-5-omni-7b",
      "qwen2-5-vl-72b-instruct",
      "qwen2-5-vl-7b-instruct",
      "qwen3-14b",
      "qwen3-235b-a22b",
      "qwen3-32b",
      "qwen3-8b",
      "qwen3-asr-flash",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-coder-flash",
      "qwen3-coder-plus",
      "qwen3-livetranslate-flash-realtime",
      "qwen3-max",
      "qwen3-next-80b-a3b-instruct",
      "qwen3-next-80b-a3b-thinking",
      "qwen3-omni-flash",
      "qwen3-omni-flash-realtime",
      "qwen3-vl-235b-a22b",
      "qwen3-vl-30b-a3b",
      "qwen3-vl-plus",
      "qwen3.5-122b-a10b",
      "qwen3.5-27b",
      "qwen3.5-35b-a3b",
      "qwen3.5-397b-a17b",
      "qwen3.5-plus",
      "qwen3.6-27b",
      "qwen3.6-35b-a3b",
      "qwen3.6-max-preview",
      "qwen3.6-plus",
      "qwen3.7-max",
      "qwq-plus"
    ],
    "302ai": [
      "MiniMax-M1",
      "MiniMax-M2",
      "MiniMax-M2.1",
      "MiniMax-M2.7",
      "MiniMax-M2.7-highspeed",
      "chatgpt-4o-latest",
      "claude-3-5-haiku-20241022",
      "claude-3-5-haiku-latest",
      "claude-haiku-4-5",
      "claude-haiku-4-5-20251001",
      "claude-opus-4-1-20250805",
      "claude-opus-4-1-20250805-thinking",
      "claude-opus-4-20250514",
      "claude-opus-4-5",
      "claude-opus-4-5-20251101",
      "claude-opus-4-5-20251101-thinking",
      "claude-opus-4-6",
      "claude-opus-4-6-thinking",
      "claude-opus-4-7",
      "claude-sonnet-4-20250514",
      "claude-sonnet-4-5",
      "claude-sonnet-4-5-20250929",
      "claude-sonnet-4-5-20250929-thinking",
      "claude-sonnet-4-6",
      "claude-sonnet-4-6-thinking",
      "deepseek-chat",
      "deepseek-reasoner",
      "deepseek-v3.2",
      "deepseek-v3.2-thinking",
      "doubao-seed-1-6-thinking-250715",
      "doubao-seed-1-6-vision-250815",
      "doubao-seed-1-8-251215",
      "doubao-seed-code-preview-251028",
      "gemini-2.0-flash-lite",
      "gemini-2.5-flash",
      "gemini-2.5-flash-image",
      "gemini-2.5-flash-lite-preview-09-2025",
      "gemini-2.5-flash-nothink",
      "gemini-2.5-flash-preview-09-2025",
      "gemini-2.5-pro",
      "gemini-3-flash-preview",
      "gemini-3-pro-image-preview",
      "gemini-3-pro-preview",
      "gemini-3.1-flash-image-preview",
      "glm-4.5",
      "glm-4.5-air",
      "glm-4.5-airx",
      "glm-4.5-x",
      "glm-4.5v",
      "glm-4.6",
      "glm-4.6v",
      "glm-4.7",
      "glm-4.7-flashx",
      "glm-5",
      "glm-5-turbo",
      "glm-5.1",
      "glm-5v-turbo",
      "glm-for-coding",
      "gpt-4.1",
      "gpt-4.1-mini",
      "gpt-4.1-nano",
      "gpt-4o",
      "gpt-5",
      "gpt-5-mini",
      "gpt-5-pro",
      "gpt-5-thinking",
      "gpt-5.1",
      "gpt-5.1-chat-latest",
      "gpt-5.2",
      "gpt-5.2-chat-latest",
      "gpt-5.4",
      "gpt-5.4-mini",
      "gpt-5.4-mini-2026-03-17",
      "gpt-5.4-nano",
      "gpt-5.4-nano-2026-03-17",
      "gpt-5.4-pro",
      "grok-4-1-fast-non-reasoning",
      "grok-4-1-fast-reasoning",
      "grok-4-fast-non-reasoning",
      "grok-4-fast-reasoning",
      "grok-4.1",
      "grok-4.20-beta-0309-non-reasoning",
      "grok-4.20-beta-0309-reasoning",
      "grok-4.20-multi-agent-beta-0309",
      "kimi-k2-0905-preview",
      "kimi-k2-thinking",
      "kimi-k2-thinking-turbo",
      "ministral-14b-2512",
      "mistral-large-2512",
      "qwen-flash",
      "qwen-max-latest",
      "qwen-plus",
      "qwen3-235b-a22b",
      "qwen3-235b-a22b-instruct-2507",
      "qwen3-30b-a3b",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-max-2025-09-23"
    ],
    "xpersona": ["xpersona-frieren-coder"],
    "stepfun": ["step-1-32k", "step-2-16k", "step-3.5-flash", "step-3.5-flash-2603"],
    "xai": [
      "grok-4.20-0309-non-reasoning",
      "grok-4.20-0309-reasoning",
      "grok-4.20-multi-agent-0309",
      "grok-4.3",
      "grok-build-0.1",
      "grok-imagine-image",
      "grok-imagine-image-quality",
      "grok-imagine-video"
    ],
    "sarvam": ["sarvam-105b", "sarvam-30b"],
    "zhipuai": [
      "glm-4.5",
      "glm-4.5-air",
      "glm-4.5-flash",
      "glm-4.5v",
      "glm-4.6",
      "glm-4.6v",
      "glm-4.7",
      "glm-4.7-flash",
      "glm-4.7-flashx",
      "glm-5",
      "glm-5.1",
      "glm-5v-turbo"
    ],
    "bailing": ["Ling-1T", "Ring-1T"],
    "qihang-ai": [
      "claude-haiku-4-5-20251001",
      "claude-opus-4-5-20251101",
      "claude-sonnet-4-5-20250929",
      "gemini-2.5-flash",
      "gemini-3-flash-preview",
      "gemini-3-pro-preview",
      "gpt-5-mini",
      "gpt-5.2",
      "gpt-5.2-codex"
    ],
    "lilac": ["google/gemma-4-31b-it", "minimaxai/minimax-m2.7", "moonshotai/kimi-k2.6", "zai-org/glm-5.1"],
    "alibaba-cn": [
      "MiniMax-M2.5",
      "MiniMax/MiniMax-M2.7",
      "deepseek-r1",
      "deepseek-r1-0528",
      "deepseek-r1-distill-llama-70b",
      "deepseek-r1-distill-llama-8b",
      "deepseek-r1-distill-qwen-1-5b",
      "deepseek-r1-distill-qwen-14b",
      "deepseek-r1-distill-qwen-32b",
      "deepseek-r1-distill-qwen-7b",
      "deepseek-v3",
      "deepseek-v3-1",
      "deepseek-v3-2-exp",
      "deepseek-v4-flash",
      "deepseek-v4-pro",
      "glm-5",
      "glm-5.1",
      "kimi-k2-thinking",
      "kimi-k2.5",
      "kimi-k2.6",
      "kimi/kimi-k2.5",
      "moonshot-kimi-k2-instruct",
      "qvq-max",
      "qwen-deep-research",
      "qwen-doc-turbo",
      "qwen-flash",
      "qwen-long",
      "qwen-math-plus",
      "qwen-math-turbo",
      "qwen-max",
      "qwen-mt-plus",
      "qwen-mt-turbo",
      "qwen-omni-turbo",
      "qwen-omni-turbo-realtime",
      "qwen-plus",
      "qwen-plus-character",
      "qwen-turbo",
      "qwen-vl-max",
      "qwen-vl-ocr",
      "qwen-vl-plus",
      "qwen2-5-14b-instruct",
      "qwen2-5-32b-instruct",
      "qwen2-5-72b-instruct",
      "qwen2-5-7b-instruct",
      "qwen2-5-coder-32b-instruct",
      "qwen2-5-coder-7b-instruct",
      "qwen2-5-math-72b-instruct",
      "qwen2-5-math-7b-instruct",
      "qwen2-5-omni-7b",
      "qwen2-5-vl-72b-instruct",
      "qwen2-5-vl-7b-instruct",
      "qwen3-14b",
      "qwen3-235b-a22b",
      "qwen3-32b",
      "qwen3-8b",
      "qwen3-asr-flash",
      "qwen3-coder-30b-a3b-instruct",
      "qwen3-coder-480b-a35b-instruct",
      "qwen3-coder-flash",
      "qwen3-coder-plus",
      "qwen3-max",
      "qwen3-next-80b-a3b-instruct",
      "qwen3-next-80b-a3b-thinking",
      "qwen3-omni-flash",
      "qwen3-omni-flash-realtime",
      "qwen3-vl-235b-a22b",
      "qwen3-vl-30b-a3b",
      "qwen3-vl-plus",
      "qwen3.5-397b-a17b",
      "qwen3.5-flash",
      "qwen3.5-plus",
      "qwen3.6-max-preview",
      "qwen3.6-plus",
      "qwq-32b",
      "qwq-plus",
      "siliconflow/deepseek-r1-0528",
      "siliconflow/deepseek-v3-0324",
      "siliconflow/deepseek-v3.1-terminus",
      "siliconflow/deepseek-v3.2",
      "tongyi-intent-detect-v3"
    ],
    "drun": ["public/deepseek-r1", "public/deepseek-v3", "public/minimax-m25"],
    "huggingface": [
      "MiniMaxAI/MiniMax-M2.1",
      "MiniMaxAI/MiniMax-M2.5",
      "MiniMaxAI/MiniMax-M2.7",
      "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "Qwen/Qwen3-Coder-Next",
      "Qwen/Qwen3-Embedding-4B",
      "Qwen/Qwen3-Embedding-8B",
      "Qwen/Qwen3-Next-80B-A3B-Instruct",
      "Qwen/Qwen3-Next-80B-A3B-Thinking",
      "Qwen/Qwen3.5-397B-A17B",
      "XiaomiMiMo/MiMo-V2-Flash",
      "deepseek-ai/DeepSeek-R1-0528",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/DeepSeek-V4-Pro",
      "moonshotai/Kimi-K2-Instruct",
      "moonshotai/Kimi-K2-Instruct-0905",
      "moonshotai/Kimi-K2-Thinking",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "zai-org/GLM-4.7",
      "zai-org/GLM-4.7-Flash",
      "zai-org/GLM-5",
      "zai-org/GLM-5.1"
    ],
    "umans-ai-coding-plan": ["umans-coder", "umans-flash", "umans-glm-5.1", "umans-kimi-k2.6", "umans-qwen3.6-35b-a3b"],
    "tencent-tokenhub": ["hy3-preview"],
    "nebius": [
      "MiniMaxAI/MiniMax-M2.5",
      "MiniMaxAI/MiniMax-M2.5-fast",
      "NousResearch/Hermes-4-405B",
      "NousResearch/Hermes-4-70B",
      "PrimeIntellect/INTELLECT-3",
      "Qwen/Qwen2.5-VL-72B-Instruct",
      "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "Qwen/Qwen3-235B-A22B-Thinking-2507-fast",
      "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "Qwen/Qwen3-32B",
      "Qwen/Qwen3-Embedding-8B",
      "Qwen/Qwen3-Next-80B-A3B-Thinking",
      "Qwen/Qwen3-Next-80B-A3B-Thinking-fast",
      "Qwen/Qwen3.5-397B-A17B",
      "Qwen/Qwen3.5-397B-A17B-fast",
      "deepseek-ai/DeepSeek-V3.2",
      "deepseek-ai/DeepSeek-V3.2-fast",
      "deepseek-ai/DeepSeek-V4-Pro",
      "google/gemma-2-2b-it",
      "google/gemma-3-27b-it",
      "meta-llama/Llama-3.3-70B-Instruct",
      "meta-llama/Meta-Llama-3.1-8B-Instruct",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.5-fast",
      "nvidia/Llama-3_1-Nemotron-Ultra-253B-v1",
      "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B",
      "nvidia/Nemotron-3-Nano-Omni",
      "nvidia/nemotron-3-super-120b-a12b",
      "openai/gpt-oss-120b",
      "openai/gpt-oss-120b-fast",
      "zai-org/GLM-5"
    ],
    "hpc-ai": ["minimax/minimax-m2.5", "moonshotai/kimi-k2.5", "zai-org/glm-5.1"],
    "xiaomi": ["mimo-v2-flash", "mimo-v2-omni", "mimo-v2-pro", "mimo-v2.5", "mimo-v2.5-pro"],
    "togetherai": [
      "MiniMaxAI/MiniMax-M2.5",
      "MiniMaxAI/MiniMax-M2.7",
      "Qwen/Qwen3-235B-A22B-Instruct-2507-tput",
      "Qwen/Qwen3-Coder-480B-A35B-Instruct-FP8",
      "Qwen/Qwen3-Coder-Next-FP8",
      "Qwen/Qwen3.5-397B-A17B",
      "Qwen/Qwen3.6-Plus",
      "deepseek-ai/DeepSeek-R1",
      "deepseek-ai/DeepSeek-V3",
      "deepseek-ai/DeepSeek-V3-1",
      "deepseek-ai/DeepSeek-V4-Pro",
      "essentialai/Rnj-1-Instruct",
      "google/gemma-4-31B-it",
      "meta-llama/Llama-3.3-70B-Instruct-Turbo",
      "moonshotai/Kimi-K2.5",
      "moonshotai/Kimi-K2.6",
      "openai/gpt-oss-120b",
      "zai-org/GLM-5.1"
    ],
    "stepfun-ai": ["step-3.5-flash", "step-3.5-flash-2603"],
    "inference": [
      "google/gemma-3",
      "meta/llama-3.1-8b-instruct",
      "meta/llama-3.2-11b-vision-instruct",
      "meta/llama-3.2-1b-instruct",
      "meta/llama-3.2-3b-instruct",
      "mistral/mistral-nemo-12b-instruct",
      "osmosis/osmosis-structure-0.6b",
      "qwen/qwen-2.5-7b-vision-instruct",
      "qwen/qwen3-embedding-4b"
    ],
    "netlify": [
      "anthropic/claude-haiku-4-5",
      "anthropic/claude-haiku-4-5-20251001",
      "anthropic/claude-opus-4-1-20250805",
      "anthropic/claude-opus-4-20250514",
      "anthropic/claude-opus-4-5",
      "anthropic/claude-opus-4-5-20251101",
      "anthropic/claude-opus-4-6",
      "anthropic/claude-opus-4-7",
      "anthropic/claude-sonnet-4-0",
      "anthropic/claude-sonnet-4-20250514",
      "anthropic/claude-sonnet-4-5",
      "anthropic/claude-sonnet-4-5-20250929",
      "anthropic/claude-sonnet-4-6",
      "gemini/gemini-2.0-flash",
      "gemini/gemini-2.0-flash-lite",
      "gemini/gemini-2.5-flash",
      "gemini/gemini-2.5-flash-image",
      "gemini/gemini-2.5-flash-lite",
      "gemini/gemini-2.5-pro",
      "gemini/gemini-3-flash-preview",
      "gemini/gemini-3-pro-image-preview",
      "gemini/gemini-3.1-flash-image-preview",
      "gemini/gemini-3.1-flash-lite",
      "gemini/gemini-3.1-flash-lite-preview",
      "gemini/gemini-3.1-pro-preview",
      "gemini/gemini-3.1-pro-preview-customtools",
      "gemini/gemini-3.5-flash",
      "gemini/gemini-flash-latest",
      "gemini/gemini-flash-lite-latest",
      "openai/chat-latest",
      "openai/gpt-4.1",
      "openai/gpt-4.1-mini",
      "openai/gpt-4.1-nano",
      "openai/gpt-4o",
      "openai/gpt-4o-mini",
      "openai/gpt-5",
      "openai/gpt-5-2025-08-07",
      "openai/gpt-5-codex",
      "openai/gpt-5-mini",
      "openai/gpt-5-mini-2025-08-07",
      "openai/gpt-5-nano",
      "openai/gpt-5-pro",
      "openai/gpt-5.1",
      "openai/gpt-5.1-2025-11-13",
      "openai/gpt-5.1-codex",
      "openai/gpt-5.1-codex-max",
      "openai/gpt-5.1-codex-mini",
      "openai/gpt-5.2",
      "openai/gpt-5.2-2025-12-11",
      "openai/gpt-5.2-codex",
      "openai/gpt-5.2-pro",
      "openai/gpt-5.2-pro-2025-12-11",
      "openai/gpt-5.3-chat-latest",
      "openai/gpt-5.3-codex",
      "openai/gpt-5.4",
      "openai/gpt-5.4-2026-03-05",
      "openai/gpt-5.4-mini",
      "openai/gpt-5.4-mini-2026-03-17",
      "openai/gpt-5.4-nano",
      "openai/gpt-5.4-nano-2026-03-17",
      "openai/gpt-5.4-pro",
      "openai/gpt-5.4-pro-2026-03-05",
      "openai/gpt-5.5",
      "openai/gpt-5.5-2026-04-23",
      "openai/gpt-5.5-pro",
      "openai/gpt-5.5-pro-2026-04-23",
      "openai/o3",
      "openai/o3-mini",
      "openai/o4-mini"
    ]
  },
  "version": "1.0.0"
}
